<div>
     @if(activeTab === 1){
   
    @if(plansTemplate === 'allPackagePlans') {
    <!-- ── allPackagetemplate: all plan tiles in one flat responsive grid, no package headers ── -->
    <div class="flex flex-wrap justify-center gap-[50px] plansscreen w-full">
      @for (package of mainarrayFinal; track package) {
        @for (group of package.groups; track group; let i = $index) {
          @for (plan of group.plans; track plan; let i = $index) {
            @for (product of plan.productAddonssNames; track product; let j = $index) {

      <div class="shadow-lg px-2 rounded-lg w-72 plan-tile"
        [hidden]="hideCompanyPaidPlans && group.categorization?.paidByCompany == 1"
        [style.background-color]="
          plan.isBundle == false
            ? plan?.productAddonss[product]?.[0]?.planlevel?.backgroundColor
            : group?.backgroundColor
        " style="width: min(375px, 100%); position: relative;">

        <div class="text-center text-white font-bold h-14 mt-1">
          @if(!hidePlanCategorization){
            @if(group.categorization.paidByCompany==1){
            <h6>{{lang.Company_Paid}}</h6>
            }
            @if(group.categorization.coveredByCompany==1){
            <h6>{{lang.Upgrade_To}}</h6>
            }
            @if(group.categorization.paidByEmployee==1){
            <h6>{{lang.Voluntary_Opt_In}}</h6>
            }
          }
          <h1 class="text-[16px] mt-2 truncate" style="padding-top: 10px;" title="{{product}}">
            {{product}}
          </h1>
        </div>

        <div class="p-2 pb-6">
          @if(plan.isBundle==true){
          <div class="overflow-y-scroll scrollbar-thin text-center bg-white" [ngClass]="currFormType === 'nhlaa' ? 'h-[283px]' : 'h-96'">
            @if(group.planLevelFeatures){
            @for(features of group.planLevelFeatures; track features){
            @if(features?.feature?.name!=null){
            <div class="accordion-header plancheck{{plan.isBundle?plan.id:0}}" [ngClass]="getFeatureClasses(features)"
              (click)="toggleItem1(features)"
              [style.background-color]="plan.isBundle==false ? plan?.productAddonss[product]?.[0]?.planlevel?.backgroundColor:group?.backgroundColor">
              {{ features?.feature?.name }}
              <span class="featureinfofaicon">
                @if(features.expanded){
                <svg class="w-5 h-5 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 14">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1" />
                </svg>
                }
                @else{
                <svg class="w-5 h-5 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 8">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1" />
                </svg>
                }
              </span>
            </div>
            <div *ngIf="features.expanded" class="accordion-content">
              <p [innerHTML]="features.description | safeHtml"></p>
            </div>
            }
            @else{
            <p class="text-left" style="padding:5px" [innerHTML]="features.description | safeHtml"></p>
            }
            }
            } @else {
            }
          </div>
          } @else{
          <div class="overflow-y-scroll scrollbar-thin text-center bg-white" [ngClass]="currFormType === 'nhlaa' ? 'h-[283px]' : 'h-96'">
            @if(plan?.productAddonss[product]?.[0]?.planlevel?.planLevelFeatures){
            @for (features of plan.productAddonss[product]?.[0]?.planlevel?.planLevelFeatures; track features){
            <div class="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][0].planlevel.id}}" [ngClass]="getFeatureClasses(features)">
              <strong>{{ features?.feature?.name }}</strong><br />
              <p class="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][0].planlevel.id}}" [innerHTML]="features.description | safeHtml"></p>
            </div>
            }
            } @else {@if(plan?.productAddonss[product]?.[0]?.description2 != undefined) {
            <p class="text-left" [innerHTML]="plan?.productAddonss[product]?.[0]?.description2 | safeHtml"></p>
            }}
          </div>
          } @for(coverage of plan.productAddonss[product]; track coverage;let k=$index){
          @if(plan.insuranceType!="LIFE"){
          <div class="flex items-center justify-between text-white text-[16px] w-full" *ngIf="coverage?.display??false">
            <div class="" style="display: flex; align-items: flex-start; gap: 0.5rem;">
              <input type="checkbox" #planCheckdetails
                id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id}}"
                class="plancheckbox{{ package.id }} plancv newPlan{{plan.id}} {{group.categorization.paidByCompany==1?'cp_plan':group.categorization.coveredByCompany==1?'cc_plan':'ep_plan'}} coverage{{coverage.planCoverageUI | uppercase}}"
                attr.data="{{ package.name }}##{{ group.name }}##{{ plan.planCoverage }}##{{plan.productAddonss[product][k].calculatedTax.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{ plan.frqMonthly }}##{{ package.optIn }}##{{ group.disallowedPlanLevels }}##{{ group.parentId }}##{{ group.id }}##{{ plan.name }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{plan.products && plan.products[k]?.upgradeCalculation?true:false}}"
                (change)="onCheckboxChange($event, package.allowMultiple, plan.productAddonss[product][k].plan_level.disallowedPlanLevels, plan.planOptions, group.parentId, package.name, group.name, plan.planCoverage, 0, 0, 0, 0, $event, i, j, k, plan, plan.productAddonss[product][k], package, group, coverage, plan.productAddonss[product].length, group?.categorization?.coveredByCompany == 1 ? 'upgrade' : 'core-voluntary')">

                @if(group.signupFormOverrides && group.signupFormOverrides['coverages']?.[coverage.planCoverageUI?.toUpperCase()]){
                  {{group.signupFormOverrides['coverages'][coverage.planCoverageUI?.toUpperCase()]}}
                }@else{
                  {{ coverage.planCoverageUI }}
                }
            </div>
            <div class="text-[14px] whitespace-nowrap ml-2">
              @if(group.categorization.paidByCompany==1){
                @if(plan.products && plan.products[k]?.upgradeCalculation){
                  <span>{{ currencySymbol }}{{ plan.products[k].upgradeCalculation.deltaplanPrice | number:"1.2-2" }}<small>*</small></span>
                } @else if(!plan.products?.[k] && plan.upgradeCalculation){
                  <span>{{ currencySymbol }}{{ plan.upgradeCalculation.deltaplanPrice | number:"1.2-2" }}<small>*</small></span>
                } @else {
                  <span>{{ currencySymbol }}0.00<small>*</small></span>
                }
              }
              @if(group.categorization.coveredByCompany==1){
                <span>{{ currencySymbol }} {{ getCoveredByCompanyDeltaPrice(plan, group, getIndexByType(coverage?.planCoverage, k, plan.productAddonss[product]?.length, plan)) | number: "1.2-2" }}<small>*</small></span>
              }
              @if(group.categorization.paidByEmployee==1){
                <span>{{ currencySymbol }}{{ coverage.price | number: "1.2-2" }}<small>*</small></span>
              }
            </div>
          </div>
          }
          @if(plan.insuranceType=="LIFE"){
          <app-life-insurance-tile
            [plan]="plan" [product]="product" [k]="k" [coverage]="coverage"
            [pkg]="package" [group]="group" [allFormData]="allFormData"
            [lang]="lang" [userForm]="userForm"
            (checkboxChangePEvent)="onCheckboxChangeP($event.event, $event.planCoverage, $event.category, $event.key1, $event.productAddon, undefined, undefined, $event.allState)"
            (radioChangeEvent)="handleRadioChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.coverageData)"
            (rangeChangeEvent)="handleRangeChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.rangeEvent, $event.coverageData)"
            (radioChangeV2Event)="handleAllStateSmokerChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.coverageData)"
            (rangeChangeV2Event)="handleRangeChangeForAllState($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.rangeEvent, $event.coverageData)"
            [possibleCoverage]="possibleCoverage">
          </app-life-insurance-tile>
          }
          }
           <!-- @if(!hidePlanCategorization){ -->
             <p class="text-white text-base" style="position: absolute; bottom: 6px; right: 8px; font-size: 11px;">*{{ lang.Monthly_applicable_taxes_extra || 'Monthly applicable taxes extra' }}</p>
            <!-- } -->
        </div>
      </div>

            }
          }
        }
      }
    </div>
    } @else {

    @for (package of mainarrayFinal; track package) {
    <!-- *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups)" -->
    <div class="text-black text-center text-[18px] font-bold mt-4 mb-4"
      *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups)">
      {{ package.name }}
    </div>

    <div class="flex flex-wrap justify-center gap-4 plansscreen w-full">
      <!--  @for (package of mainarrayFinal; track package) {  -->
      @for (group of package.groups; track group;let i = $index)
      {
      @for (plan of group.plans; track plan;let i=$index)
      {
      @for (product of plan.productAddonssNames;track product;let j=$index) {

      <div class="shadow-lg px-2 rounded-lg w-72 plan-tile"
        [hidden]="hideCompanyPaidPlans && group.categorization?.paidByCompany == 1"
        [style.background-color]="
          plan.isBundle == false
            ? plan?.productAddonss[product]?.[0]?.planlevel?.backgroundColor
            : group?.backgroundColor
        " style="position: relative;">

        <div class="text-center text-white font-bold h-14 mt-1">

          @if(!hidePlanCategorization){
            @if(group.categorization.paidByCompany==1){
            <h6>{{lang.Company_Paid}}</h6>
            }
            @if(group.categorization.coveredByCompany==1){
            <h6>{{lang.Upgrade_To}}</h6>
            }
            @if(group.categorization.paidByEmployee==1){
            <h6>{{lang.Voluntary_Opt_In}}</h6>
            }
          }
          <!-- <h1 class="text-[16px] mt-4" title="{{product}}">
            {{product.length>30? product.slice(0,30)+"...":product}}

          </h1> -->

          <h1 class="text-[16px] mt-2 truncate" style="padding-top: 10px;" title="{{product}}">
            {{product}}
          </h1>

        </div>


        <div class="p-2 pb-6">
          @if(plan.isBundle==true){
          <!-- <div class="h-48 overflow-y-scroll scrollbar-thin text-center bg-white my-8"> -->
          <div class="overflow-y-scroll scrollbar-thin text-center bg-white" [ngClass]="currFormType === 'nhlaa' ? 'h-[283px]' : 'h-96'">
            @if(group.planLevelFeatures){
            @for(features of
            group.planLevelFeatures; track features){

            @if(features?.feature?.name!=null){
            <div class="accordion-header plancheck{{plan.isBundle?plan.id:0}}" [ngClass]="getFeatureClasses(features)"
              (click)="toggleItem1(features)"
              [style.background-color]="
              plan.isBundle==false ? plan?.productAddonss[product]?.[0]?.planlevel?.backgroundColor:group?.backgroundColor">
              {{ features?.feature?.name }}
              <!-- @if(features.feature.name==null){
                  {{ features.feature.category }}
                }@else{
                  {{ features.feature.name }}
                } -->
              <span class="featureinfofaicon">

                @if(features.expanded){
                <svg class="w-5 h-5 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="none" viewBox="0 0 8 14">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1" />
                </svg>
                }
                @else{
                <svg class="w-5 h-5 text-white dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="none" viewBox="0 0 14 8">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1" />
                </svg>
                }
                <!-- <i *ngIf="features.expanded; else downarrowIcon1" class="fa fa-angle-right featureinfofaicon" aria-hidden="true"></i>
                  <ng-template #downarrowIcon1>
                    <i class="fa fa-angle-down featureinfofaicon" aria-hidden="true"></i>
                  </ng-template> -->
              </span>
            </div>
            <div *ngIf="features.expanded" class="accordion-content">
              <p [innerHTML]="features.description | safeHtml"></p>

            </div>
            }
            @else{
            <p class="text-left" style="padding:5px" [innerHTML]="features.description | safeHtml"></p>

            }
            }
            } @else {
            <!-- <p [innerHTML]="plan.productAddonss[product][0].description2"></p> -->
            }
          </div>

          } @else{
          <div class="overflow-y-scroll scrollbar-thin text-center bg-white" [ngClass]="currFormType === 'nhlaa' ? 'h-[283px]' : 'h-96'">
            @if(plan?.productAddonss[product]?.[0]?.planlevel?.planLevelFeatures){
            @for (features of
            plan.productAddonss[product]?.[0]?.planlevel?.planLevelFeatures; track
            features){
            <div class="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][0].planlevel.id}}"
              [ngClass]="getFeatureClasses(features)">
              <strong>{{ features?.feature?.name }}</strong><br />

              <p class="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][0].planlevel.id}}"
                [innerHTML]="features.description | safeHtml"></p>
            </div>
            }
            } @else {@if(plan?.productAddonss[product]?.[0]?.description2 != undefined) {
            <p class="text-left" [innerHTML]="plan?.productAddonss[product]?.[0]?.description2 | safeHtml"></p>
            }}
          </div>

          } @for(coverage of plan.productAddonss[product]; track coverage;let k=$index){
          @if(plan.insuranceType!="LIFE"){
          <div class="flex items-center justify-between text-white text-[16px] w-full" *ngIf="coverage?.display??false">
            <div class="" style="display: flex; align-items: flex-start; gap: 0.5rem;">
              <input type="checkbox" #planCheckdetails
                id="plancheck{{plan.isBundle?plan.id:plan.productAddonss[product][k].planlevel.id }}"
                class="plancheckbox{{ package.id }} plancv newPlan{{plan.id}} {{group.categorization.paidByCompany==1?'cp_plan':group.categorization.coveredByCompany==1?'cc_plan':'ep_plan'}} coverage{{coverage.planCoverageUI | uppercase}}"
                attr.data="{{ package.name }}##{{ group.name }}##{{
     plan.planCoverage
   }}##{{plan.productAddonss[product][k].calculatedTax.price}}##0##0##0##{{ plan.id }}##{{ plan.fusebillId }}##{{
     plan.frqMonthly
   }}##{{ package.optIn }}##{{
     group.disallowedPlanLevels
   }}##{{ group.parentId }}##{{ group.id }}##{{
     plan.name
   }}##{{ plan.planLevel }}##{{ plan.packageId }}##0##{{plan.planOptions}}##{{plan.productAddonss[product][k].id}}##{{plan.productAddonss[product][k].plan_level.id}}##{{plan.isBundle}}##{{plan.products && plan.products[k]?.upgradeCalculation?true:false}}"
                (change)="
     onCheckboxChange(
       $event,
       package.allowMultiple,
       plan.productAddonss[product][k].plan_level.disallowedPlanLevels,
       plan.planOptions,
       group.parentId,
       package.name,
       group.name,
       plan.planCoverage,
       0,
       0,
       0,
       0,
       $event,
       i,
       j,
       k,
       plan,
       plan.productAddonss[product][k],package,group,
       coverage,
       plan.productAddonss[product].length,
       group?.categorization?.coveredByCompany == 1 ? 'upgrade' : 'core-voluntary'
     )
  ">
             @if(!coveragesOverride){
                  {{ coverage.planCoverageUI }}
                }@else if(signupFormOverrides && signupFormOverrides['coverages'][coverage.planCoverageUI?.toUpperCase()]){
                  {{signupFormOverrides['coverages'][coverage.planCoverageUI?.toUpperCase()]}}
                }@else{
                  {{ coverage.planCoverageUI }}
                }
            </div>
            <div class="text-[14px] whitespace-nowrap ml-2">
              @if(group.categorization.paidByCompany==1){
                @if(plan.products && plan.products[k]?.upgradeCalculation){
                  <span>{{ currencySymbol }}{{ plan.products[k].upgradeCalculation.deltaplanPrice | number:"1.2-2" }}<small>*</small></span>
                } @else if(!plan.products?.[k] && plan.upgradeCalculation){
                  <span>{{ currencySymbol }}{{ plan.upgradeCalculation.deltaplanPrice | number:"1.2-2" }}<small>*</small></span>
                } @else {
                  <span>{{ currencySymbol }}0.00<small>*</small></span>
                }
              }
              @if(group.categorization.coveredByCompany==1){
                <span>{{ currencySymbol }} {{ getCoveredByCompanyDeltaPrice(plan, group, getIndexByType(coverage?.planCoverage, k, plan.productAddonss[product]?.length, plan)) | number: "1.2-2" }}<small>*</small></span>
              }
              @if(group.categorization.paidByEmployee==1){
                <span>{{ currencySymbol }}{{ coverage.price | number: "1.2-2" }}<small>*</small></span>
              }
            </div>
          </div>
          }



           @if(plan.insuranceType=="LIFE"){

                <!-- <app-allstate-ci-tile
                  [plan]="plan" [product]="product" [k]="k"
                  [pkg]="package" [group]="group"
                  [allFormData]="allFormData" [lang]="lang" [userForm]="userForm"
                  (checkboxChangePEvent)="onCheckboxChangeP($event.event, $event.planCoverage, $event.category, $event.key1, $event.productAddon)"
                  (radioChangeEvent)="handleRadioChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.coverageData)"
                  (rangeChangeEvent)="handleRangeChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.rangeEvent, $event.coverageData)">
                </app-allstate-ci-tile> -->
              <app-life-insurance-tile
                [plan]="plan"
                [product]="product"
                [k]="k"
                [coverage]="coverage"
                [pkg]="package"
                [group]="group"
                [allFormData]="allFormData"
                [lang]="lang"
                [userForm]="userForm"
                (checkboxChangePEvent)="onCheckboxChangeP($event.event, $event.planCoverage, $event.category, $event.key1, $event.productAddon, undefined, undefined, $event.allState)"
                (radioChangeEvent)="handleRadioChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.coverageData)"
                (rangeChangeEvent)="handleRangeChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.rangeEvent, $event.coverageData)"
                (radioChangeV2Event)="handleAllStateSmokerChange($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.coverageData)"
                (rangeChangeV2Event)="handleRangeChangeForAllState($event.event, $event.planCoverage, $event.category, $event.planOptions, $event.planObj, $event.productAddon, $event.pkgObj, $event.groupObj, $event.rangeEvent, $event.coverageData)"
                [possibleCoverage]="possibleCoverage"
              ></app-life-insurance-tile>
              }

       
          }
          <!-- <h3 class="font-bold text-xl mb-2">Card Title 1</h3> -->
          <!-- @if(!hidePlanCategorization){ -->
          <p class="text-white text-base" style="position: absolute; bottom: 6px; right: 8px; font-size: 11px;">
            *{{ lang.Monthly_applicable_taxes_extra || 'Monthly applicable taxes extra' }}
          </p>
          <!-- } -->
        </div>
      </div>
      }
      }
      <!-- <img src="https://via.placeholder.com/400" alt="Card Image" class="w-full h-48 object-cover"> -->

      }
    </div>
    }

    } <!-- /@else (default layout) -->


    <div class="relative">

      <!-- Left Button -->
      <button
        class="fixed text-center inline-flex items-center left-3 sm:left-16 lg:left-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
        (click)="gotoPersonalInfoPage()" style="width:120px;">
        <svg class="h-9 w-9 me-2 text-indigo-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        {{ lang.Previous }}
      </button>

      <!-- Right Button -->
      <button [disabled]="cartcheckvalue || disableNext"
        class="fixed text-center inline-flex items-center right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
        (click)="paymentpage(1)">
        {{ lang.Next }}&nbsp;&nbsp;
        <svg class="h-9 w-9 text-indigo-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>


      <!-- <button
            type="submit"
            class="w-36 h-14 mb-1 rounded-full border-2 text-center inline-flex items-center border-indigo-700 bg-gray-200 p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white px-5 py-2.5 me-2"
          >{{ lang.next }}&nbsp;&nbsp;
          <svg class="h-10 w-10 me-2 text-sky-900"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>


          </button> -->
    </div>
    <!-- </div> -->

    }
  

  <!-- not using -->
  @if(activeTab === 2 && currFormType != 'nhlaa' && false){


    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3 mx-2">
      <!-- First column -->


      <!-- First column -->

      <!-- Second column -->
      <div class="col-span-full bg-white text-black">
        <!-- <div class="form-row" *ngIf="!singleSummaryTable && (companySelectedPlans.length == 0 ? false : true)"> -->

        @if(!singleSummaryTable && (companySelectedPlans.length == 0 ? false : true)){
        <div class="col-span-full">
          <!-- <label for="cardnumnber"><strong>{{lang.core_plans_premium_paid_100%_by_employer}}</strong></label> -->
          <label for="cardnumnber"><strong>{{lang.Core_Plans_Premium_paid_100_by_employer}}</strong></label>



          <div class="overflow-x-auto">
            <table class="table table-bordered text-black" id="customerPlansTable">
              <tbody>
                <tr>
                  <!-- <th>S. no</th> -->
                  <th>{{lang.Plan}}</th>
                  <!-- <th>Company Share</th>
                          <th>Employee Share</th> -->
                  <th class="taxamount">{{lang.Amount}}({{lang.Company}})</th>
                  <!-- <td>Plan</td> -->
                  <th class="taxamount">{{lang.Tax}}</th>
                  <th class="taxamount">{{lang.Total}}</th>
                </tr>
                <tr *ngFor="
                            let item of companySelectedPlans;
                            let i = index
                          ">
                  <!-- <td>{{i+1}}</td> -->
                  <!-- {{item.groupName | lowercase}}- -->

                  <td>{{ item.planname }}<br />({{ item.packagename }})</td>
                  <!-- <td>{{item.companyAmountUI}}</td>
                          <td>{{item.employeeAmountUI}}</td> -->
                  <td class="taxamount">
                    {{ currencySymbol }}{{ item.planPrice | number: "1.2-2" }}
                  </td>
                  <!-- <td>{{item.planCoverage}}</td> -->
                  <td class="taxamount">
                    <span *ngIf="item.gstCheck" class="gsttaxes">{{ item.gstPrice == 0 ? "-" : currencySymbol +
                      (item.gstPrice |
                      number: "1.2-2") + "&nbsp;(GST)" }}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{
                      item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                      number: "1.2-2") + "&nbsp;(PST)" }}</span><span *ngIf="item.hstCheck" class="gsttaxes">{{
                      item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                      number: "1.2-2") + "&nbsp;(HST)" }}</span><span *ngIf="
                                !item.gstCheck &&
                                !item.pstCheck &&
                                !item.hstCheck
                              ">-</span>
                  </td>
                  <td class="grandTotal">
                    {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                  </td>
                </tr>

                <tr>
                  <td>{{lang.Total}}</td>
                  <td colspan="2"></td>
                  <td class="grandTotal">
                    <b>{{ currencySymbol
                      }}{{ companyPaidTotal}}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        }

        <br />

        <!-- no use -->
        <div class="form-row" *ngIf="!singleSummaryTable && (companyCoveredPlans.length == 0 ? false : true)"
          class="form-row">
          <div class="form-group col-md-12">
            <label
              for="cardnumnber"><strong>{{lang.upgrade_plans_premium_difference_payroll_deduction}}34</strong></label>

            <div class="overflow-x-auto">
              <table class="table table-bordered text-black" id="customerPlansTable">
                <tbody>
                  <tr>
                    <!-- <th>S. no</th> -->
                    <th>{{lang.plan}}</th>
                    <!-- <th>Company Share</th>
                        <th>Employee Share</th> -->
                    <th class="taxamount">{{lang.amount}}<br>({{lang.company}}+{{lang.employee}})</th>
                    <!-- <td>Plan</td> -->
                    <th class="taxamount">{{lang.tax}}</th>
                    <th class="taxamount">{{lang.total}}</th>
                  </tr>
                  <ng-container *ngFor="
                      let item of companyCoveredPlans;
                      let i = index
                    ">
                    <tr class="main-details-ccplan-tr">

                      <td>{{i+1}}. {{ item.planname }} <br>({{ item.packagename }}) </td>
                      <td class="taxamount">
                        {{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                        }}
                      </td>
                      <td class="taxamount">
                        <span *ngIf="item.gstCheck" class="gsttaxes">{{ item.gstPrice == 0 ? "-" : currencySymbol +
                          (item.gstPrice |
                          number: "1.2-2") + "&nbsp;(GST)" }}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{
                          item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                          number: "1.2-2") + "&nbsp;(PST)" }}</span><span *ngIf="item.hstCheck" class="gsttaxes">{{
                          item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                          number: "1.2-2") + "&nbsp;(HST)" }}</span><span *ngIf="
                          !item.gstCheck &&
                          !item.pstCheck &&
                          !item.hstCheck
                        ">-</span>
                      </td>
                      <td class="grandTotal">
                        {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                      </td>
                    </tr>
                    <tr class="additional-details-ccplan-tr">
                      <!-- <td></td> -->
                      <td>Base Plan paid by company <br> {{item.companyCoveredBasePlan.planName}}</td>
                      <td>
                        Company share from base plan - <i
                          [innerHTML]="item.companyCoveredBasePlan.amount | number: '1.2-2'"></i>
                        <br> Employee share deducted from salary- <i
                          [innerHTML]="item.employeeDeductions.amount | number: '1.2-2'"></i>
                      </td>
                      <td>
                        Company share from base plan -
                        <!-- <i [innerHTML]="item.companyCoveredBasePlan.taxUI"></i>  -->
                        [{{item.companyCoveredBasePlan.tax}}]
                        <br> Employee share deducted from salary-
                        <!-- <i [innerHTML]="item.employeeDeductions.taxUI"></i> -->
                        [{{item.employeeDeductions.tax}}]
                      </td>
                      <td> Company share from base plan - <i
                          [innerHTML]="item.companyCoveredBasePlan.total | number: '1.2-2'"></i>
                        <br> Employee share deducted from salary- <i
                          [innerHTML]="item.employeeDeductions.total | number: '1.2-2'"></i>
                    </tr>
                  </ng-container>


                  <tr>
                    <td>{{lang.Total}}(All plans)</td>

                    <td class="grandTotal" colspan="3">
                      <b> {{ currencySymbol
                        }}{{ companyCoveredTotal | number: '1.2-2'}}</b>
                      <br />--------------------
                      <p>
                        <br> Company share from all base plans - {{ currencySymbol
                        }}{{companyCoveredCompanyShareTotal | number: '1.2-2'}}
                        <br> Employee share from all plans deducted from salary- {{ currencySymbol
                        }}{{companyCoveredEmployeeShareTotal | number: '1.2-2'}}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <br />
        <!-- no use -->
        @if(!singleSummaryTable && (EmployeeSelectedPlans.length == 0 ? false : true)){
        <div class="col-span-full">
          <label for="cardnumnber"><strong>{{lang.voluntary_plans__premium_paid_employee}}56</strong></label>

          <div class="overflow-x-auto">
            <table class="table table-bordered text-black" id="customerPlansTable">
              <tbody>
                <tr>
                  <!-- <th>S. no</th> -->
                  <th>{{lang.plan}}</th>
                  <!-- <th>Company Share</th>
                      <th>Employee Share</th> -->
                  <th class="taxamount">{{lang.amount}}(Employee)</th>
                  <!-- <td>Plan</td> -->
                  <th class="taxamount">{{lang.tax}}</th>
                  <th class="taxamount">{{lang.total}}</th>
                </tr>
                <tr *ngFor="
                        let item of EmployeeSelectedPlans;
                        let i = index
                      ">
                  <!-- <td>{{i+1}}</td> -->
                  <!-- {{item.groupName | lowercase}}- -->

                  <td>{{ item.planname }}<br />({{ item.packagename }})</td>
                  <!-- <td>{{item.companyAmountUI}}</td>
                      <td>{{item.employeeAmountUI}}</td> -->
                  <td class="taxamount">
                    {{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                    }}
                  </td>
                  <!-- <td>{{item.planCoverage}}</td> -->
                  <td class="taxamount">
                    <span *ngIf="item.gstCheck" class="gsttaxes">{{ item.gstPrice == 0 ? "-" : currencySymbol +
                      (item.gstPrice |
                      number: "1.2-2") + "&nbsp;(GST)" }}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{
                      item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                      number: "1.2-2") + "&nbsp;(PST)" }}</span><span *ngIf="item.hstCheck" class="gsttaxes">{{
                      item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                      number: "1.2-2") + "&nbsp;(HST)" }}</span><span *ngIf="
                            !item.gstCheck &&
                            !item.pstCheck &&
                            !item.hstCheck
                          ">-</span>
                  </td>
                  <td class="grandTotal">
                    {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                  </td>
                </tr>

                <tr>
                  <td>{{lang.Total}}</td>
                  <td colspan="2"></td>
                  <td class="grandTotal">
                    <b> {{ currencySymbol
                      }}{{ paidEmployeedTotal | number: "1.2-2" }}</b>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>

        }

        @if(singleSummaryTable && allSelectedPlans.length == 0 ? false : true){
        <div class="cols-span-full">
          <label for="cardnumnber"><strong>{{lang.All_selected_plans_summary}}</strong></label>

          <div class="overflow-x-auto">
            <table class="table table-bordered text-black" id="customerPlansTable">
              <tbody>
                <tr>
                  <!-- <th>S. no</th> -->
                  <th>{{lang.Plan}}</th>
                  <!-- <th>Company Share</th>
                          <th>Employee Share</th> -->
                  <th>{{lang.Type}}</th>
                  <th *ngIf="isMedcanPopUpSubmitted">{{lang.Units}}</th>
                  <th class="taxamount align-right">{{lang.Premium}}<br /> <span *ngIf="isMedcanPopUpSubmitted"
                      style="font-size: 10px;">(Per
                      unit)</span></th>
                  <!-- <td>Plan</td> -->
                  <!-- <th class="taxamount">Tax Percentage</th> -->

                  <th class="taxamount align-right">{{lang.Tax}}<br /> <span *ngIf="isMedcanPopUpSubmitted"
                      style="font-size: 10px;">(Per unit)</span>
                  </th>
                  <th class="taxamount align-right">{{lang.Total}}</th>
                </tr>
                <tr *ngFor="
                            let item of allSelectedPlans;
                            let i = index
                          "
                  [hidden]="(item.paidByCompany && currFormType === 'nhlaa') || hasUpgradePlans">
                    
                  <!-- <td>{{i+1}}</td> -->
                  <!-- {{item.groupName | lowercase}}- -->
                  <td *ngIf="item.isBundle==true;else productname">

                    <!-- ({{ item.packagename }}) -  -->
                    <span *ngIf="item.coveredByCompany==1;else noupgrade">{{ item.upgradeCalculation.planName }}</span>
                    <ng-template #noupgrade>{{item.planname}}</ng-template>

                  </td>

                  <ng-template #productname>
                    <td>
                      <!-- ({{ item.packagename }}) -  -->
                      <span *ngIf="item.coveredByCompany==1;else noupgrade1">{{ item.upgradeCalculation.planName
                        }}</span>
                      <ng-template #noupgrade1>{{item.planproductname}}</ng-template>
                    </td>
                  </ng-template>

                  <!-- <td>{{item.companyAmountUI}}</td>
                          <td>{{item.employeeAmountUI}}</td> -->
                  <td *ngIf="currFormType!='nhlaa'">{{item.type}}</td>
                  <td *ngIf="currFormType=='nhlaa'">Plan Upgrade</td>
                  <td *ngIf="isMedcanPopUpSubmitted">
                    <span
                      *ngIf="item.planLevel==15 && item.multiCountPlan==true;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                    <ng-template #defaultSubmitCheck>-</ng-template>
                  </td>
                  <td class="grandTotal amounts" *ngIf="employercheck">

                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">

                    <span *ngIf="item.coveredByCompany==1;else noupgradeprice">{{ currencySymbol }}{{
                      item.upgradeCalculation.combinedplanPrice | number: "1.2-2"}}</span>
                    <ng-template #noupgradeprice>{{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                      }}</ng-template>

                  </td>
                  <!-- <td>{{item.planCoverage}}</td> -->
                  <!-- <td>taxRateperecnatge&&taxtype</td> -->
                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="item.coveredByCompany==1;else noupgradetax">{{ currencySymbol }}{{
                      item.upgradeCalculation.combinedplanTax | number: "1.2-2"}}</span>
                    <ng-template #noupgradetax>{{ currencySymbol }}{{item.tax | number: "1.2-2"}}</ng-template>

                  </td>

                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="item.coveredByCompany==1;else noupgradetotal">{{ currencySymbol }}
                      {{
                      item.upgradeCalculation.combinedplanTotal
                      | number: "1.2-2"
                      }}
                    </span>
                    <ng-template #noupgradetotal>{{ currencySymbol }}
                      {{
                      item.totalPrice
                      | number: "1.2-2"
                      }}
                    </ng-template>

                  </td>
                </tr>

                <tr style="background-color: #D08000 ;" [hidden]="hasUpgradePlans">
                  <td>{{lang.Total}}</td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td class="grandTotal amounts" *ngIf="employercheck">---</td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">{{ currencySymbol}}{{
                    allPlansAmountTotal |
                    number: "1.2-2" }}</td>
                  <td class="grandTotal amounts" *ngIf="employercheck">---</td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">{{ currencySymbol
                    }}{{allPlansTotaltax | number: "1.2-2"}}</td>
                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <b>{{ currencySymbol
                      }}{{ allPlansTotal | number: "1.2-2" }}</b>
                  </td>
                </tr>


                <tr>
                  <td>
                  <td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>


                @if(!hidePlanCategorization){



                <tr style="background-color: black">
                  <td style="color:white">{{lang.Monthly_Payment_Summary}}
                  <td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                <tr *ngIf="companyDealingPlans.length == 0 ? false : true">
                  <td><b>{{lang.Company_Pays}}</b>
                  <td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr *ngFor="let companypay of companyDealingPlans">

                  <td>
                    <span
                      *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.compnayShareStatement}}</span>
                    <ng-template #normalname>
                      {{companypay.planname}}
                    </ng-template>

                  </td>
                  <td *ngIf="isdandjform">{{lang.Company_Pays}}</td>
                  <td *ngIf="!isdandjform">{{companypay.type}}</td>
                  <td *ngIf="isMedcanPopUpSubmitted">
                    <span
                      *ngIf="companypay.planLevel==15 && companypay.multiCountPlan==true;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                    <ng-template #defaultSubmitCheck>-</ng-template>
                  </td>



                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                      }}{{ companypay.upgradeCalculation.baseplanPrice | number: "1.2-2" }}</span>
                    <ng-template #normalamount>
                      {{ currencySymbol
                      }}{{ companypay.amount | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                      }}{{ companypay.upgradeCalculation.baseplanTax | number: "1.2-2" }}</span>

                    <ng-template #normaltax>
                      {{ currencySymbol
                      }}{{ companypay.tax | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                      <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.baseplanTotal | number: "1.2-2"
                        }}</b></span>

                    <ng-template #normaltotal>
                      <b>{{ currencySymbol
                        }}{{ companypay.total | number: "1.2-2" }}</b>
                    </ng-template>
                  </td>



                </tr>

                <ng-container *ngIf="payrolldeduction">
                  <tr *ngIf="payrolldeduction && payrollCCplansarr.length == 0 ? false : true">
                    <td><b>{{lang.Employee_pays_through_payroll_deduction}} </b>
                      <td>
                        <td *ngIf="isMedcanPopUpSubmitted"></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                </ng-container>
                <ng-container *ngIf="payrolldeduction">
                <tr *ngFor="let companypay of payrollCCplansarr">
                  <td>
                    <span
                      *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.employeeShareStatement}}</span>
                    <ng-template #normalname>
                      {{companypay.planname}}
                    </ng-template>

                  </td>
                  <td> <span *ngIf="isdandjform">Addition to </span>{{companypay.type}}</td>

                  <td *ngIf="isMedcanPopUpSubmitted">
                     <span
                      *ngIf="companypay.planLevel==15 && companypay.multiCountPlan==true;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                    <ng-template #defaultSubmitCheck>-</ng-template>
                  </td>

                  <td class="grandTotal amounts align-right">
                    <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                      }}{{ companypay.upgradeCalculation.deltaplanPrice | number: "1.2-2" }}</span>
                    <ng-template #normalamount>
                      {{ currencySymbol
                      }}{{ companypay.amount | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts align-right">
                    <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                      }}{{ companypay.upgradeCalculation.deltaplanTax | number: "1.2-2" }}</span>

                    <ng-template #normaltax>
                      {{ currencySymbol
                      }}{{ companypay.tax | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts align-right">
                    <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                      <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.deltaplanTotal | number: "1.2-2"
                        }}</b></span>

                    <ng-template #normaltotal>
                      <b>{{ currencySymbol
                        }}{{ companypay.total | number: "1.2-2" }}</b>
                    </ng-template>
                  </td>
                </tr>
                </ng-container>
           

                <tr style="background-color: #D08000" *ngIf="employercheck">

                  <td>{{lang.Total_charge_to_Company}}</td>
                  <td></td>
                  <td class="grandTotal amounts">---</td>
                  <td class="grandTotal amounts">---</td>
                  <td class="grandTotal amounts">
                    <b>---</b>


                  </td>
                </tr>
                <tr style="background-color: #D08000" *ngIf="!employercheck">

                  <td>{{lang.Total_charge_to_Company}}</td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td class="grandTotal amounts align-right">{{ currencySymbol
                    }}{{ companydealingplansTotal | number: "1.2-2" }}</td>
                  <td class="grandTotal amounts align-right">{{ currencySymbol
                    }}{{ companydealingplanstaxTotal | number: "1.2-2" }}</td>
                  <td class="grandTotal amounts align-right">
                    <b>{{ currencySymbol
                      }}{{ companydealingplansgrandTotal | number: "1.2-2" }}</b>


                  </td>
                </tr>
                <tr>
                  <td>
                  <td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td></td>
                  <td></td>
                </tr>
              }
              @if(hasUpgradePlans){
                <tr *ngFor="let employeePay of employeeDealingPlansarr">

                  <td>
                    <!-- <span *ngIf="employeePay.upgradeCalculation;else normalname">{{employeePay.upgradeCalculation.compnayShareStatement}}</span> -->
                    <!-- <ng-template > -->
                    {{employeePay.planname}}
                    <!-- </ng-template> -->

                  </td>
                  <td *ngIf="currFormType!='nhlaa'">{{employeePay.type}}</td>
                  <td *ngIf="currFormType=='nhlaa'">Plan Upgrade</td>

                  <td *ngIf="isMedcanPopUpSubmitted">
                     <span
                      *ngIf="employeePay.planLevel==15 && employeePay.multiCountPlan==true;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                    <ng-template #defaultSubmitCheck>-</ng-template>
                  </td>

                  <td class="grandTotal amounts align-right">
                    <span *ngIf="employeePay.upgradeCalculation;else normalamount">{{ currencySymbol
                            }}{{ employeePay.upgradeCalculation.deltaplanPrice | number: "1.2-2" }}</span>
                    <ng-template #normalamount>
                    {{ currencySymbol
                    }}{{ employeePay.amount | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts align-right">
                    <span *ngIf="employeePay.upgradeCalculation;else normaltax">{{ currencySymbol
                            }}{{ employeePay.upgradeCalculation.deltaplanTax | number: "1.2-2" }}</span>

                    <ng-template #normaltax>
                    {{ currencySymbol
                    }}{{ employeePay.tax | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts align-right">
                    <span *ngIf="employeePay.upgradeCalculation;else normaltotal">
                           <b>{{ currencySymbol}}{{ employeePay.upgradeCalculation.deltaplanTotal | number: "1.2-2" }}</b></span>

                    <ng-template #normaltotal >
                    <b>{{ currencySymbol
                      }}{{ employeePay.total | number: "1.2-2" }}</b>
                    </ng-template>
                  </td>
                </tr>
              }

                @if(iafgplansCheck.length>0){






                <ng-container *ngIf="formConfigResult.allstateCI;else defaultTemp">
                   <ng-container *ngFor="
                    let plan of planssummarymainLife;
                    let i = index">
                        <tr style="background-color:#ffff">
                          <td colspan="6">&nbsp;
                            {{plan.packagename}}
                          </td>
                        </tr>
                        <tr *ngFor="let product of plan.products;let j = index">
                          <td>&nbsp;
                            {{plan.name}}
                          </td>

                          <td class="align-center">
                            <span *ngIf="plan.coverage =='MEMBER'  || plan.coverage =='MEMBER & FAMILY' || plan.coverage =='MEMBER & SPOUSE';else placheck">
                              <span>
                                @if(plan.coverage =='MEMBER'){
                                  SINGLE
                                }
                                @else if(plan.coverage =='MEMBER & FAMILY'){
                                 COUPLE
                                }
                                @else{
                                {{lang.Member_Spouse}}
                                }
                              </span>
                            </span>
                            <ng-template #placheck>---</ng-template>

                          </td>
                          <td class="align-right">

                            <!-- <span>{{lang.MEMBER}}:</span> -->

                            <table class="table text-nowrap" style="font-size:12px">

                              <tbody>

                                  <tr class=" ">
                                  <td>
                                      Coverage
                                  </td>
                                  <td>
                                    @if(plan.member.defaultRange>=plan.member.maximumCoverageWithoutEvidence){
                                    {{plan.member.maximumCoverageWithoutEvidence | currency:"USD"}}
                                    }
                                    @else{
                                    {{plan.member.defaultRange | currency:"USD"}}
                                    }

                                  </td>

                                </tr>

                                <tr class=" ">
                                  <td *ngIf="showUnits"  class=" border-right">{{lang.Units}}</td>
                                  <td *ngIf="showUnits">({{plan.member.coverageValue/plan.member.standardUnits}})</td>

                                </tr>
                                <tr class=" ">
                                  <td class=" border-right">{{lang.Premium}}</td>
                                  <td>{{plan.member.amount | currency:"USD"}}</td>

                                </tr>
                                <tr class=" " *ngIf="showUnits">
                                  <td class=" border-right">
                                    {{lang.Amount}}
                                    </td>
                                  <td>
                                    @if(formConfigResult.allstateCI){
                                      {{plan.member.dynamicAmount | currency:"USD"}}
                                      }
                                      @else{
                                      {{plan.member.amount | currency:"USD"}}
                                      }
                                  </td>

                                </tr>
                              
                              </tbody>
                            </table>
                        <!-- {{product.calculatedTax.price  | currency:"USD"}}&nbsp; -->
                        </td>
                        <td class="align-right">
                          <!-- <strong>Member:</strong>

                        <table class="table text-nowrap" style="font-size:12px">

                          <tbody>


                            <tr class=" ">
                              <td class=" border-right">Tax</td>
                              <td>{{plan.member.tax | currency:"USD"}}</td>

                            </tr>
                          </tbody>
                        </table> -->

                          <!-- @if(plan.coverage =='MEMBER & SPOUSE'){

                        <strong>Spouse:</strong>
                        <table class="table text-nowrap" style="font-size:12px">

                          <tbody>

                            <tr class=" ">
                              <td class=" border-right">Tax</td>
                              <td>{{plan.spouse.tax | currency:"USD"}}</td>

                            </tr>

                          </tbody>
                        </table>

                  } -->
                          <tr>
                            <td>${{plan.member.tax | number : '1.2-2'}}</td>
                          <tr>
                            <!-- {{product.calculatedTax.tax  | currency:"USD"}}&nbsp; -->
                        </td>
                        <td class="align-right">
                          {{product.calculatedTax.total | currency:"USD"}}&nbsp;
                        </td>
                        </tr>
                   </ng-container>
                  </ng-container>

                  
                  <ng-template #defaultTemp>
                        <ng-container *ngFor="
                        let plan of iafgplansCheck;
                        let i = index">
                  <tr style="background-color:#ffff">
                    <td colspan="6">&nbsp;
                      <b>{{plan.packagename}}</b>
                    </td>
                  </tr>
                  <tr *ngFor="let product of plan.products;let j = index">
                    <td>&nbsp;
                      {{plan.name}}
                    </td>

                    <td class="align-center">
                      <span
                        *ngIf="plan.coverage =='MEMBER' || plan.coverage =='MEMBER & SPOUSE';else placheck">{{plan.coverage}}</span>
                      <ng-template #placheck>---</ng-template>

                    </td>
                    <td class="align-right">

                      <strong>{{lang.MEMBER}}:</strong>

                      <table class="table text-nowrap" style="font-size:12px">

                        <tbody>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Units}}</td>
                            <td>({{plan.member.coverageValue/plan.member.standardUnits}})</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Premium}}</td>
                            <td>{{plan.member.premium | currency:"USD"}}</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Amount}}</td>
                            <td>{{plan.member.amount | currency:"USD"}}</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Guarantee_Acceptance}}</td>
                            <td>
                              @if(plan.member.defaultRange>=plan.member.maximumCoverageWithoutEvidence){
                              {{plan.member.maximumCoverageWithoutEvidence | currency:"USD"}}
                              }
                              @else{
                              {{plan.member.defaultRange | currency:"USD"}}
                              }

                            </td>

                          </tr>
                          @if(plan.member.maximumCoverageWithoutEvidence>plan.member.defaultRange){
                          <tr class=" ">
                            <td class=" border-right">{{lang.Acceptance_pending_approval}}</td>
                            <td>

                              {{plan.member.maximumCoverageWithoutEvidence-plan.member.defaultRange | currency:"USD"}}



                            </td>

                          </tr>
                          }
                        </tbody>
                      </table>

                      @if(plan.coverage =='MEMBER & SPOUSE'){

                      <strong>{{lang.Spouse}}:</strong>
                      <table class="table text-nowrap" style="font-size:12px">

                        <tbody>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Units}}</td>
                            <td>({{plan.spouse.coverageValue/plan.spouse.standardUnits}})</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Premium}}</td>
                            <td>{{plan.spouse.premium | currency:"USD"}}</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Amount}}</td>
                            <td>{{plan.spouse.amount | currency:"USD"}}</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Guarantee_Acceptance}}</td>
                            <td>
                              @if(plan.spouse.defaultRange>=plan.spouse.maximumCoverageWithoutEvidence){
                              {{plan.spouse.maximumCoverageWithoutEvidence | currency:"USD"}}
                              }
                              @else{
                              {{plan.spouse.defaultRange | currency:"USD"}}
                              }

                            </td>

                          </tr>
                          @if(plan.spouse.maximumCoverageWithoutEvidence>plan.spouse.defaultRange){
                          <tr class=" ">
                            <td class=" border-right">{{lang.Acceptance_pending_approval}}</td>
                            <td>

                              {{plan.spouse.maximumCoverageWithoutEvidence-plan.spouse.defaultRange | currency:"USD"}}



                            </td>

                          </tr>
                          }
                        </tbody>
                      </table>

                      }
                  <tr>
                    @if(plan.coverage =='MEMBER & SPOUSE'){
                    <td>{{lang.Total}}:${{plan.member.amount+plan.spouse.amount | number : '1.2-2'}}</td>
                    }
                    @if(plan.coverage =='MEMBER'){
                    <td>{{lang.Total}}:${{plan.member.amount | number : '1.2-2'}}</td>
                    }
                  </tr>
                  <!-- {{product.calculatedTax.price  | currency:"USD"}}&nbsp; -->
                  </td>
                  <td class="align-right">
                    <!-- <strong>Member:</strong>

                            <table class="table text-nowrap" style="font-size:12px">

                              <tbody>


                                <tr class=" ">
                                  <td class=" border-right">Tax</td>
                                  <td>{{plan.member.tax | currency:"USD"}}</td>

                                </tr>
                              </tbody>
                            </table> -->

                    <!-- @if(plan.coverage =='MEMBER & SPOUSE'){

                            <strong>Spouse:</strong>
                            <table class="table text-nowrap" style="font-size:12px">

                              <tbody>

                                <tr class=" ">
                                  <td class=" border-right">Tax</td>
                                  <td>{{plan.spouse.tax | currency:"USD"}}</td>

                                </tr>

                              </tbody>
                            </table>

                      } -->
                    <tr>
                      @if(plan.coverage =='MEMBER & SPOUSE'){
                      <td>{{lang.Total}}:${{plan.member.tax | number : '1.2-2'}}</td>
                      }
                      @if(plan.coverage =='MEMBER'){
                      <td>{{lang.Total}}:${{plan.member.tax | number : '1.2-2'}}</td>
                      }
                    <tr>
                      <!-- {{product.calculatedTax.tax  | currency:"USD"}}&nbsp; -->
                  </td>
                  <td class="align-right">
                    {{product.calculatedTax.total | currency:"USD"}}&nbsp;
                  </td>
                  </tr>
                </ng-container>
                  </ng-template>






             
                }


                @if(!hidePlanCategorization || hasUpgradePlans){
                    <tr style="background-color: #D08000" *ngIf="hasUpgradePlans || !hidePlanCategorization">

                  <td>{{lang.Total}}</td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted">
                    
                  </td>

                  <td class="grandTotal amounts align-right">{{ currencySymbol
                    }}{{ empDirectpayPlanamountTotal | number: "1.2-2" }}</td>
                  <td class="grandTotal amounts align-right">{{ currencySymbol
                    }}{{ empDirectpayPlantaxTotal | number: "1.2-2" }}</td>
                  <td class="grandTotal amounts align-right">
                    <b>{{ currencySymbol
                      }}{{ empDirectpayPlangrandTotal | number: "1.2-2" }}</b>


                  </td>
                </tr>
                }

              
              </tbody>
            </table>
            <!-- <table>
                    <label>Monthly payment Sumamry</label>
                    <tr></tr>
                  </table> -->
          </div>
        </div>
        }


        @if(addbenificaryData.length>0){
        <label for="cardnumnber">{{lang.Beneficiary_Information}}</label>
        <div class="form-group col-md-12" style="padding:0px">
          <div class="overflow-x-auto"><table class="table table-bordered text-black" id="customerPlansTable">

            <tbody>
              <tr>
                <!-- <th>{{lang.Type}}</th> -->
                <!-- <th>{{lang.First_Name}}</th>
                <th>{{lang.Last_Name}}</th> -->
                <th>Name</th>
                <th>{{lang.Gender}}</th>
                <th>{{lang.Relation}}</th>
                <!-- <th>{{lang.Minor}}</th> -->
                <th>{{lang.Date_of_Birth}}</th>
                <!-- <th>{{lang.Contingent_First_Name}}</th>
                <th>{{lang.Contingent_Last_Name}}</th> -->
                <!-- <th>{{lang.Trustee_First_Name}}</th>
                <th>{{lang.Trustee_Last_Name}}</th>
                <th>Trustee Relation</th> -->
                <th>Trustee Name - Relation</th>
                <th>{{lang.Percentage}}</th>
                <th>{{lang.Action}}</th>
              </tr>

              <tr *ngFor="
                          let broker of addbenificaryData;
                          let i = index
                        " [ngClass]="{
                          orange: i % 2 == 0,
                          white: i % 2 != 0
                        }">

                <!-- <td>{{broker.customerType}}</td> -->

                <!-- <td>
                  {{broker.firstName}}
                </td>
                <td>
                  {{broker.lastName}}
                </td> -->
                <td>
                  {{broker.firstName + ' ' +broker.lastName}}
                </td>
                <td>
                  {{broker.gender}}
                </td>
                <!-- <td>
                  {{broker.relationship}}
                </td> -->
                <td>
                  @if(broker.relationship.toLowerCase()=="other"){
                  {{capitalize(broker.relationshipSpecific ?? '')}}
                  }@else{
                  {{capitalize(broker.relationship ?? '')}}
                  }
                </td>
                <!-- <td>
                  @if(broker.isMinor=="true"){
                  Yes
                  }@else{
                  No
                  }
                </td> -->

                <td>
                  @if(broker.dob==null){
                  NA
                  }@else{
                  {{broker.dob | displayDate}}
                  }
                </td>
                <!--
                <td>
                  {{broker.contingentFirstName}}
                </td>
                <td>
                  {{broker.contingentLastName}}
                </td> -->
                <!-- <td>

                  @if(broker.trusteeFirstName==""){
                  NA
                  }@else{
                  {{broker.trusteeFirstName}}
                  }

                </td>
                <td>
                  @if(broker.trusteeLastName==""){
                  NA
                  }@else{
                  {{broker.trusteeLastName}}
                  }
                </td>
                <td>
                  @if(broker.trusteeRelation==""){
                  NA
                  }@else{
                  {{broker.trusteeRelation}}
                  }
                </td> -->
                <td>
                  @if(broker.trusteeFirstName==""){
                  NA
                  }@else{
                  {{broker.trusteeFirstName+ ' '+broker.trusteeLastName + ' - '+broker.trusteeRelation}}
                  }
                </td>

                <td style="text-align:center">
                  {{broker.percentage}}%
                </td>

                <td class="thBottomNone text-center inline-flex items-center">
                  <svg class="h-10 w-10 text-green-600" (click)="editbenficiary($event, i, broker)"
                    *ngIf="enableEditIndex != i" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                    <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                    <line x1="16" y1="5" x2="19" y2="8" />
                  </svg>
                  <svg class="h-9 w-9 text-red-600" (click)="deleteBenficiary(broker, i)" *ngIf="enableEditIndex != i"
                    width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="3" y="4" width="18" height="4" rx="2" />
                    <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" />
                    <line x1="10" y1="12" x2="14" y2="12" />
                  </svg>


                </td>

              </tr>
            </tbody>
          </table></div>



        </div>

        }

        <!-- no use -->
        @if(alloptinplans && alloptinplans.length == 0 ? false : true){
        <div class="col-span-full">
          <label for="cardnumnber"><strong>{{lang.opt_in_plans_summary}}90</strong></label>

          <div class="overflow-x-auto">
            <table class="table table-bordered text-black" id="customerPlansTable">
              <tbody>
                <tr>
                  <!-- <th>S. no</th> -->
                  <th>{{lang.plan}}</th>
                  <th>{{lang.details}}</th>
                  <!-- <th class="taxamount"> Amount</th>

                  <th class="taxamount">Tax</th>
                  <th class="taxamount">Total</th> -->
                </tr>
                <tr *ngFor="
                        let item of alloptinplans;
                        let i = index
                      ">
                  <!-- <td>{{i+1}}</td> -->
                  <!-- {{item.groupName | lowercase}}- -->

                  <td>
                    {{ item.planname }}<br />({{
                    item.packagename
                    }})
                  </td>
                  <td>{{ item.details }}</td>
                  <!-- <td class="taxamount">{{currencySymbol}}{{item.planPrice | number : '1.2-2'}}</td>

                  <td class="taxamount"><span *ngIf="item.gstCheck" class="gsttaxes">{{item.gstPrice==0?"-":"(GST)&nbsp;"+currencySymbol+(item.gstPrice | number : '1.2-2')}}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{item.pstPrice==0?"-":"(PST)&nbsp;"+currencySymbol+(item.pstPrice | number : '1.2-2')}}</span><span *ngIf="item.hstCheck"  class="gsttaxes">{{item.hstPrice==0?"-":"(HST)&nbsp;"+currencySymbol+(item.hstPrice | number : '1.2-2')}}</span><span *ngIf="!item.gstCheck && !item.pstCheck && !item.hstCheck ">-</span></td>
                  <td class="grandTotal">{{currencySymbol}}{{item.totalPrice | number : '1.2-2'}}</td> -->
                </tr>

                <tr>
                  <!-- <td>Total </td><td colspan="2"></td><td class="grandTotal">{{currencySymbol}}0.00</td> -->
                </tr>
                <!-- <tr>
                  <td colspan="3">

                  </td>
                  <td colspan="2" class="grandTotal">Total:&nbsp;{{currencySymbol}}{{planAmount | number : '1.2-2'}}</td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        }


        <br />
        @if(!hideCompanyPaidPlans){

          <div class="col-span-full">
            <input type="checkbox" name="comanyprovided" value="true"
              (change)="companyPlansConfirmation($event)" />&nbsp;<span
              class="termsandconditions">{{lang.I_confirm_signing_up_for_the_benefits_plan_provided_by_the_company || 'I confirm signing up for the benefits plan provided by the company'}}
            </span>
            @if (companyplansCheck) {
            <div class="invalid text-red-500">{{lang.Please_confirm_Company_paid_plans}}</div>
            }
          </div>
        }
        @if(payrollCCplansarr.length>0 && payrolldeduction){
        <div class="col-span-full">
          <input type="checkbox" name="upgradeplans" value="true"
            (change)="upgradeplansConfirmation($event)" />&nbsp;<span
            class="termsandconditions">{{lang.I_confirm_upgrading_my_benefit_plans_and_acknowledge_that_the_difference_between_the_plans_paid_by_the_company_and_my_selection_will_deducted_on_my_pay_check}}
          </span>
          @if (upgradeplansCheck) {
          <div class="invalid text-red-500">{{lang.Please_confirm_Upgrade_plans}}</div>
          }
        </div>
        }

        @if(!hidePlanCategorization && showPaymenthMethod && EmployeeSelectedPlans.length>0 && directpayCCplansarr.length==0 ||
        iafgplansCheck.length>0){
        <div class="col-span-full">
          <input type="checkbox" name="voluntary" value="true"
            (change)="voluntryplansConfirmation($event)" />&nbsp;<span
            class="termsandconditions">{{lang.I_confirm_enrolling_into_voluntary_opt_ins_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below || 'I confirm enrolling into voluntary opt-ins and charge monthly premiums to Credit Card or PAD as per data below'}}
          </span>
          @if (voluntryplansCheck) {
          <div class="invalid text-red-500">{{lang.Please_confirm_voluntary_plans}}</div>
          }
        </div>
        }

        @if(!hidePlanCategorization && showPaymenthMethod && EmployeeSelectedPlans.length==0 && directpayCCplansarr.length>0){
        <div class="col-span-full">
          <input type="checkbox" name="voluntary" />&nbsp;<span class="termsandconditions">
            {{lang.I_confirm_enrolling_into_Upgrade_plans_split_amount_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below || 'I confirm enrolling into Upgrade plans split amount and charge monthly premiums to Credit Card or PAD as per data below'}}
          </span>
        </div>
        }
        @if(!hidePlanCategorization && showPaymenthMethod && EmployeeSelectedPlans.length>0 && directpayCCplansarr.length>0){
        <div class="col-span-full">
          <input type="checkbox" name="voluntary" />&nbsp;<span
            class="termsandconditions">{{lang.I_confirm_enrolling_into_voluntary_opt_ins_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below || 'I confirm enrolling into voluntary opt-ins and charge monthly premiums to Credit Card or PAD as per data below'}}
          </span>
        </div>
        }
        <div class="col-span-w-1/2" [hidden]="showPaymenthMethod">
          <label for="cardnumnber">{{lang.Signature}}<span style="color: red">*</span></label>

          <div class="signature-container sm:w-1/4" style="border:1px solid #ccc;border-radius: 4px;">

            <signature-pad [options]="signaturePadOptions" (touchmove)="onMouseMove($event)"
              (mousemove)="onMouseMove($event)" (onEndEvent)="drawComplete()"
              (onBeginEvent)="drawStart()"></signature-pad>
            @if(signaturecheckvalue1cc){
            <div style="
                left: 10px;
                color: red;
                text-decoration: underline;cursor:pointer">
              <p (click)="clearSignature()">x {{lang.Clear}}</p>
            </div>
            }
            <!-- <canvas
#sigplanconf
(mousedown)="onMouseDownplan($event)"   (touchstart)="onMouseDownplan($event)" (touchmove)="onMouseMoveplan($event)"
(mousemove)="onMouseMoveplan($event)" required
></canvas>
              <div
                *ngIf="signaturecheckvalue1PlansConfirmation"
                style="
                  position: absolute;
                  top: 32px;
                  left: 20px;
                  color: red;
                  text-decoration: underline;
                  cursor: pointer;
                ">
                <p (click)="clearPadPlansConfirmation()">x {{lang.clear || "Clear"}}</p>
              </div>

              <span class="help-block text-danger" *ngIf="signaturemessagePlansConfirmation"
                >{{lang.please_sign_the_signature}}</span
              > -->
            <!-- <span
            class="help-block text-danger"
            *ngIf="signaturemessageccconfirm">Please confirm the signature</span
          > -->
          </div>

          <br />
          <!-- <form class="signbtn" *ngIf="signaturecheckvaluePlansConfirmation">
            </form> -->
        </div>





        <!-- Second column -->
      </div>
      @if(showPaymenthMethod){
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3 mx-2">
        <div class="col-span-full tex-center items-center">
          @if(EmployeeSelectedPlans.length>0 && directpayCCplansarr.length==0 && !hidePlanCategorization){
          {{lang.Voluntary_Opt_ins_Payment || 'Voluntary Opt-ins Payment'}} : {{lang.Total || 'Total'}} ({{currencySymbol}}{{cartDisplayAmount}})
          }
          @if(EmployeeSelectedPlans.length==0 && directpayCCplansarr.length>0 && !hidePlanCategorization){
          {{lang.Upgrade_plans || 'Upgrade Plans'}} : {{lang.Total}} ({{currencySymbol}}{{DirectCCpayPlangrandTotal}})
          }
          @if(EmployeeSelectedPlans.length>0 && directpayCCplansarr.length>0 && !hidePlanCategorization){
          {{lang.Voluntary_Opt_ins_Payment}} & {{lang.Upgrade_plans}} : {{lang.Total}}
          {{currencySymbol}}{{empDirectpayPlangrandTotal}} ({{currencySymbol}}{{cartDisplayAmount}} +
          {{currencySymbol}}{{DirectCCpayPlangrandTotal}})
          }
          <form [formGroup]="paymentForm" #paymentformCC
            action="https://payments.subscriptionplatform.com/v2/payments/create" method="post">
            <!-- <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4 p-4 "  > -->

            <div class="col-span-1">
              <input class="form-control" autofocus="autofocus" id="CustomerId" formcontrolname="cutomerId"
                name="CustomerID" type="hidden" value="{{ customerid }}" />
            </div>
            <div class="col-span-1">
              <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                type="hidden" value="{{ publicapikey }}" />
            </div>

            <div class="col-span-1">
              <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri" type="hidden"
                value="{{ paymentsuccessuri }}" />
            </div>

            <div class="col-span-1">
              <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                value="{{ paymentUri }}" />
            </div>

            <div class="col-span-1">
              <input class="form-control" id="MakeDefault" placeholder="Name on the card" value="true" type="hidden"
                name="MakeDefault" />
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">

              <div class="col-span-3" *ngIf="!hidePlanCategorization">
                <label for="Email" class="labeling">{{ lang.Email }}<span style="color: red">*</span></label>

                <input class="form-control" id="Email" placeholder={{lang.Email}} type="hidden" name="email"
                  [(ngModel)]="paymentemail" [ngModelOptions]="{standalone: true}" value="{{paymentemail}}" />
                <input class="form-control" id="Email" placeholder="{{ lang.Email }}" type="email" readonly
                  formControlName="email" [(ngModel)]="paymentemail" value="{{paymentemail}}" />


              </div>

              <div class="col-span-3">
                <div>
                  <label for="cardnumnber" class="labeling">{{ lang.Payment_Method }}</label>
                </div>
                <div class="flex items-center space-x-2">
                  <input type="radio" id="pad_payment" formControlName="paymentRadioCheck" value="PAD"
                    class="form-radio text-blue-600" (click)="paymentmethod($event)" />
                  <!-- <label for="true" class="labeling">{{
                  lang.Pre_authorized_Debit
                }}</label> -->
                  <label for="pad_payment" class="labeling">Pre Authorized Debit</label>
                </div>

                <div class="flex items-center space-x-2">
                  <input type="radio" id="cc_payment" formControlName="paymentRadioCheck"
                    [checked]="bankpaymentmethod === 'CC'" value="CC" class="form-radio text-blue-600"
                    (click)="paymentmethod($event)" />
                  <label for="cc_payment" class="labeling">{{
                    lang.Credit_Card
                    }}</label>
                </div>
              </div>
            </div>

            @if(paymentForm.get('paymentRadioCheck')?.value === 'CC')
            {
            <div
              class="grid grid-cols-1 sm:grid-cols-3 gap-1 border-[1px] border-indigo-700 backdrop-blur-sm rounded-xl px-2 py-2">
              <!-- <span class="bg-gradient-to-r from-[#d5dfe1] to-[#616874] rounded-xl px-4 py-8 w-3/4"> -->
              <div class="col-span-3 sm:col-span-1">
                <label for="firstname" class="labeling"> {{ lang.First_Name
                  }}<span style="color: red">*</span></label>
                <input class="form-control" id="firstname" placeholder={{lang.First_Name}} name="FirstName"
                  type="hidden" [value]="paymentFirstName" [(ngModel)]="paymentFirstName"
                  [ngModelOptions]="{standalone: true}" />
                <input class="form-control" id="firstname" placeholder={{lang.First_Name}} formControlName="FirstName"
                  type="text" [(ngModel)]="paymentFirstName" (keypress)="alphabatesOnly($event)" />
                @if (payment['FirstName'].errors &&
                payment['FirstName'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['FirstName'].errors?.['required']) {
                  <div>{{ lang.Please_enter_first_name }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="lastname" class="labeling">{{ lang.Last_Name
                  }}<span style="color: red">*</span></label>
                <input class="form-control" id="lastName" placeholder={{lang.Last_Name}} name="LastName" type="hidden"
                  [value]="paymentLastName" [ngModelOptions]="{standalone: true}" [(ngModel)]="paymentLastName" />
                <input class="form-control" id="LastName" placeholder={{lang.Last_Name}} formControlName="LastName"
                  type="text" [(ngModel)]="paymentLastName" (keypress)="alphabatesOnly($event)" />
                @if (payment['LastName'].errors &&
                payment['LastName'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['LastName'].errors?.['required']) {
                  <div>{{ lang.Please_enter_last_name }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-2">
                <label for="CardNumber" class="labeling">{{ lang.Card_Number
                  }}<span style="color: red">*</span></label>
                <div class="flex items-center gap-2">
                  <input class="form-control" id="CardNumber" placeholder="{{ lang.cardnumnber || 'Card Number' }}" name="CardNumber"
                    formControlName="CardNumber" (input)="creditcardlblurmethod($event)" (keypress)="
                          ($event.charCode >= 48 && $event.charCode < 58)
                        " />
                  @if(cardType){
                  <img class="w-16 h-10 animate-pulse flex-shrink-0" src={{cardType}} />
                  }
                </div>

                @if (payment['CardNumber'].errors &&
                payment['CardNumber'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['CardNumber'].errors?.['required']) {
                  <div>{{ lang.Please_enter_card_Number }}</div>
                  } @if
                  (payment['CardNumber'].errors?.['invalidcreditcarddetails'])
                  {
                  <div>{{ lang.Please_enter_valid_Card_number }}</div>
                  }
                  @else{
                  @if(invalidcreditcard==true){

                  <div class="invalid text-red-500">
                    {{ lang.Please_enter_valid_Card_number }}
                  </div>

                  }
                  }
                </div>
                }
              </div>
              <div class="col-span-1"></div>
              <div class="col-span-3 sm:col-span-1">
                <label for="ExpirationMonth" class="labeling">{{ lang.Expiry_month || 'Expiry Month'
                  }}<span style="color: red">*</span></label>

                <select class="form-control" id="ExpirationMonth" name="ExpirationMonth"
                  (change)="filterExpiryDate($event)" formControlName="ExpirationMonth" placeholder="MM">
                  <option value="" disabled selected>
                    {{ lang.Select }}
                  </option>
                  <option value="01">Jan</option>
                  <option value="02">Feb</option>
                  <option value="03">Mar</option>
                  <option value="04">April</option>
                  <option value="05">May</option>
                  <option value="06">June</option>
                  <option value="07">July</option>
                  <option value="08">Aug</option>
                  <option value="09">Sept</option>
                  <option value="10">Oct</option>
                  <option value="11">Nov</option>
                  <option value="12">Dec</option>
                </select>
                @if (payment['ExpirationMonth'].errors &&
                payment['ExpirationMonth'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['ExpirationMonth'].errors?.['required']) {
                  <div>{{ lang.Please_Select_Expiry_Month }}</div>
                  } @if (payment['ExpirationMonth'].errors?.['min']) {
                  <div>minim</div>
                  } @if (payment['ExpirationMonth'].errors?.['max']) {
                  <div>maxmim</div>
                  }
                </div>
                }
                <!-- @if (payment['ExpirationMonth'].errors?.['invalidcreditcarddetails']) {
                                        <div>{{ lang.please_enter_valid_credit_card }}</div>
                                        } -->
                <!-- <span
                                      class="help-block text-danger"
                                      *ngIf="
                                        paymentForm.get('ExpirationMonth').touched &&
                                        paymentForm
                                          .get('ExpirationMonth')
                                          .hasError('required')
                                      "
                                      >{{lang.please_select_expiry_month}}</span
                                    >

                                    <span
                                      class="help-block text-danger"
                                      *ngIf="showexpirymontherror"
                                      >{{lang.please_enter_valid_expiry_month}}</span
                                    > -->
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="ExpirationYear" class="labeling">{{ lang.Expiry_Year
                  }}<span style="color: red">*</span></label>

                <select class="form-control" id="ExpirationYear" placeholder="YY" name="ExpirationYear"
                  (change)="filterExpiryDate($event)" formControlName="ExporationYear">
                  <option value="" disabled selected>
                    {{ lang.Select }}
                  </option>
                  <option *ngFor="let item of [].constructor(40); let i = index" value="{{ i + 25}}">
                    {{ i + 2025 }}
                  </option>
                </select>
                @if (payment['ExporationYear'].errors &&
                payment['ExporationYear'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['ExporationYear'].errors?.['required']) {
                  <div>{{ lang.Please_Select_Expiry_Year }}</div>
                  } @if (payment['ExporationYear'].errors?.['expiryDate']) {
                  <div>cant minimminim</div>
                  }
                </div>
                }
                <!-- <span
                                      class="help-block text-danger"
                                      *ngIf="
                                        paymentForm.get('ExporationYear').touched &&
                                        paymentForm.get('ExporationYear').hasError('required')
                                      "
                                      >{{lang.please_select_expiry_year}}</span
                                    >

                                    <span
                                      class="help-block text-danger"
                                      *ngIf="showexpiryyearerror"
                                      >{{lang.please_enter_valid_expiry_year}}</span
                                    > -->
              </div>

              <div class="col-span-3 sm:col-span-1">
                <label for="Cvv" class="labeling">{{ lang.CVV }}<span style="color: red">*</span></label>

                <input class="form-control" id="Cvv" placeholder={{lang.CVV}} name="Cvv" formControlName="cvv"
                  maxlength="4" (keypress)="
                        ($event.charCode >= 48 && $event.charCode < 58)
                      " />
                @if (payment['cvv'].errors && payment['cvv'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['cvv'].errors?.['required']) {
                  <div>{{ lang.Please_enter_cvv }}</div>
                  } @if (payment['cvv'].errors?.['minlength']) {
                  <div>{{ lang.CVV_must_be_3_or_4_digits }}</div>
                  }
                </div>
                }
              </div>


              @if(invalidCardDetails){
              <div class="col-span-3">
                <span class="invalid text-red-500">{{lang.Please_enter_the_correct_Month_and_Year}}</span>
              </div>
              }
            </div>

            <!-- </span> -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
              <div class="col-span-3">
                <input type="checkbox" (click)="homeaddresscheckCC($event)" id="home_address" />&nbsp;
                <span class="paymentaddress labeling" for="home_address">{{
                  lang.Home_Address_same_as_billing_Address }}
                </span>
              </div>

              <div class="col-span-3 sm:col-span-1">
                <label for="Address1" class="labeling">{{ lang.Street_Address
                  }}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="Address1" placeholder={{lang.Street_Address}}
                  formControlName="streetaddress" autocomplete="off" />
                <input type="hidden" name="Address1" />
                @if (payment['streetaddress'].errors &&
                payment['streetaddress'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['streetaddress'].errors?.['required']) {
                  <div>{{ lang.Please_enter_Street_Address }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="Address2" class="labeling">{{ lang.Street_Address_Line_2 }}<span></span></label>
                <input type="text" class="form-control" id="Address2" formControlName="streetaddressline2"
                  autocomplete="off" placeholder={{lang.Street_Address_Line_2}} />
                <input type="hidden" name="Address2" />
              </div>
              <div class="col-span-3 sm:col-span-1"></div>

              <div class="col-span-3 sm:col-span-1">
                <label for="City" class="labeling">{{ lang.City }}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="City" placeholder={{lang.City}}
                  formControlName="city" />
                <input type="hidden" name="City" />
                @if (payment['city'].errors && payment['city'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['city'].errors?.['required']) {
                  <div>{{ lang.Please_enter_City }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="StateId" class="labeling">{{ lang.Province }}<span style="color: red">*</span></label>

                <select class="form-control" id="StateId" placeholder="select" formControlName="province"
                  (change)="provincelistCreditPayment($event)" autocomplete="off">
                  <option value="">{{ lang.Select }}</option>
                  <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                    {{ name.shortName }}
                  </option>
                </select>

                <input type="hidden" name="StateId" />

                @if (payment['province'].errors && payment['province'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['province'].errors?.['required']) {
                  <div>{{ lang.Please_select_Province }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="PostalZip" class="labeling">{{ lang.Postal_Code }}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="PostalZip" formControlName="postalcode"
                  autocomplete="off" placeholder={{lang.Postal_Code}}
                  (input)="changeTextToUppercaseCreditPayment('postalcode',$event)" />
                <input type="hidden" name="PostalZip" />

                @if (payment['postalcode'].errors && payment['postalcode'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['postalcode'].errors?.['required']) {
                  <div>{{ lang.Please_enter_postal_code }}</div>
                  }
                </div>
                } @if (creditCradInvalidProvince==true) {
                <div class="invalid text-red-500">
                  {{ lang.Please_enter_valid_postal_code }}
                </div>
                }
              </div>
              <div class="col-span-3">
                <label for="signature" class="labeling">{{ lang.Signature }}<span style="color: red">*</span></label>

                <div class="signature-container sm:w-1/2" style="border:1px solid #ccc;border-radius: 4px;">

                  <!-- <button class="btn btn-primary btn-inline" (click)="clearPadcc()" [disabled]="signaturecheckvalue1cc">Clear</button> -->

                  <!-- <canvas
                #canvascc
                (touchstart)="startDrawingcc($event)"
                (touchmove)="movedcc($event)"
                (click)="signaturestartcc($event)" required
              ></canvas> -->

                  <signature-pad [options]="signaturePadOptions" #signaturePad1 (touchmove)="onMouseMoveCredit($event)"
                    (mousemove)="onMouseMoveCredit($event)" (onEndEvent)="drawCompleteCC()"
                    (onBeginEvent)="drawStartCC()"></signature-pad>
                  @if(signaturecheckCC){
                  <div style="
              left: 10px;
              color: red;
              text-decoration: underline;cursor:pointer">
                    <p (click)="clearSignatureCC()">x {{lang.Clear}}</p>
                  </div>
                  }




                </div>
                @if(signaturemessagecc){
                <span class="invalid text-red-500">{{lang.Please_Sign_the_Signature}}</span>
                }
              </div>
              <div class="col-span-3">
                <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                  siteKey="{{ fusbillinfocaptchavalue }}">
                </re-captcha>

                <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
                @if (payment['recaptchaReactive'].errors &&
                payment['recaptchaReactive'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['recaptchaReactive'].errors?.['required']) {
                  <div>{{ lang.Please_Check_re_Captcha_Validation }}</div>
                  }
                </div>
                }
              </div>
            </div>

            }


            @if(paymentForm.get('paymentRadioCheck')?.value === 'PAD')
            {
            <form [formGroup]="bankpayForm" #bankForm="ngForm">
              <!-- <div class="grid grid-cols-1 sm:grid-cols-6 gap-2"> -->
              <!-- style="max-width:90px;margin-left:5px" -->

              <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                <div class="col-span-3 sm:col-span-1">
                  <!-- <label for="cardnumnber"
                      >{{ lang.Bank_Code }}<span style="color: red">*</span></label
                    > -->
                  <label for="banknumber" class="labeling">Bank Code<span style="color: red">*</span></label>
                  <input class="form-control checking-field" id="banknumber" placeholder={{lang.Bank_Code}}
                    name="banknumber" autocomplete="off" formControlName="banknumber" maxlength="3"
                    (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />

                  @if (bankpay['banknumber'].errors &&
                  bankpay['banknumber'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['banknumber'].errors?.['required']) {
                    <div>{{ lang.Please_enter_bank_code }}</div>
                    }
                    @if (bankpay['banknumber'].errors?.['checkbanknumbervalidator']) {
                    <div>{{ lang.Bank_code_must_be_3_digits }}</div>
                    }
                  </div>
                  }

                </div>
                <!-- style="max-width:120px;" -->
                <div class="col-span-3 sm:col-span-1">
                  <label for="branch" class="labeling">{{ lang.Transit_Number || 'Transit Number'
                    }}<span style="color: red">*</span></label>
                  <!-- (input)="credit_card_number($event)" -->
                  <input class="form-control checking-field" id="branch" placeholder={{lang.Transit_Number}}
                    name="branch" formControlName="transitnumber" autocomplete="off" maxlength="5"
                    (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  @if (bankpay['transitnumber'].errors &&
                  bankpay['transitnumber'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['transitnumber'].errors?.['required']) {
                    <div>{{ lang.Enter_Transit_Number }}</div>
                    }
                    @if (bankpay['transitnumber'].errors?.['checktransitnumbervalidator']) {
                    <div>{{ lang.Transit_Number_must_be_5_digits }}</div>
                    }
                  </div>
                  }

                </div>
                <div class="col-span-3 sm:col-span-1">
                  <label for="accountnumber" class="labeling">{{ lang.Account_Number
                    }}<span style="color: red">*</span></label>
                  <!-- (input)="credit_card_number($event)" -->
                  <input class="form-control checking-field" id="accountnumber" placeholder={{lang.Account_Number}}
                    autocomplete="off" name="accountnumber" formControlName="accountnumber" maxlength="12"
                    (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  @if (bankpay['accountnumber'].errors &&
                  bankpay['accountnumber'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['accountnumber'].errors?.['required']) {
                    <div>{{ lang.Enter_Account_Number }}</div>
                    }
                    @if (bankpay['accountnumber'].errors?.['checkaccountnumbervalidator']) {
                    <div>{{ lang.Account_Number_must_be_5_12_digits }}</div>
                    }
                  </div>
                  }


                </div>
                @if(bankerrormsg){
                <div class="col-span-3 invalid text-red-500 ">{{bankerrormsg}}</div>
                }

                <div class="col-span-3">
                  <label for="bankname" class="labeling">{{ lang.Bank_Details }}</label>
                  <!-- (input)="credit_card_number($event)" -->
                  <textarea class="form-control" id="bankname" placeholder="{{ lang.bank_details }}" name="bankname"
                    formControlName="bankname" style="color: rgba(85, 85, 85, 0.9)" [ngModel]="banknameres"
                    rows="6"></textarea>
                  @if (bankpay['bankname'].errors &&
                  bankpay['bankname'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['bankname'].errors?.['required']) {
                    <div>{{ lang.Please_verify_the_bank_details }}</div>
                    }

                  </div>
                  }


                </div>


                <div class="col-span-3">
                  @if(verifybankdetails && verifybutton){
                  <button type="submit"
                    class="w-36 h-14 mb-1 rounded-full border-[1px] border-indigo-700 bg-white p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white hover:border-green-500"
                    (click)="verifybank()">
                    {{lang.Verify}}
                  </button>&nbsp;

                  }

                  @if(verifybankdetails){

                  <button type="submit"
                    class="w-36 h-14 mb-1 rounded-full border-[1px] border-indigo-700 bg-gray-200 p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white"
                    (click)="checkbankdetails($event)">
                    {{lang.Reset}}
                  </button>
                  }


                  <!-- <form class="signbtn">
                      <button class="btn btn-primary btn-inline"  *ngIf="(verifybankdetails && verifybutton)"  (click)="verifybank()" style="margin-left:5px">{{lang.verify}}</button>
                      <button class="btn btn-primary btn-inline" *ngIf="verifybankdetails"  id="no" value="no" (click)="checkbankdetails($event)" >{{lang.reset}}</button>
                    </form>
                    <div class="clearfix"></div> -->


                  <!-- <span *ngIf="(bankdetailsverify && verifybankdetails)"  class="help-block text-danger" style="margin-top:20px;margin-left:10px">{{lang.please_verify_the_bank_details}}</span> -->

                </div>


                <div class="col-span-3">
                  <label for="uploadvoidCheque">{{ lang.Upload_Void_Cheque
                    }}<span style="color: red">*</span></label>

                  <!-- Hidden native input — keeps formControlName for Angular validation -->
                  <input #voidInput type="file" id="uploadvoidCheque"
                    formControlName="voidcheck"
                    (change)="voidcheckupload($event)"
                    accept=".jpg,.jpeg,.png,.pdf"
                    style="display:none" />

                  <!-- Custom upload button row -->
                  <div class="void-upload-row">
                    <button type="button" class="void-upload-btn" (click)="voidInput.click()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                      </svg>
                      {{ lang.Choose_file || 'Choose file' }}
                    </button>
                    <span class="void-upload-filename">{{ voidCheckFileDisplayName || (lang.No_file_selected || 'No file selected') }}</span>
                  </div>

                  @if (bankpay['voidcheck'].errors && bankpay['voidcheck'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['voidcheck'].errors?.['required']) {
                    <div>{{ lang.Please_Upload_Void_Cheque_file }}</div>
                    }
                  </div>
                  }

                  @if(imagedisplay){
                  <div class="void-card-preview" (click)="showvoidcheckpreview()" title="Click to enlarge">
                    @if(normalview){
                    <img [src]="imagedisplay" class="void-card-img" alt="Void Cheque" />
                    }
                    @if(pdfview){
                    <div class="void-card-pdf">
                      <svg xmlns="http://www.w3.org/2000/svg" class="void-card-pdf-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 3.5L18.5 9H13V3.5zM9 13h6v1H9v-1zm0 3h6v1H9v-1zm0-6h2v1H9v-1z"/>
                      </svg>
                      <span class="void-card-pdf-name">PDF Document</span>
                      <small class="void-card-pdf-hint">{{ lang.Click_to_view_full_document || 'Click to view full document' }}</small>
                    </div>
                    }
                    <span class="void-card-enlarge-pill">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                      </svg>
                      <!-- {{ lang.Click_to_enlarge || 'Click to enlarge' }} -->
                    </span>
                  </div>
                  }
                </div>

                <div class="col-span-3">
                  <input type="checkbox" (click)="homeaddresscheck($event)" id="home_address" />&nbsp;
                  <span class="paymentaddress labeling" for="home_address">{{
                    lang.Home_Address_same_as_billing_Address }}
                  </span>
                </div>


                <div class="col-span-3 sm:col-span-1">
                  <label for="Address1" class="labeling">{{ lang.Street_Address
                    }}<span style="color: red">*</span></label>
                  <input type="text" class="form-control checking-field" id="Address1"
                    placeholder={{lang.Street_Address}} formControlName="bankstreetaddress" autocomplete="off" />
                  @if (bankpay['bankstreetaddress'].errors &&
                  bankpay['bankstreetaddress'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['bankstreetaddress'].errors?.['required']) {
                    <div>{{ lang.Please_enter_Street_Address }}</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-span-3 sm:col-span-1">
                  <label for="Address2" class="labeling">{{ lang.Street_Address_Line_2 }}<span></span></label>
                  <input type="text" class="form-control" id="Address2" formControlName="bankstreetaddressline2"
                    autocomplete="off" placeholder={{lang.Street_Address_Line_2}} />
                </div>
                <div class="col-span-3 sm:col-span-1"></div>

                <div class="col-span-3 sm:col-span-1">
                  <label for="City" class="labeling">{{ lang.City }}<span style="color: red">*</span></label>
                  <input type="text" class="form-control checking-field" id="City" placeholder={{lang.City}}
                    formControlName="bankcity" value="" />
                  @if (bankpay['bankcity'].errors && bankpay['bankcity'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['bankcity'].errors?.['required']) {
                    <div>{{ lang.Please_enter_City }}</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-span-3 sm:col-span-1">
                  <label for="StateId" class="labeling">{{ lang.Province }}<span style="color: red">*</span></label>

                  <select class="form-control" id="StateId" placeholder="select" formControlName="bankprovince" value=""
                    (change)="provincelistpayment($event)" autocomplete="off">
                    <option value="">{{ lang.Select }}</option>
                    <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                      {{ name.shortName }}
                    </option>
                  </select>


                  @if (bankpay['bankprovince'].errors && bankpay['bankprovince'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['bankprovince'].errors?.['required']) {
                    <div>{{ lang.Please_select_Province }}</div>
                    }
                  </div>
                  }
                </div>
                <div class="col-span-3 sm:col-span-1">
                  <label for="PostalZip" class="labeling">{{ lang.Postal_Code }}<span style="color: red">*</span></label>
                  <input type="text" class="form-control checking-field" id="PostalZip" formControlName="bankpostalcode"
                    autocomplete="off" (input)="changeTextToUppercasePayment('bankpostalcode', $event)"
                    placeholder={{lang.Postal_Code}} value="" />
                  <input type="hidden" name="PostalZip" />

                  @if (bankpay['bankpostalcode'].errors && bankpay['bankpostalcode'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['bankpostalcode'].errors?.['required']) {
                    <div>{{ lang.Please_enter_postal_code }}</div>
                    }
                  </div>
                  } @if (bankinvalidPostalCode==true) {
                  <div class="invalid text-red-500">
                    {{ lang.Please_enter_valid_postal_code }}
                  </div>
                  }


                </div>

                <div class="col-span-3">

                  <button type="button"
                    class="w-full sm:w-1/2 h-14 mb-1 max-2 rounded-full border-[1px] border-indigo-700 bg-white p-0.5 font-bold transition duration-700 ease-in-out text-black mt-2"
                    (click)="showpadaggrement()">
                    {{lang.Review_and_Sign_the_PAD_Agreement}}
                  </button>
                  <span class="invalid text-red-500">{{padaggrementerror}}</span>
                </div>


              </div>
            </form>

            }


            @if(paymentForm.get('paymentRadioCheck')?.value === 'CC'){


            <button
              class="fixed right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
              (click)="creditcardpaysubmit2(paymentForm.value,paymentformCC)">
              {{ lang.Submit }}
            </button>
            }

          </form>
        </div>
      </div>
      }
      <div class="relative">

        <!-- Left Button -->
        <!-- <button class="fixed left-0 bottom-16  w-36 h-14 mb-1 rounded-full border-2 border-indigo-700 bg-gray-200 p-0.5 font-bold mx-2 sm:mx-12 hover:bg-white" (click)="gotoPlansPage()">
        {{ lang.previous }}
      </button> -->


        <button
          class="fixed text-center inline-flex items-center left-3 sm:left-16 lg:left-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
          style="width:120px;"
          (click)="gotoPlansPage()">

          <svg class="h-9 w-9 me-2 text-indigo-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          {{ lang.Previous }}
        </button>
        <!-- Right Button -->

        @if(paymentForm.get('paymentRadioCheck')?.value === 'PAD'){



        <button
          class="fixed right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
          (click)="bankpayformsubmit2(bankpayForm.value)">
          {{ lang.Submit }}
        </button>
        }

        <!-- @if(paymentForm.get('paymentRadioCheck')?.value =='') {

        <button class="fixed right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white" (click)="registartionform(paymentForm.value)">
          {{ lang.submit }}
        </button>

      } -->

        @if(paymentForm.get('paymentRadioCheck')?.value !== 'CC' && paymentForm.get('paymentRadioCheck')?.value !==
        'PAD') {

        <button
          class="fixed right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
          (click)="registartionform2(paymentForm.value)">
          {{ lang.Submit }}
        </button>

        }

      </div>
    </div>
    }



    @if(activeTab === 2){


    <div class="flex flex-col sm:flex-row gap-4 mt-3 mx-2 items-start">

      <!-- RIGHT: Tables (52%) -->
      <div class="w-full sm:w-[52%] order-2 bg-white text-black">
        <!-- <div class="form-row" *ngIf="!singleSummaryTable && (companySelectedPlans.length == 0 ? false : true)"> -->

        @if(!singleSummaryTable && (companySelectedPlans.length == 0 ? false : true)){
        <div class="col-span-full">
          <!-- <label for="cardnumnber"><strong>{{lang.core_plans_premium_paid_100%_by_employer}}</strong></label> -->
          <label for="cardnumnber"><strong>{{lang.Core_Plans_Premium_paid_100_by_employer}}</strong></label>



          <div class="overflow-x-auto">
            <table class="table table-bordered text-black" id="customerPlansTable">
              <tbody>
                <tr>
                  <!-- <th>S. no</th> -->
                  <th>{{lang.Plan}}</th>
                  <!-- <th>Company Share</th>
                          <th>Employee Share</th> -->
                  <th class="taxamount">{{lang.Amount}}({{lang.Company}})</th>
                  <!-- <td>Plan</td> -->
                  <th class="taxamount">{{lang.Tax}}</th>
                  <th class="taxamount">{{lang.Total}}</th>
                </tr>
                <tr *ngFor="
                            let item of companySelectedPlans;
                            let i = index
                          ">
                  <!-- <td>{{i+1}}</td> -->
                  <!-- {{item.groupName | lowercase}}- -->

                  <td>{{ item.planname }}<br />({{ item.packagename }})</td>
                  <!-- <td>{{item.companyAmountUI}}</td>
                          <td>{{item.employeeAmountUI}}</td> -->
                  <td class="taxamount">
                    {{ currencySymbol }}{{ item.planPrice | number: "1.2-2" }}
                  </td>
                  <!-- <td>{{item.planCoverage}}</td> -->
                  <td class="taxamount">
                    <span *ngIf="item.gstCheck" class="gsttaxes">{{ item.gstPrice == 0 ? "-" : currencySymbol +
                      (item.gstPrice |
                      number: "1.2-2") + "&nbsp;(GST)" }}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{
                      item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                      number: "1.2-2") + "&nbsp;(PST)" }}</span><span *ngIf="item.hstCheck" class="gsttaxes">{{
                      item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                      number: "1.2-2") + "&nbsp;(HST)" }}</span><span *ngIf="
                                !item.gstCheck &&
                                !item.pstCheck &&
                                !item.hstCheck
                              ">-</span>
                  </td>
                  <td class="grandTotal">
                    {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                  </td>
                </tr>

                <tr>
                  <td>{{lang.Total}}</td>
                  <td colspan="2"></td>
                  <td class="grandTotal">
                    <b>{{ currencySymbol
                      }}{{ companyPaidTotal}}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        }

        <br />

        <!-- no use -->
        <div class="form-row" *ngIf="!singleSummaryTable && (companyCoveredPlans.length == 0 ? false : true)"
          class="form-row">
          <div class="form-group col-md-12">
            <label
              for="cardnumnber"><strong>{{lang.upgrade_plans_premium_difference_payroll_deduction}}34</strong></label>

            <div class="overflow-x-auto">
              <table class="table table-bordered text-black" id="customerPlansTable">
                <tbody>
                  <tr>
                    <!-- <th>S. no</th> -->
                    <th>{{lang.plan}}</th>
                    <!-- <th>Company Share</th>
                        <th>Employee Share</th> -->
                    <th class="taxamount">{{lang.amount}}<br>({{lang.company}}+{{lang.employee}})</th>
                    <!-- <td>Plan</td> -->
                    <th class="taxamount">{{lang.tax}}</th>
                    <th class="taxamount">{{lang.total}}</th>
                  </tr>
                  <ng-container *ngFor="
                      let item of companyCoveredPlans;
                      let i = index
                    ">
                    <tr class="main-details-ccplan-tr">

                      <td>{{i+1}}. {{ item.planname }} <br>({{ item.packagename }}) </td>
                      <td class="taxamount">
                        {{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                        }}
                      </td>
                      <td class="taxamount">
                        <span *ngIf="item.gstCheck" class="gsttaxes">{{ item.gstPrice == 0 ? "-" : currencySymbol +
                          (item.gstPrice |
                          number: "1.2-2") + "&nbsp;(GST)" }}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{
                          item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                          number: "1.2-2") + "&nbsp;(PST)" }}</span><span *ngIf="item.hstCheck" class="gsttaxes">{{
                          item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                          number: "1.2-2") + "&nbsp;(HST)" }}</span><span *ngIf="
                          !item.gstCheck &&
                          !item.pstCheck &&
                          !item.hstCheck
                        ">-</span>
                      </td>
                      <td class="grandTotal">
                        {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                      </td>
                    </tr>
                    <tr class="additional-details-ccplan-tr">
                      <!-- <td></td> -->
                      <td>Base Plan paid by company <br> {{item.companyCoveredBasePlan.planName}}</td>
                      <td>
                        Company share from base plan - <i
                          [innerHTML]="item.companyCoveredBasePlan.amount | number: '1.2-2'"></i>
                        <br> Employee share deducted from salary- <i
                          [innerHTML]="item.employeeDeductions.amount | number: '1.2-2'"></i>
                      </td>
                      <td>
                        Company share from base plan -
                        <!-- <i [innerHTML]="item.companyCoveredBasePlan.taxUI"></i>  -->
                        [{{item.companyCoveredBasePlan.tax}}]
                        <br> Employee share deducted from salary-
                        <!-- <i [innerHTML]="item.employeeDeductions.taxUI"></i> -->
                        [{{item.employeeDeductions.tax}}]
                      </td>
                      <td> Company share from base plan - <i
                          [innerHTML]="item.companyCoveredBasePlan.total | number: '1.2-2'"></i>
                        <br> Employee share deducted from salary- <i
                          [innerHTML]="item.employeeDeductions.total | number: '1.2-2'"></i>
                    </tr>
                  </ng-container>


                  <tr>
                    <td>{{lang.Total}}(All plans)</td>

                    <td class="grandTotal" colspan="3">
                      <b> {{ currencySymbol
                        }}{{ companyCoveredTotal | number: '1.2-2'}}</b>
                      <br />--------------------
                      <p>
                        <br> Company share from all base plans - {{ currencySymbol
                        }}{{companyCoveredCompanyShareTotal | number: '1.2-2'}}
                        <br> Employee share from all plans deducted from salary- {{ currencySymbol
                        }}{{companyCoveredEmployeeShareTotal | number: '1.2-2'}}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <br />
        <!-- no use -->
        @if(!singleSummaryTable && (EmployeeSelectedPlans.length == 0 ? false : true)){
        <div class="col-span-full">
          <label for="cardnumnber"><strong>{{lang.voluntary_plans__premium_paid_employee}}56</strong></label>

          <div class="overflow-x-auto">
            <table class="table table-bordered text-black" id="customerPlansTable">
              <tbody>
                <tr>
                  <!-- <th>S. no</th> -->
                  <th>{{lang.plan}}</th>
                  <!-- <th>Company Share</th>
                      <th>Employee Share</th> -->
                  <th class="taxamount">{{lang.amount}}(Employee)</th>
                  <!-- <td>Plan</td> -->
                  <th class="taxamount">{{lang.tax}}</th>
                  <th class="taxamount">{{lang.total}}</th>
                </tr>
                <tr *ngFor="
                        let item of EmployeeSelectedPlans;
                        let i = index
                      ">
                  <!-- <td>{{i+1}}</td> -->
                  <!-- {{item.groupName | lowercase}}- -->

                  <td>{{ item.planname }}<br />({{ item.packagename }})</td>
                  <!-- <td>{{item.companyAmountUI}}</td>
                      <td>{{item.employeeAmountUI}}</td> -->
                  <td class="taxamount">
                    {{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                    }}
                  </td>
                  <!-- <td>{{item.planCoverage}}</td> -->
                  <td class="taxamount">
                    <span *ngIf="item.gstCheck" class="gsttaxes">{{ item.gstPrice == 0 ? "-" : currencySymbol +
                      (item.gstPrice |
                      number: "1.2-2") + "&nbsp;(GST)" }}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{
                      item.pstPrice == 0 ? "-" : currencySymbol + (item.pstPrice |
                      number: "1.2-2") + "&nbsp;(PST)" }}</span><span *ngIf="item.hstCheck" class="gsttaxes">{{
                      item.hstPrice == 0 ? "-" : currencySymbol + (item.hstPrice |
                      number: "1.2-2") + "&nbsp;(HST)" }}</span><span *ngIf="
                            !item.gstCheck &&
                            !item.pstCheck &&
                            !item.hstCheck
                          ">-</span>
                  </td>
                  <td class="grandTotal">
                    {{ currencySymbol }}{{ item.totalPrice | number: "1.2-2" }}
                  </td>
                </tr>

                <tr>
                  <td>{{lang.Total}}</td>
                  <td colspan="2"></td>
                  <td class="grandTotal">
                    <b> {{ currencySymbol
                      }}{{ paidEmployeedTotal | number: "1.2-2" }}</b>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>

        }

        @if(singleSummaryTable && allSelectedPlans.length == 0 ? false : true){
        <div class="cols-span-full">
          <label for="cardnumnber"><strong>{{lang.All_selected_plans_summary}}</strong></label>

          <div class="overflow-x-auto">
            <table class="table table-bordered text-black" id="customerPlansTable">
              <tbody>
                <tr>
                  <!-- <th>S. no</th> -->
                  <th>{{lang.Plan}}</th>
                  <!-- <th>Company Share</th>
                          <th>Employee Share</th> -->
                  <th>{{lang.Type}}</th>
                  <th *ngIf="isMedcanPopUpSubmitted">{{lang.Units}}</th>
                  <th class="taxamount align-right">{{lang.Premium}}<br /> <span *ngIf="isMedcanPopUpSubmitted"
                      style="font-size: 10px;">(Per
                      unit)</span></th>
                  <!-- <td>Plan</td> -->
                  <!-- <th class="taxamount">Tax Percentage</th> -->

                  <th class="taxamount align-right">{{lang.Tax}}<br /> <span *ngIf="isMedcanPopUpSubmitted"
                      style="font-size: 10px;">(Per unit)</span>
                  </th>
                  <th class="taxamount align-right">{{lang.Total}}</th>
                </tr>
                <tr *ngFor="
                            let item of allSelectedPlans;
                            let i = index
                          "
                  [hidden]="(item.paidByCompany && currFormType === 'nhlaa') || hasUpgradePlans">
                    
                  <!-- <td>{{i+1}}</td> -->
                  <!-- {{item.groupName | lowercase}}- -->
                  <td *ngIf="item.isBundle==true;else productname">

                    <!-- ({{ item.packagename }}) -  -->
                    <span *ngIf="item.coveredByCompany==1;else noupgrade">{{ item.upgradeCalculation.planName }}</span>
                    <ng-template #noupgrade>{{item.planname}}</ng-template>

                  </td>

                  <ng-template #productname>
                    <td>
                      <!-- ({{ item.packagename }}) -  -->
                      <span *ngIf="item.coveredByCompany==1;else noupgrade1">{{ item.upgradeCalculation.planName
                        }}</span>
                      <ng-template #noupgrade1>{{item.planproductname}}</ng-template>
                    </td>
                  </ng-template>

                  <!-- <td>{{item.companyAmountUI}}</td>
                          <td>{{item.employeeAmountUI}}</td> -->
                  <td *ngIf="currFormType!='nhlaa'">{{item.type}}</td>
                  <td *ngIf="currFormType=='nhlaa'">Plan Upgrade</td>
                  <td *ngIf="isMedcanPopUpSubmitted">
                    <span
                      *ngIf="item.planLevel==15 && item.multiCountPlan==true;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                    <ng-template #defaultSubmitCheck>-</ng-template>
                  </td>
                  <td class="grandTotal amounts" *ngIf="employercheck">

                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">

                    <span *ngIf="item.coveredByCompany==1;else noupgradeprice">{{ currencySymbol }}{{
                      item.upgradeCalculation.combinedplanPrice | number: "1.2-2"}}</span>
                    <ng-template #noupgradeprice>{{ currencySymbol }}{{ item.planPrice | number: "1.2-2"
                      }}</ng-template>

                  </td>
                  <!-- <td>{{item.planCoverage}}</td> -->
                  <!-- <td>taxRateperecnatge&&taxtype</td> -->
                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="item.coveredByCompany==1;else noupgradetax">{{ currencySymbol }}{{
                      item.upgradeCalculation.combinedplanTax | number: "1.2-2"}}</span>
                    <ng-template #noupgradetax>{{ currencySymbol }}{{item.tax | number: "1.2-2"}}</ng-template>

                  </td>

                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="item.coveredByCompany==1;else noupgradetotal">{{ currencySymbol }}
                      {{
                      item.upgradeCalculation.combinedplanTotal
                      | number: "1.2-2"
                      }}
                    </span>
                    <ng-template #noupgradetotal>{{ currencySymbol }}
                      {{
                      item.totalPrice
                      | number: "1.2-2"
                      }}
                    </ng-template>

                  </td>
                </tr>

                <tr style="background-color: #4682b59c ;" [hidden]="hasUpgradePlans">
                  <td>{{lang.Total}}</td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td class="grandTotal amounts" *ngIf="employercheck">---</td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">{{ currencySymbol}}{{
                    allPlansAmountTotal |
                    number: "1.2-2" }}</td>
                  <td class="grandTotal amounts" *ngIf="employercheck">---</td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">{{ currencySymbol
                    }}{{allPlansTotaltax | number: "1.2-2"}}</td>
                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <b>{{ currencySymbol
                      }}{{ allPlansTotal | number: "1.2-2" }}</b>
                  </td>
                </tr>


                <!-- <tr>
                  <td>
                  <td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr> -->


                @if(!hidePlanCategorization){



                <tr style="background-color: black">
                  <td style="color:white">{{lang.Monthly_Payment_Summary}}
                  <td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                <tr *ngIf="companyDealingPlans.length == 0 ? false : true">
                  <td><b>{{lang.Company_Pays}}</b>
                  <td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr *ngFor="let companypay of companyDealingPlans">

                  <td>
                    <span
                      *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.compnayShareStatement}}</span>
                    <ng-template #normalname>
                      {{companypay.planname}}
                    </ng-template>

                  </td>
                  <td *ngIf="isdandjform">{{lang.Company_Pays}}</td>
                  <td *ngIf="!isdandjform">{{companypay.type}}</td>
                  <td *ngIf="isMedcanPopUpSubmitted">
                    <span
                      *ngIf="companypay.planLevel==15 && companypay.multiCountPlan==true;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                    <ng-template #defaultSubmitCheck>-</ng-template>
                  </td>



                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                      }}{{ companypay.upgradeCalculation.baseplanPrice | number: "1.2-2" }}</span>
                    <ng-template #normalamount>
                      {{ currencySymbol
                      }}{{ companypay.amount | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                      }}{{ companypay.upgradeCalculation.baseplanTax | number: "1.2-2" }}</span>

                    <ng-template #normaltax>
                      {{ currencySymbol
                      }}{{ companypay.tax | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts" *ngIf="employercheck">
                    ---
                  </td>
                  <td class="grandTotal amounts align-right" *ngIf="!employercheck">
                    <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                      <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.baseplanTotal | number: "1.2-2"
                        }}</b></span>

                    <ng-template #normaltotal>
                      <b>{{ currencySymbol
                        }}{{ companypay.total | number: "1.2-2" }}</b>
                    </ng-template>
                  </td>



                </tr>

                <ng-container *ngIf="payrolldeduction">
                  <tr *ngIf="payrolldeduction && payrollCCplansarr.length == 0 ? false : true">
                    <td><b>{{lang.Employee_pays_through_payroll_deduction}} </b>
                      <td>
                        <td *ngIf="isMedcanPopUpSubmitted"></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                </ng-container>
                <ng-container *ngIf="payrolldeduction">
                <tr *ngFor="let companypay of payrollCCplansarr">
                  <td>
                    <span
                      *ngIf="companypay.upgradeCalculation;else normalname">{{companypay.upgradeCalculation.employeeShareStatement}}</span>
                    <ng-template #normalname>
                      {{companypay.planname}}
                    </ng-template>

                  </td>
                  <td> <span *ngIf="isdandjform">Addition to </span>{{companypay.type}}</td>

                  <td *ngIf="isMedcanPopUpSubmitted">
                     <span
                      *ngIf="companypay.planLevel==15 && companypay.multiCountPlan==true;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                    <ng-template #defaultSubmitCheck>-</ng-template>
                  </td>

                  <td class="grandTotal amounts align-right">
                    <span *ngIf="companypay.upgradeCalculation;else normalamount">{{ currencySymbol
                      }}{{ companypay.upgradeCalculation.deltaplanPrice | number: "1.2-2" }}</span>
                    <ng-template #normalamount>
                      {{ currencySymbol
                      }}{{ companypay.amount | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts align-right">
                    <span *ngIf="companypay.upgradeCalculation;else normaltax">{{ currencySymbol
                      }}{{ companypay.upgradeCalculation.deltaplanTax | number: "1.2-2" }}</span>

                    <ng-template #normaltax>
                      {{ currencySymbol
                      }}{{ companypay.tax | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts align-right">
                    <span *ngIf="companypay.upgradeCalculation;else normaltotal">
                      <b>{{ currencySymbol}}{{ companypay.upgradeCalculation.deltaplanTotal | number: "1.2-2"
                        }}</b></span>

                    <ng-template #normaltotal>
                      <b>{{ currencySymbol
                        }}{{ companypay.total | number: "1.2-2" }}</b>
                    </ng-template>
                  </td>
                </tr>
                </ng-container>
           

                <tr style="background-color: #4682b59c" *ngIf="employercheck">

                  <td>{{lang.Total_charge_to_Company}}</td>
                  <td></td>
                  <td class="grandTotal amounts">---</td>
                  <td class="grandTotal amounts">---</td>
                  <td class="grandTotal amounts">
                    <b>---</b>


                  </td>
                </tr>
                <tr style="background-color: #4682b59c" *ngIf="!employercheck">

                  <td>{{lang.Total_charge_to_Company}}</td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td class="grandTotal amounts align-right">{{ currencySymbol
                    }}{{ companydealingplansTotal | number: "1.2-2" }}</td>
                  <td class="grandTotal amounts align-right">{{ currencySymbol
                    }}{{ companydealingplanstaxTotal | number: "1.2-2" }}</td>
                  <td class="grandTotal amounts align-right">
                    <b>{{ currencySymbol
                      }}{{ companydealingplansgrandTotal | number: "1.2-2" }}</b>


                  </td>
                </tr>
                <tr>
                  <td>
                  <td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted"></td>
                  <td></td>
                  <td></td>
                </tr>
              }
              @if(hasUpgradePlans){
                <tr *ngFor="let employeePay of employeeDealingPlansarr">

                  <td>
                    <!-- <span *ngIf="employeePay.upgradeCalculation;else normalname">{{employeePay.upgradeCalculation.compnayShareStatement}}</span> -->
                    <!-- <ng-template > -->
                    {{employeePay.planname}}
                    <!-- </ng-template> -->

                  </td>
                  <td *ngIf="currFormType!='nhlaa'">{{employeePay.type}}</td>
                  <td *ngIf="currFormType=='nhlaa'">Plan Upgrade</td>

                  <td *ngIf="isMedcanPopUpSubmitted">
                     <span
                      *ngIf="employeePay.planLevel==15 && employeePay.multiCountPlan==true;else defaultSubmitCheck">{{medcanSubmitCount}}</span>
                    <ng-template #defaultSubmitCheck>-</ng-template>
                  </td>

                  <td class="grandTotal amounts align-right">
                    <span *ngIf="employeePay.upgradeCalculation;else normalamount">{{ currencySymbol
                            }}{{ employeePay.upgradeCalculation.deltaplanPrice | number: "1.2-2" }}</span>
                    <ng-template #normalamount>
                    {{ currencySymbol
                    }}{{ employeePay.amount | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts align-right">
                    <span *ngIf="employeePay.upgradeCalculation;else normaltax">{{ currencySymbol
                            }}{{ employeePay.upgradeCalculation.deltaplanTax | number: "1.2-2" }}</span>

                    <ng-template #normaltax>
                    {{ currencySymbol
                    }}{{ employeePay.tax | number: "1.2-2" }}
                    </ng-template>
                  </td>
                  <td class="grandTotal amounts align-right">
                    <span *ngIf="employeePay.upgradeCalculation;else normaltotal">
                           <b>{{ currencySymbol}}{{ employeePay.upgradeCalculation.deltaplanTotal | number: "1.2-2" }}</b></span>

                    <ng-template #normaltotal >
                    <b>{{ currencySymbol
                      }}{{ employeePay.total | number: "1.2-2" }}</b>
                    </ng-template>
                  </td>
                </tr>
              }

                @if(iafgplansCheck.length>0){






                <ng-container *ngIf="formConfigResult.allstateCI;else defaultTemp">
                   <ng-container *ngFor="
                    let plan of planssummarymainLife;
                    let i = index">
                        <tr style="background-color:#ffff">
                          <td colspan="6">&nbsp;
                            {{plan.packagename}}
                          </td>
                        </tr>
                        <tr *ngFor="let product of plan.products;let j = index">
                          <td>&nbsp;
                            {{plan.name}}
                          </td>

                          <td class="align-center">
                            <span *ngIf="plan.coverage =='MEMBER'  || plan.coverage =='MEMBER & FAMILY' || plan.coverage =='MEMBER & SPOUSE';else placheck">
                              <span>
                                @if(plan.coverage =='MEMBER'){
                                  SINGLE
                                }
                                @else if(plan.coverage =='MEMBER & FAMILY'){
                                 COUPLE
                                }
                                @else{
                                {{lang.Member_Spouse}}
                                }
                              </span>
                            </span>
                            <ng-template #placheck>---</ng-template>

                          </td>
                          <td class="align-right">

                            <!-- <span>{{lang.MEMBER}}:</span> -->

                            <table class="table text-nowrap" style="font-size:12px">

                              <tbody>

                                  <tr class=" ">
                                  <td>
                                      Coverage
                                  </td>
                                  <td>
                                    @if(plan.member.defaultRange>=plan.member.maximumCoverageWithoutEvidence){
                                    {{plan.member.maximumCoverageWithoutEvidence | currency:"USD"}}
                                    }
                                    @else{
                                    {{plan.member.defaultRange | currency:"USD"}}
                                    }

                                  </td>

                                </tr>

                                <tr class=" ">
                                  <td *ngIf="showUnits"  class=" border-right">{{lang.Units}}</td>
                                  <td *ngIf="showUnits">({{plan.member.coverageValue/plan.member.standardUnits}})</td>

                                </tr>
                                <tr class=" ">
                                  <td class=" border-right">{{lang.Premium}}</td>
                                  <td>{{plan.member.amount | currency:"USD"}}</td>

                                </tr>
                                <tr class=" " *ngIf="showUnits">
                                  <td class=" border-right">
                                    {{lang.Amount}}
                                    </td>
                                  <td>
                                    @if(formConfigResult.allstateCI){
                                      {{plan.member.dynamicAmount | currency:"USD"}}
                                      }
                                      @else{
                                      {{plan.member.amount | currency:"USD"}}
                                      }
                                  </td>

                                </tr>
                              
                              </tbody>
                            </table>
                        <!-- {{product.calculatedTax.price  | currency:"USD"}}&nbsp; -->
                        </td>
                        <td class="align-right">
                          <!-- <strong>Member:</strong>

                        <table class="table text-nowrap" style="font-size:12px">

                          <tbody>


                            <tr class=" ">
                              <td class=" border-right">Tax</td>
                              <td>{{plan.member.tax | currency:"USD"}}</td>

                            </tr>
                          </tbody>
                        </table> -->

                          <!-- @if(plan.coverage =='MEMBER & SPOUSE'){

                        <strong>Spouse:</strong>
                        <table class="table text-nowrap" style="font-size:12px">

                          <tbody>

                            <tr class=" ">
                              <td class=" border-right">Tax</td>
                              <td>{{plan.spouse.tax | currency:"USD"}}</td>

                            </tr>

                          </tbody>
                        </table>

                  } -->
                          <tr>
                            <td>${{plan.member.tax | number : '1.2-2'}}</td>
                          <tr>
                            <!-- {{product.calculatedTax.tax  | currency:"USD"}}&nbsp; -->
                        </td>
                        <td class="align-right">
                          {{product.calculatedTax.total | currency:"USD"}}&nbsp;
                        </td>
                        </tr>
                   </ng-container>
                  </ng-container>

                  
                  <ng-template #defaultTemp>
                        <ng-container *ngFor="
                        let plan of iafgplansCheck;
                        let i = index">
                  <tr style="background-color:#ffff">
                    <td colspan="6">&nbsp;
                      <b>{{plan.packagename}}</b>
                    </td>
                  </tr>
                  <tr *ngFor="let product of plan.products;let j = index">
                    <td>&nbsp;
                      {{plan.name}}
                    </td>

                    <td class="align-center">
                      <span
                        *ngIf="plan.coverage =='MEMBER' || plan.coverage =='MEMBER & SPOUSE';else placheck">{{plan.coverage}}</span>
                      <ng-template #placheck>---</ng-template>

                    </td>
                    <td class="align-right">

                      <strong>{{lang.MEMBER}}:</strong>

                      <table class="table text-nowrap" style="font-size:12px">

                        <tbody>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Units}}</td>
                            <td>({{plan.member.coverageValue/plan.member.standardUnits}})</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Premium}}</td>
                            <td>{{plan.member.premium | currency:"USD"}}</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Amount}}</td>
                            <td>{{plan.member.amount | currency:"USD"}}</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Guarantee_Acceptance}}</td>
                            <td>
                              @if(plan.member.defaultRange>=plan.member.maximumCoverageWithoutEvidence){
                              {{plan.member.maximumCoverageWithoutEvidence | currency:"USD"}}
                              }
                              @else{
                              {{plan.member.defaultRange | currency:"USD"}}
                              }

                            </td>

                          </tr>
                          @if(plan.member.maximumCoverageWithoutEvidence>plan.member.defaultRange){
                          <tr class=" ">
                            <td class=" border-right">{{lang.Acceptance_pending_approval}}</td>
                            <td>

                              {{plan.member.maximumCoverageWithoutEvidence-plan.member.defaultRange | currency:"USD"}}



                            </td>

                          </tr>
                          }
                        </tbody>
                      </table>

                      @if(plan.coverage =='MEMBER & SPOUSE'){

                      <strong>{{lang.Spouse}}:</strong>
                      <table class="table text-nowrap" style="font-size:12px">

                        <tbody>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Units}}</td>
                            <td>({{plan.spouse.coverageValue/plan.spouse.standardUnits}})</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Premium}}</td>
                            <td>{{plan.spouse.premium | currency:"USD"}}</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Amount}}</td>
                            <td>{{plan.spouse.amount | currency:"USD"}}</td>

                          </tr>
                          <tr class=" ">
                            <td class=" border-right">{{lang.Guarantee_Acceptance}}</td>
                            <td>
                              @if(plan.spouse.defaultRange>=plan.spouse.maximumCoverageWithoutEvidence){
                              {{plan.spouse.maximumCoverageWithoutEvidence | currency:"USD"}}
                              }
                              @else{
                              {{plan.spouse.defaultRange | currency:"USD"}}
                              }

                            </td>

                          </tr>
                          @if(plan.spouse.maximumCoverageWithoutEvidence>plan.spouse.defaultRange){
                          <tr class=" ">
                            <td class=" border-right">{{lang.Acceptance_pending_approval}}</td>
                            <td>

                              {{plan.spouse.maximumCoverageWithoutEvidence-plan.spouse.defaultRange | currency:"USD"}}



                            </td>

                          </tr>
                          }
                        </tbody>
                      </table>

                      }
                  <tr>
                    @if(plan.coverage =='MEMBER & SPOUSE'){
                    <td>{{lang.Total}}:${{plan.member.amount+plan.spouse.amount | number : '1.2-2'}}</td>
                    }
                    @if(plan.coverage =='MEMBER'){
                    <td>{{lang.Total}}:${{plan.member.amount | number : '1.2-2'}}</td>
                    }
                  </tr>
                  <!-- {{product.calculatedTax.price  | currency:"USD"}}&nbsp; -->
                  </td>
                  <td class="align-right">
                    <!-- <strong>Member:</strong>

                            <table class="table text-nowrap" style="font-size:12px">

                              <tbody>


                                <tr class=" ">
                                  <td class=" border-right">Tax</td>
                                  <td>{{plan.member.tax | currency:"USD"}}</td>

                                </tr>
                              </tbody>
                            </table> -->

                    <!-- @if(plan.coverage =='MEMBER & SPOUSE'){

                            <strong>Spouse:</strong>
                            <table class="table text-nowrap" style="font-size:12px">

                              <tbody>

                                <tr class=" ">
                                  <td class=" border-right">Tax</td>
                                  <td>{{plan.spouse.tax | currency:"USD"}}</td>

                                </tr>

                              </tbody>
                            </table>

                      } -->
                    <tr>
                      @if(plan.coverage =='MEMBER & SPOUSE'){
                      <td>{{lang.Total}}:${{plan.member.tax | number : '1.2-2'}}</td>
                      }
                      @if(plan.coverage =='MEMBER'){
                      <td>{{lang.Total}}:${{plan.member.tax | number : '1.2-2'}}</td>
                      }
                    <tr>
                      <!-- {{product.calculatedTax.tax  | currency:"USD"}}&nbsp; -->
                  </td>
                  <td class="align-right">
                    {{product.calculatedTax.total | currency:"USD"}}&nbsp;
                  </td>
                  </tr>
                </ng-container>
                  </ng-template>






             
                }


                @if(!hidePlanCategorization || hasUpgradePlans){
                    <tr style="background-color: #4682b59c" *ngIf="hasUpgradePlans || !hidePlanCategorization">

                  <td>{{lang.Total}}</td>
                  <td></td>
                  <td *ngIf="isMedcanPopUpSubmitted">
                    
                  </td>

                  <td class="grandTotal amounts align-right">{{ currencySymbol
                    }}{{ empDirectpayPlanamountTotal | number: "1.2-2" }}</td>
                  <td class="grandTotal amounts align-right">{{ currencySymbol
                    }}{{ empDirectpayPlantaxTotal | number: "1.2-2" }}</td>
                  <td class="grandTotal amounts align-right">
                    <b>{{ currencySymbol
                      }}{{ empDirectpayPlangrandTotal | number: "1.2-2" }}</b>


                  </td>
                </tr>
                }

              
              </tbody>
            </table>
            <!-- <table>
                    <label>Monthly payment Sumamry</label>
                    <tr></tr>
                  </table> -->
          </div>
        </div>
        }


        @if(addbenificaryData.length>0){
        <label for="cardnumnber">{{lang.Beneficiary_Information}}</label>
        <div class="form-group col-md-12" style="padding:0px">
          <div class="overflow-x-auto"><table class="table table-bordered text-black" id="customerPlansTable">

            <tbody>
              <tr>
                <!-- <th>{{lang.Type}}</th> -->
                <!-- <th>{{lang.First_Name}}</th>
                <th>{{lang.Last_Name}}</th> -->
                <th>Name</th>
                <th>{{lang.Gender}}</th>
                <th>{{lang.Relation}}</th>
                <!-- <th>{{lang.Minor}}</th> -->
                <th>{{lang.Date_of_Birth}}</th>
                <!-- <th>{{lang.Contingent_First_Name}}</th>
                <th>{{lang.Contingent_Last_Name}}</th> -->
                <!-- <th>{{lang.Trustee_First_Name}}</th>
                <th>{{lang.Trustee_Last_Name}}</th>
                <th>Trustee Relation</th> -->
                <th>Trustee Name - Relation</th>
                <th>{{lang.Percentage}}</th>
                <th>{{lang.Action}}</th>
              </tr>

              <tr *ngFor="
                          let broker of addbenificaryData;
                          let i = index
                        " [ngClass]="{
                          orange: i % 2 == 0,
                          white: i % 2 != 0
                        }">

                <!-- <td>{{broker.customerType}}</td> -->

                <!-- <td>
                  {{broker.firstName}}
                </td>
                <td>
                  {{broker.lastName}}
                </td> -->
                <td>
                  {{broker.firstName + ' ' +broker.lastName}}
                </td>
                <td>
                  {{broker.gender}}
                </td>
                <!-- <td>
                  {{broker.relationship}}
                </td> -->
                <td>
                  @if(broker.relationship.toLowerCase()=="other"){
                  {{capitalize(broker.relationshipSpecific ?? '')}}
                  }@else{
                  {{capitalize(broker.relationship ?? '')}}
                  }
                </td>
                <!-- <td>
                  @if(broker.isMinor=="true"){
                  Yes
                  }@else{
                  No
                  }
                </td> -->

                <td>
                  @if(broker.dob==null){
                  NA
                  }@else{
                  {{broker.dob | displayDate}}
                  }
                </td>
                <!--
                <td>
                  {{broker.contingentFirstName}}
                </td>
                <td>
                  {{broker.contingentLastName}}
                </td> -->
                <!-- <td>

                  @if(broker.trusteeFirstName==""){
                  NA
                  }@else{
                  {{broker.trusteeFirstName}}
                  }

                </td>
                <td>
                  @if(broker.trusteeLastName==""){
                  NA
                  }@else{
                  {{broker.trusteeLastName}}
                  }
                </td>
                <td>
                  @if(broker.trusteeRelation==""){
                  NA
                  }@else{
                  {{broker.trusteeRelation}}
                  }
                </td> -->
                <td>
                  @if(broker.trusteeFirstName==""){
                  NA
                  }@else{
                  {{broker.trusteeFirstName+ ' '+broker.trusteeLastName + ' - '+broker.trusteeRelation}}
                  }
                </td>

                <td style="text-align:center">
                  {{broker.percentage}}%
                </td>

                <td class="thBottomNone text-center inline-flex items-center">
                  <svg class="h-10 w-10 text-green-600" (click)="editbenficiary($event, i, broker)"
                    *ngIf="enableEditIndex != i" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                    <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                    <line x1="16" y1="5" x2="19" y2="8" />
                  </svg>
                  <svg class="h-9 w-9 text-red-600" (click)="deleteBenficiary(broker, i)" *ngIf="enableEditIndex != i"
                    width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="3" y="4" width="18" height="4" rx="2" />
                    <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" />
                    <line x1="10" y1="12" x2="14" y2="12" />
                  </svg>


                </td>

              </tr>
            </tbody>
          </table></div>



        </div>

        }

        <!-- no use -->
        @if(alloptinplans && alloptinplans.length == 0 ? false : true){
        <div class="col-span-full">
          <label for="cardnumnber"><strong>{{lang.opt_in_plans_summary}}90</strong></label>

          <div class="overflow-x-auto">
            <table class="table table-bordered text-black" id="customerPlansTable">
              <tbody>
                <tr>
                  <!-- <th>S. no</th> -->
                  <th>{{lang.plan}}</th>
                  <th>{{lang.details}}</th>
                  <!-- <th class="taxamount"> Amount</th>

                  <th class="taxamount">Tax</th>
                  <th class="taxamount">Total</th> -->
                </tr>
                <tr *ngFor="
                        let item of alloptinplans;
                        let i = index
                      ">
                  <!-- <td>{{i+1}}</td> -->
                  <!-- {{item.groupName | lowercase}}- -->

                  <td>
                    {{ item.planname }}<br />({{
                    item.packagename
                    }})
                  </td>
                  <td>{{ item.details }}</td>
                  <!-- <td class="taxamount">{{currencySymbol}}{{item.planPrice | number : '1.2-2'}}</td>

                  <td class="taxamount"><span *ngIf="item.gstCheck" class="gsttaxes">{{item.gstPrice==0?"-":"(GST)&nbsp;"+currencySymbol+(item.gstPrice | number : '1.2-2')}}</span><span *ngIf="item.pstCheck" class="gsttaxes">{{item.pstPrice==0?"-":"(PST)&nbsp;"+currencySymbol+(item.pstPrice | number : '1.2-2')}}</span><span *ngIf="item.hstCheck"  class="gsttaxes">{{item.hstPrice==0?"-":"(HST)&nbsp;"+currencySymbol+(item.hstPrice | number : '1.2-2')}}</span><span *ngIf="!item.gstCheck && !item.pstCheck && !item.hstCheck ">-</span></td>
                  <td class="grandTotal">{{currencySymbol}}{{item.totalPrice | number : '1.2-2'}}</td> -->
                </tr>

                <tr>
                  <!-- <td>Total </td><td colspan="2"></td><td class="grandTotal">{{currencySymbol}}0.00</td> -->
                </tr>
                <!-- <tr>
                  <td colspan="3">

                  </td>
                  <td colspan="2" class="grandTotal">Total:&nbsp;{{currencySymbol}}{{planAmount | number : '1.2-2'}}</td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
        }


        <br />
        @if(!hideCompanyPaidPlans){

          <div class="col-span-full">
            <input type="checkbox" name="comanyprovided" value="true"
              (change)="companyPlansConfirmation($event)" />&nbsp;<span
              class="termsandconditions">{{lang.I_confirm_signing_up_for_the_benefits_plan_provided_by_the_company || 'I confirm signing up for the benefits plan provided by the company'}}
            </span>
            @if (companyplansCheck) {
            <div class="invalid text-red-500">{{lang.Please_confirm_Company_paid_plans}}</div>
            }
          </div>
        }
        @if(payrollCCplansarr.length>0 && payrolldeduction){
        <div class="col-span-full">
          <input type="checkbox" name="upgradeplans" value="true"
            (change)="upgradeplansConfirmation($event)" />&nbsp;<span
            class="termsandconditions">{{lang.I_confirm_upgrading_my_benefit_plans_and_acknowledge_that_the_difference_between_the_plans_paid_by_the_company_and_my_selection_will_deducted_on_my_pay_check}}
          </span>
          @if (upgradeplansCheck) {
          <div class="invalid text-red-500">{{lang.Please_confirm_Upgrade_plans}}</div>
          }
        </div>
        }

        @if(!hidePlanCategorization && showPaymenthMethod && EmployeeSelectedPlans.length>0 && directpayCCplansarr.length==0 ||
        iafgplansCheck.length>0){
        <div class="col-span-full">
          <input type="checkbox" name="voluntary" value="true"
            (change)="voluntryplansConfirmation($event)" />&nbsp;<span
            class="termsandconditions">{{lang.I_confirm_enrolling_into_voluntary_opt_ins_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below || 'I confirm enrolling into voluntary opt-ins and charge monthly premiums to Credit Card or PAD as per data below'}}
          </span>
          @if (voluntryplansCheck) {
          <div class="invalid text-red-500">{{lang.Please_confirm_voluntary_plans}}</div>
          }
        </div>
        }

        @if(!hidePlanCategorization && showPaymenthMethod && EmployeeSelectedPlans.length==0 && directpayCCplansarr.length>0){
        <div class="col-span-full">
          <input type="checkbox" name="voluntary" />&nbsp;<span class="termsandconditions">
            {{lang.I_confirm_enrolling_into_Upgrade_plans_split_amount_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below || 'I confirm enrolling into Upgrade plans split amount and charge monthly premiums to Credit Card or PAD as per data below'}}
          </span>
        </div>
        }
        @if(!hidePlanCategorization && showPaymenthMethod && EmployeeSelectedPlans.length>0 && directpayCCplansarr.length>0){
        <div class="col-span-full">
          <input type="checkbox" name="voluntary" />&nbsp;<span
            class="termsandconditions">{{lang.I_confirm_enrolling_into_voluntary_opt_ins_and_charge_monthly_premiums_to_Credit_Card_or_PAD_as_per_data_below || 'I confirm enrolling into voluntary opt-ins and charge monthly premiums to Credit Card or PAD as per data below'}}
          </span>
        </div>
        }
        <div class="col-span-w-1/2" [hidden]="showPaymenthMethod">
          <label for="cardnumnber">{{lang.Signature}}<span style="color: red">*</span></label>

          <div class="signature-container sm:w-1/4" style="border:1px solid #ccc;border-radius: 4px;">

            <signature-pad [options]="signaturePadOptions" (touchmove)="onMouseMove($event)"
              (mousemove)="onMouseMove($event)" (onEndEvent)="drawComplete()"
              (onBeginEvent)="drawStart()"></signature-pad>
            @if(signaturecheckvalue1cc){
            <div style="
                left: 10px;
                color: red;
                text-decoration: underline;cursor:pointer">
              <p (click)="clearSignature()">x {{lang.Clear}}</p>
            </div>
            }
            <!-- <canvas
#sigplanconf
(mousedown)="onMouseDownplan($event)"   (touchstart)="onMouseDownplan($event)" (touchmove)="onMouseMoveplan($event)"
(mousemove)="onMouseMoveplan($event)" required
></canvas>
              <div
                *ngIf="signaturecheckvalue1PlansConfirmation"
                style="
                  position: absolute;
                  top: 32px;
                  left: 20px;
                  color: red;
                  text-decoration: underline;
                  cursor: pointer;
                ">
                <p (click)="clearPadPlansConfirmation()">x {{lang.clear || "Clear"}}</p>
              </div>

              <span class="help-block text-danger" *ngIf="signaturemessagePlansConfirmation"
                >{{lang.please_sign_the_signature}}</span
              > -->
            <!-- <span
            class="help-block text-danger"
            *ngIf="signaturemessageccconfirm">Please confirm the signature</span
          > -->
          </div>

          <br />
          <!-- <form class="signbtn" *ngIf="signaturecheckvaluePlansConfirmation">
            </form> -->
        </div>





        <!-- RIGHT column ends -->
      </div>

      <!-- LEFT: Payment method (48%) -->
      <div class="w-full sm:w-[48%] order-1">
      @if(showPaymenthMethod){
      <div class="">
        <div class="">
          @if(EmployeeSelectedPlans.length>0 && directpayCCplansarr.length==0 && !hidePlanCategorization){
          {{lang.Voluntary_Opt_ins_Payment || 'Voluntary Opt-ins Payment'}} : {{lang.Total || 'Total'}} ({{currencySymbol}}{{cartDisplayAmount}})
          }
          @if(EmployeeSelectedPlans.length==0 && directpayCCplansarr.length>0 && !hidePlanCategorization){
          {{lang.Upgrade_plans || 'Upgrade Plans'}} : {{lang.Total}} ({{currencySymbol}}{{DirectCCpayPlangrandTotal}})
          }
          @if(EmployeeSelectedPlans.length>0 && directpayCCplansarr.length>0 && !hidePlanCategorization){
          {{lang.Voluntary_Opt_ins_Payment}} & {{lang.Upgrade_plans}} : {{lang.Total}}
          {{currencySymbol}}{{empDirectpayPlangrandTotal}} ({{currencySymbol}}{{cartDisplayAmount}} +
          {{currencySymbol}}{{DirectCCpayPlangrandTotal}})
          }
          <form [formGroup]="paymentForm" #paymentformCC
            action="https://payments.subscriptionplatform.com/v2/payments/create" method="post">
            <!-- <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4 p-4 "  > -->

            <div class="col-span-1">
              <input class="form-control" autofocus="autofocus" id="CustomerId" formcontrolname="cutomerId"
                name="CustomerID" type="hidden" value="{{ customerid }}" />
            </div>
            <div class="col-span-1">
              <input class="form-control" id="PublicApiKey" formcontrolname="PublicApiKey" name="PublicApiKey"
                type="hidden" value="{{ publicapikey }}" />
            </div>

            <div class="col-span-1">
              <input class="form-control" id="SuccessUri" formcontrolname="SuccessUri" name="SuccessUri" type="hidden"
                value="{{ paymentsuccessuri }}" />
            </div>

            <div class="col-span-1">
              <input class="form-control" id="FailUri" formcontrolname="FailUri" name="FailUri" type="hidden"
                value="{{ paymentUri }}" />
            </div>

            <div class="col-span-1">
              <input class="form-control" id="MakeDefault" placeholder="Name on the card" value="true" type="hidden"
                name="MakeDefault" />
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">

              <div class="col-span-3" *ngIf="!hidePlanCategorization">
                <label for="Email" class="labeling">{{ lang.Email }}<span style="color: red">*</span></label>

                <input class="form-control" id="Email" placeholder={{lang.Email}} type="hidden" name="email"
                  [(ngModel)]="paymentemail" [ngModelOptions]="{standalone: true}" value="{{paymentemail}}" />
                <input class="form-control" id="Email" placeholder="{{ lang.Email }}" type="email" readonly
                  formControlName="email" [(ngModel)]="paymentemail" value="{{paymentemail}}" />


              </div>

              <div class="col-span-3">
                <div>
                  <label for="cardnumnber" class="labeling">{{ lang.Payment_Method }}</label>
                </div>
                <div class="flex items-center space-x-2">
                  <input type="radio" id="pad_payment" formControlName="paymentRadioCheck" value="PAD"
                    class="form-radio text-blue-600" (click)="paymentmethod($event)" />
                  <!-- <label for="true" class="labeling">{{
                  lang.Pre_authorized_Debit
                }}</label> -->
                  <label for="pad_payment" class="labeling">Pre Authorized Debit</label>
                </div>

                <div class="flex items-center space-x-2">
                  <input type="radio" id="cc_payment" formControlName="paymentRadioCheck"
                    [checked]="bankpaymentmethod === 'CC'" value="CC" class="form-radio text-blue-600"
                    (click)="paymentmethod($event)" />
                  <label for="cc_payment" class="labeling">{{
                    lang.Credit_Card
                    }}</label>
                </div>
              </div>
            </div>

            @if(paymentForm.get('paymentRadioCheck')?.value === 'CC')
            {
            <div
              class="grid grid-cols-1 sm:grid-cols-3 gap-1 border-[1px] border-indigo-700 backdrop-blur-sm rounded-xl px-2 py-2">
              <!-- <span class="bg-gradient-to-r from-[#d5dfe1] to-[#616874] rounded-xl px-4 py-8 w-3/4"> -->
              <div class="col-span-3 sm:col-span-1">
                <label for="firstname" class="labeling"> {{ lang.First_Name
                  }}<span style="color: red">*</span></label>
                <input class="form-control" id="firstname" placeholder={{lang.First_Name}} name="FirstName"
                  type="hidden" [value]="paymentFirstName" [(ngModel)]="paymentFirstName"
                  [ngModelOptions]="{standalone: true}" />
                <input class="form-control" id="firstname" placeholder={{lang.First_Name}} formControlName="FirstName"
                  type="text" [(ngModel)]="paymentFirstName" (keypress)="alphabatesOnly($event)" />
                @if (payment['FirstName'].errors &&
                payment['FirstName'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['FirstName'].errors?.['required']) {
                  <div>{{ lang.Please_enter_first_name }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="lastname" class="labeling">{{ lang.Last_Name
                  }}<span style="color: red">*</span></label>
                <input class="form-control" id="lastName" placeholder={{lang.Last_Name}} name="LastName" type="hidden"
                  [value]="paymentLastName" [ngModelOptions]="{standalone: true}" [(ngModel)]="paymentLastName" />
                <input class="form-control" id="LastName" placeholder={{lang.Last_Name}} formControlName="LastName"
                  type="text" [(ngModel)]="paymentLastName" (keypress)="alphabatesOnly($event)" />
                @if (payment['LastName'].errors &&
                payment['LastName'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['LastName'].errors?.['required']) {
                  <div>{{ lang.Please_enter_last_name }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-2">
                <label for="CardNumber" class="labeling">{{ lang.Card_Number
                  }}<span style="color: red">*</span></label>
                <div class="flex items-center gap-2">
                  <input class="form-control" id="CardNumber" placeholder="{{ lang.cardnumnber || 'Card Number' }}" name="CardNumber"
                    formControlName="CardNumber" (input)="creditcardlblurmethod($event)" (keypress)="
                          ($event.charCode >= 48 && $event.charCode < 58)
                        " />
                  @if(cardType){
                  <img class="w-16 h-10 animate-pulse flex-shrink-0" src={{cardType}} />
                  }
                </div>

                @if (payment['CardNumber'].errors &&
                payment['CardNumber'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['CardNumber'].errors?.['required']) {
                  <div>{{ lang.Please_enter_card_Number }}</div>
                  } @if
                  (payment['CardNumber'].errors?.['invalidcreditcarddetails'])
                  {
                  <div>{{ lang.Please_enter_valid_Card_number }}</div>
                  }
                  @else{
                  @if(invalidcreditcard==true){

                  <div class="invalid text-red-500">
                    {{ lang.Please_enter_valid_Card_number }}
                  </div>

                  }
                  }
                </div>
                }
              </div>
              <div class="col-span-1"></div>
              <div class="col-span-3 sm:col-span-1">
                <label for="ExpirationMonth" class="labeling">{{ lang.Expiry_month || 'Expiry Month'
                  }}<span style="color: red">*</span></label>

                <select class="form-control" id="ExpirationMonth" name="ExpirationMonth"
                  (change)="filterExpiryDate($event)" formControlName="ExpirationMonth" placeholder="MM">
                  <option value="" disabled selected>
                    {{ lang.Select }}
                  </option>
                  <option value="01">Jan</option>
                  <option value="02">Feb</option>
                  <option value="03">Mar</option>
                  <option value="04">April</option>
                  <option value="05">May</option>
                  <option value="06">June</option>
                  <option value="07">July</option>
                  <option value="08">Aug</option>
                  <option value="09">Sept</option>
                  <option value="10">Oct</option>
                  <option value="11">Nov</option>
                  <option value="12">Dec</option>
                </select>
                @if (payment['ExpirationMonth'].errors &&
                payment['ExpirationMonth'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['ExpirationMonth'].errors?.['required']) {
                  <div>{{ lang.Please_Select_Expiry_Month }}</div>
                  } @if (payment['ExpirationMonth'].errors?.['min']) {
                  <div>minim</div>
                  } @if (payment['ExpirationMonth'].errors?.['max']) {
                  <div>maxmim</div>
                  }
                </div>
                }
                <!-- @if (payment['ExpirationMonth'].errors?.['invalidcreditcarddetails']) {
                                        <div>{{ lang.please_enter_valid_credit_card }}</div>
                                        } -->
                <!-- <span
                                      class="help-block text-danger"
                                      *ngIf="
                                        paymentForm.get('ExpirationMonth').touched &&
                                        paymentForm
                                          .get('ExpirationMonth')
                                          .hasError('required')
                                      "
                                      >{{lang.please_select_expiry_month}}</span
                                    >

                                    <span
                                      class="help-block text-danger"
                                      *ngIf="showexpirymontherror"
                                      >{{lang.please_enter_valid_expiry_month}}</span
                                    > -->
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="ExpirationYear" class="labeling">{{ lang.Expiry_Year
                  }}<span style="color: red">*</span></label>

                <select class="form-control" id="ExpirationYear" placeholder="YY" name="ExpirationYear"
                  (change)="filterExpiryDate($event)" formControlName="ExporationYear">
                  <option value="" disabled selected>
                    {{ lang.Select }}
                  </option>
                  <option *ngFor="let item of [].constructor(40); let i = index" value="{{ i + 25}}">
                    {{ i + 2025 }}
                  </option>
                </select>
                @if (payment['ExporationYear'].errors &&
                payment['ExporationYear'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['ExporationYear'].errors?.['required']) {
                  <div>{{ lang.Please_Select_Expiry_Year }}</div>
                  } @if (payment['ExporationYear'].errors?.['expiryDate']) {
                  <div>cant minimminim</div>
                  }
                </div>
                }
                <!-- <span
                                      class="help-block text-danger"
                                      *ngIf="
                                        paymentForm.get('ExporationYear').touched &&
                                        paymentForm.get('ExporationYear').hasError('required')
                                      "
                                      >{{lang.please_select_expiry_year}}</span
                                    >

                                    <span
                                      class="help-block text-danger"
                                      *ngIf="showexpiryyearerror"
                                      >{{lang.please_enter_valid_expiry_year}}</span
                                    > -->
              </div>

              <div class="col-span-3 sm:col-span-1">
                <label for="Cvv" class="labeling">{{ lang.CVV }}<span style="color: red">*</span></label>

                <input class="form-control" id="Cvv" placeholder={{lang.CVV}} name="Cvv" formControlName="cvv"
                  maxlength="4" (keypress)="
                        ($event.charCode >= 48 && $event.charCode < 58)
                      " />
                @if (payment['cvv'].errors && payment['cvv'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['cvv'].errors?.['required']) {
                  <div>{{ lang.Please_enter_cvv }}</div>
                  } @if (payment['cvv'].errors?.['minlength']) {
                  <div>{{ lang.CVV_must_be_3_or_4_digits }}</div>
                  }
                </div>
                }
              </div>


              @if(invalidCardDetails){
              <div class="col-span-3">
                <span class="invalid text-red-500">{{lang.Please_enter_the_correct_Month_and_Year}}</span>
              </div>
              }
            </div>

            <!-- </span> -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
              <div class="col-span-3" style="margin-top: 10px; margin-bottom: 10px; display: flex; align-items: flex-start;">
                <input type="checkbox" (click)="homeaddresscheckCC($event)" id="home_address" />&nbsp;
                <span class="paymentaddress labeling" for="home_address">{{
                  lang.Home_Address_same_as_billing_Address }}
                </span>
              </div>

              <div class="col-span-3 sm:col-span-1">
                <label for="Address1" class="labeling">{{ lang.Street_Address
                  }}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="Address1" placeholder={{lang.Street_Address}}
                  formControlName="streetaddress" autocomplete="off" />
                <input type="hidden" name="Address1" />
                @if (payment['streetaddress'].errors &&
                payment['streetaddress'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['streetaddress'].errors?.['required']) {
                  <div>{{ lang.Please_enter_Street_Address }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="Address2" class="labeling">{{ lang.Street_Address_Line_2 }}<span></span></label>
                <input type="text" class="form-control" id="Address2" formControlName="streetaddressline2"
                  autocomplete="off" placeholder={{lang.Street_Address_Line_2}} />
                <input type="hidden" name="Address2" />
              </div>
              <div class="col-span-3 sm:col-span-1"></div>

              <div class="col-span-3 sm:col-span-1">
                <label for="City" class="labeling">{{ lang.City }}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="City" placeholder={{lang.City}}
                  formControlName="city" />
                <input type="hidden" name="City" />
                @if (payment['city'].errors && payment['city'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['city'].errors?.['required']) {
                  <div>{{ lang.Please_enter_City }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="StateId" class="labeling">{{ lang.Province }}<span style="color: red">*</span></label>

                <select class="form-control" id="StateId" placeholder="select" formControlName="province"
                  (change)="provincelistCreditPayment($event)" autocomplete="off">
                  <option value="">{{ lang.Select }}</option>
                  <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                    {{ name.shortName }}
                  </option>
                </select>

                <input type="hidden" name="StateId" />

                @if (payment['province'].errors && payment['province'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['province'].errors?.['required']) {
                  <div>{{ lang.Please_select_Province }}</div>
                  }
                </div>
                }
              </div>
              <div class="col-span-3 sm:col-span-1">
                <label for="PostalZip" class="labeling">{{ lang.Postal_Code }}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="PostalZip" formControlName="postalcode"
                  autocomplete="off" placeholder={{lang.Postal_Code}}
                  (input)="changeTextToUppercaseCreditPayment('postalcode',$event)" />
                <input type="hidden" name="PostalZip" />

                @if (payment['postalcode'].errors && payment['postalcode'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['postalcode'].errors?.['required']) {
                  <div>{{ lang.Please_enter_postal_code }}</div>
                  }
                </div>
                } @if (creditCradInvalidProvince==true) {
                <div class="invalid text-red-500">
                  {{ lang.Please_enter_valid_postal_code }}
                </div>
                }
              </div>
              <div class="col-span-3">
                <label for="signature" class="labeling">{{ lang.Signature }}<span style="color: red">*</span></label>

                <div class="signature-container sm:w-1/2" style="border:1px solid #ccc;border-radius: 4px;">

                  <!-- <button class="btn btn-primary btn-inline" (click)="clearPadcc()" [disabled]="signaturecheckvalue1cc">Clear</button> -->

                  <!-- <canvas
                #canvascc
                (touchstart)="startDrawingcc($event)"
                (touchmove)="movedcc($event)"
                (click)="signaturestartcc($event)" required
              ></canvas> -->

                  <signature-pad [options]="signaturePadOptions" #signaturePad1 (touchmove)="onMouseMoveCredit($event)"
                    (mousemove)="onMouseMoveCredit($event)" (onEndEvent)="drawCompleteCC()"
                    (onBeginEvent)="drawStartCC()"></signature-pad>
                  @if(signaturecheckCC){
                  <div style="
              left: 10px;
              color: red;
              text-decoration: underline;cursor:pointer">
                    <p (click)="clearSignatureCC()">x {{lang.Clear}}</p>
                  </div>
                  }




                </div>
                @if(signaturemessagecc){
                <span class="invalid text-red-500">{{lang.Please_Sign_the_Signature}}</span>
                }
              </div>
              <div class="col-span-3">
                <re-captcha (resolved)="resolved($event)" formControlName="recaptchaReactive"
                  siteKey="{{ fusbillinfocaptchavalue }}">
                </re-captcha>

                <input id="recaptcha_token" type="hidden" name="recaptcha_token" [value]="recaptchaResponse" />
                @if (payment['recaptchaReactive'].errors &&
                payment['recaptchaReactive'].touched) {
                <div class="invalid text-red-500">
                  @if (payment['recaptchaReactive'].errors?.['required']) {
                  <div>{{ lang.Please_Check_re_Captcha_Validation }}</div>
                  }
                </div>
                }
              </div>
            </div>

            }

          </form><!-- closes paymentForm (CC) -->

             @if(paymentForm.get('paymentRadioCheck')?.value === 'PAD')
            {
            <form [formGroup]="bankpayForm" #bankForm="ngForm">
              <!-- <div class="grid grid-cols-1 sm:grid-cols-6 gap-2"> -->
              <!-- style="max-width:90px;margin-left:5px" -->

              <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                <div class="col-span-3 sm:col-span-1">
                  <!-- <label for="cardnumnber"
                      >{{ lang.Bank_Code }}<span style="color: red">*</span></label
                    > -->
                  <label for="banknumber" class="labeling">Bank Code<span style="color: red">*</span></label>
                  <input class="form-control checking-field" id="banknumber" placeholder={{lang.Bank_Code}}
                    name="banknumber" autocomplete="off" formControlName="banknumber" maxlength="3"
                    (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />

                  @if (bankpay['banknumber'].errors &&
                  bankpay['banknumber'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['banknumber'].errors?.['required']) {
                    <div>{{ lang.Please_enter_bank_code }}</div>
                    }
                    @if (bankpay['banknumber'].errors?.['checkbanknumbervalidator']) {
                    <div>{{ lang.Bank_code_must_be_3_digits }}</div>
                    }
                  </div>
                  }

                </div>
                <!-- style="max-width:120px;" -->
                <div class="col-span-3 sm:col-span-1">
                  <label for="branch" class="labeling">{{ lang.Transit_Number || 'Transit Number'
                    }}<span style="color: red">*</span></label>
                  <!-- (input)="credit_card_number($event)" -->
                  <input class="form-control checking-field" id="branch" placeholder={{lang.Transit_Number}}
                    name="branch" formControlName="transitnumber" autocomplete="off" maxlength="5"
                    (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  @if (bankpay['transitnumber'].errors &&
                  bankpay['transitnumber'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['transitnumber'].errors?.['required']) {
                    <div>{{ lang.Enter_Transit_Number }}</div>
                    }
                    @if (bankpay['transitnumber'].errors?.['checktransitnumbervalidator']) {
                    <div>{{ lang.Transit_Number_must_be_5_digits }}</div>
                    }
                  </div>
                  }

                </div>
                <div class="col-span-3 sm:col-span-1">
                  <label for="accountnumber" class="labeling">{{ lang.Account_Number
                    }}<span style="color: red">*</span></label>
                  <!-- (input)="credit_card_number($event)" -->
                  <input class="form-control checking-field" id="accountnumber" placeholder={{lang.Account_Number}}
                    autocomplete="off" name="accountnumber" formControlName="accountnumber" maxlength="12"
                    (input)="touchedmsg()" (keypress)="($event.charCode >= 48 && $event.charCode < 58)" />
                  @if (bankpay['accountnumber'].errors &&
                  bankpay['accountnumber'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['accountnumber'].errors?.['required']) {
                    <div>{{ lang.Enter_Account_Number }}</div>
                    }
                    @if (bankpay['accountnumber'].errors?.['checkaccountnumbervalidator']) {
                    <div>{{ lang.Account_Number_must_be_5_12_digits }}</div>
                    }
                  </div>
                  }


                </div>
                @if(bankerrormsg){
                <div class="col-span-3 invalid text-red-500 ">{{bankerrormsg}}</div>
                }


                 <div class="col-span-3" style="margin-top: 8px;">
                  @if(verifybankdetails && verifybutton){
                  <button type="submit"
                    class="w-36 h-14 mb-1 rounded-full border-[1px] border-indigo-700 bg-white p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white hover:border-green-500"
                    (click)="verifybank()">
                    {{lang.Verify}}
                  </button>&nbsp;

                  }

                  @if(verifybankdetails){

                  <button type="submit"
                    class="w-36 h-14 mb-1 rounded-full border-[1px] border-indigo-700 bg-gray-200 p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white"
                    (click)="checkbankdetails($event)">
                    {{lang.Reset}}
                  </button>
                  }


                  <!-- <form class="signbtn">
                      <button class="btn btn-primary btn-inline"  *ngIf="(verifybankdetails && verifybutton)"  (click)="verifybank()" style="margin-left:5px">{{lang.verify}}</button>
                      <button class="btn btn-primary btn-inline" *ngIf="verifybankdetails"  id="no" value="no" (click)="checkbankdetails($event)" >{{lang.reset}}</button>
                    </form>
                    <div class="clearfix"></div> -->


                  <!-- <span *ngIf="(bankdetailsverify && verifybankdetails)"  class="help-block text-danger" style="margin-top:20px;margin-left:10px">{{lang.please_verify_the_bank_details}}</span> -->

                </div>

                <div class="col-span-3">
                  <label for="bankname" class="labeling">{{ lang.Bank_Details }}</label>
                  <!-- (input)="credit_card_number($event)" -->
                  <textarea class="form-control" id="bankname" placeholder="{{ lang.bank_details }}" name="bankname"
                    formControlName="bankname" style="color: rgba(85, 85, 85, 0.9)" [ngModel]="banknameres"
                    rows="2"></textarea>
                  @if (bankpay['bankname'].errors &&
                  bankpay['bankname'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['bankname'].errors?.['required']) {
                    <div>{{ lang.Please_verify_the_bank_details }}</div>
                    }

                  </div>
                  }


                </div>


               


                <div class="col-span-3">
                  <label for="uploadvoidChequeNhlaa">{{ lang.Upload_Void_Cheque
                    }}<span style="color: red">*</span></label>

                  <!-- Hidden native input — keeps formControlName for Angular validation -->
                  <input #voidInputNhlaa type="file" id="uploadvoidChequeNhlaa"
                    formControlName="voidcheck"
                    (change)="voidcheckupload($event)"
                    accept=".jpg,.jpeg,.png,.pdf"
                    style="display:none" />

                  <!-- Custom upload button row -->
                  <div class="void-upload-row">
                    <button type="button" class="void-upload-btn" (click)="voidInputNhlaa.click()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                      </svg>
                      {{ lang.Choose_file || 'Choose file' }}
                    </button>
                    <span class="void-upload-filename">{{ voidCheckFileDisplayName || (lang.No_file_selected || 'No file selected') }}</span>
                  </div>

                  @if (bankpay['voidcheck'].errors && bankpay['voidcheck'].touched) {
                  <div class="invalid text-red-500">
                    @if (bankpay['voidcheck'].errors?.['required']) {
                    <div>{{ lang.Please_Upload_Void_Cheque_file }}</div>
                    }
                  </div>
                  }

                  @if(imagedisplay){
                  <div class="void-card-preview" (click)="showvoidcheckpreview()" title="Click to enlarge">
                    @if(normalview){
                    <img [src]="imagedisplay" class="void-card-img" alt="Void Cheque" />
                    }
                    @if(pdfview){
                    <div class="void-card-pdf">
                      <svg xmlns="http://www.w3.org/2000/svg" class="void-card-pdf-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM13 3.5L18.5 9H13V3.5zM9 13h6v1H9v-1zm0 3h6v1H9v-1zm0-6h2v1H9v-1z"/>
                      </svg>
                      <span class="void-card-pdf-name">PDF Document</span>
                      <small class="void-card-pdf-hint">{{ lang.Click_to_view_full_document || 'Click to view full document' }}</small>
                    </div>
                    }
                    <span class="void-card-enlarge-pill">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                      </svg>
                      <!-- {{ lang.Click_to_enlarge || 'Click to enlarge' }} -->
                    </span>
                  </div>
                  }
                </div>

                <!-- Home address same as billing hidden + auto-checked for PAD -->
                <input type="hidden" formControlName="bankstreetaddress" />
                <input type="hidden" formControlName="bankstreetaddressline2" />
                <input type="hidden" formControlName="bankcity" />
                <input type="hidden" formControlName="bankprovince" />
                <input type="hidden" formControlName="bankpostalcode" />


                <div class="col-span-3">
                  <label for="signature" class="labeling">{{ lang.Signature }}<span style="color: red">*</span></label>

                  <div class="signature-container sm:w-1/2" style="border:1px solid #000000;border-radius: 4px;">
                
                    <signature-pad [options]="signaturePadOptions" #signaturePad1 (touchmove)="onMouseMovePad($event)"
                      (mousemove)="onMouseMovePad($event)" (onEndEvent)="drawCompletePad()"
                      (onBeginEvent)="drawStartpad()"></signature-pad>
                    @if(signaturecheckPAD){
                    <div style="
                      left: 10px;
                      color: red;
                      text-decoration: underline;cursor:pointer">
                            <p (click)="clearSignatureCC()">x {{lang.Clear}}</p>
                          </div>
                          }

                  </div>
                  @if(signaturemessagepad){
                  <span class="invalid text-red-500">{{lang.Please_Sign_the_Signature}}</span>
                  }
                </div>

                <div class="col-span-3" style="margin-bottom: 15px;">
                  <!-- <p style="text-decoration: underline; color: blue; cursor: pointer;" *ngIf="isFileUploaded && bankverifyDetails" (click)="generateAndSubmitPAD()">Review the PAD Agreement</p> -->
                  <button type="button"
                    class="w-full sm:w-1/2 h-14 mb-1 max-2 rounded-full border-[1px] border-indigo-700 bg-white p-0.5 font-bold transition duration-700 ease-in-out text-black mt-2"
                    (click)="generateAndSubmitPAD(true)">
                    Review the PAD Agreement
                  </button>
                  <span class="invalid text-red-500">{{padaggrementerror}}</span>
                </div>


              </div>
            </form>

            }


            @if(paymentForm.get('paymentRadioCheck')?.value === 'CC'){


            <button
              class="fixed right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
              (click)="creditcardpaysubmit2(paymentForm.value,paymentformCC)">
              {{ lang.Submit }}
            </button>
            }

          <!-- paymentForm already closed above -->
        </div>
      </div>
      }
      </div>
      <div class="relative">

        <!-- Left Button -->
        <!-- <button class="fixed left-0 bottom-16  w-36 h-14 mb-1 rounded-full border-2 border-indigo-700 bg-gray-200 p-0.5 font-bold mx-2 sm:mx-12 hover:bg-white" (click)="gotoPlansPage()">
        {{ lang.previous }}
      </button> -->


        <button
          class="fixed text-center inline-flex items-center left-3 sm:left-16 lg:left-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
          style="width:120px;"
          (click)="gotoPlansPage()">

          <svg class="h-9 w-9 me-2 text-indigo-900" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          {{ lang.Previous }}
        </button>
        <!-- Right Button -->

        @if(paymentForm.get('paymentRadioCheck')?.value === 'PAD'){



        <button
          class="fixed right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
          (click)="bankpayformsubmit2(bankpayForm.value)">
          {{ lang.Submit }}
        </button>
        }

        <!-- @if(paymentForm.get('paymentRadioCheck')?.value =='') {

        <button class="fixed right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white" (click)="registartionform(paymentForm.value)">
          {{ lang.submit }}
        </button>

      } -->

        @if(paymentForm.get('paymentRadioCheck')?.value !== 'CC' && paymentForm.get('paymentRadioCheck')?.value !==
        'PAD') {

        <button
          class="fixed right-3 sm:right-16 lg:right-24 bottom-10 w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 px-5 py-2.5 transition duration-700 ease-in-out hover:bg-white"
          (click)="registartionform2(paymentForm.value)">
          {{ lang.Submit }}
        </button>

        }

      </div>
    </div>
    }
</div>





@if(languageData){
<app-confirmation-model [show]="showDeleteModal" [message]="modalMessage" [languageData]="languageData"
  (confirmed)="onConfirmed($event)">
</app-confirmation-model>
}

@if(showModelDialog || showPADModelDiaslog){
<app-model-dialog [show]="showModelDialog" [showPAD]="showPADModelDiaslog" [message]="pdfData"
  [languageData]="languageData" [headMessage]="header" (pdfconfirmed)="onPdfConfirmed($event)"
  (padPdfconfirmed)="onPADPdfConfirmed($event)">
</app-model-dialog>
}

@if(showModal && languageData){
<app-forms-model [show]="showModal" [editChildData]="editChildInfo" [buttonInfo]="childInfoModalAddAndUpdateButton"
  (submitForm)="onSubmitForm($event)" [formConfigData]="languageTokensArray" [languageData]="languageData"
  (close)="onCloseModal()">
</app-forms-model>
}
@if(ShowModelPopup && languageData){
<app-modelpopupconfirmation [show]="ShowModelPopup" [languageData]="languageData"
  [showHeaderMessage]="ShowModelPopupTitle" [showModelContent]="ShowModelPopupMessage"
  (closedModelpopup)="onClosedModelpopup($event)">

</app-modelpopupconfirmation>
}

@if(missingInformation){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        class="relative transform overflow-hidden rounded-lg bg-white text-center mx-auto shadow-xl transition-all sm:w-1/3">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.Missing_Information}}
            </div>
            <div class="text-left mx-2" style="  max-height: calc(100vh - 300px);
        overflow-y: auto;">
              @for(item of missingInfo; track item;let i=$index){
              <div>
                <span>{{i+1}}.&nbsp;{{item}}&nbsp;<span style="color: red">*</span></span>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-2 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">
          <button type="button"
            class="w-36 h-14 mb-2 mt-2 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:border-indigo-700 hover:bg-white"
            (click)="closemissingInfoModel()">
            {{lang.Close}}
          </button>
          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}


@if(noPlanSelected){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        class="relative transform overflow-hidden rounded-lg bg-white text-center mx-auto shadow-xl transition-all sm:w-1/3">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              Plan Required
            </div>
            <div class="text-left mx-2" style="  max-height: calc(100vh - 300px);
        overflow-y: auto;">
              @for(item of missingInfo; track item;let i=$index){
              <div>
                <span>{{i+1}}.&nbsp;{{item}}&nbsp;<span style="color: red">*</span></span>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-2 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">
          <button type="button"
            class="w-36 h-14 mb-2 mt-2 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:border-indigo-700 hover:bg-white"
            (click)="closemissingInfoModel()">
            {{lang.Close}}
          </button>
          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}


<div
  style="display: none;"
  class="iframe-modal-backdrop"
>
  <div class="iframe-modal">
 
    <button
      class="close-btn"
      (click)="closeIframe()"
      aria-label="Close"
    >
      &times;
    </button>
 
    <iframe
      [src]="iframeUrl"
      class="feature-iframe"
      frameborder="0">
    </iframe>
 
  </div>
</div>
 
@if(iframeUrl && false){
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
 
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all w-full sm:my-8 sm:w-full sm:max-w-7xl max-w-2xl">
          <div class="bg-white">
            <div class="">
              <div class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white object-fit">
                {{iframeHeading}}
              </div>
              <div class="text-center" style="height: 60vh;">
                <iframe
                  [src]="iframeUrl"
                  class="iframe"
                  frameborder="0">
                </iframe>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">
            <button
            type="button"
            class="w-36 h-14 mb-1 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 font-bold hover:bg-white"
            (click)="closeIframe()"
          >
          {{lang.Close}}
          </button>
        </div>
        </div>
      </div>
    </div>
  </div>
}

@if(planOptionsModel){
<lib-clinics [optionstitle]="optionstitle" [lang]="lang" [userForm]="userForm"
  [selectedProvinceId]="validationInputData.province_id" [optionmessage]="optionmessage" [_decimalPipe]="_decimalPipe"
  [_CustomDatePipe]="_CustomDatePipe" [(planOptionsModel)]="planOptionsModel"
  [plandetailsobjvalue]="plandetailsobjvalue" (closeClicked)="closeoptionsselection()"
  (confirmClicked)="confirmoptionsselectionV2($event)" [currChild]="currChild" [currChildType]="currChildType" [currChildIndex]="currChildIndex" [planScopeDetails]="planScopeDetails" ></lib-clinics>
}

@if(false){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
          Modal panel, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
      <div
        class="relative transform overflow-hidden rounded-lg bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl max-w-2xl">
        <div class="bg-white pb-2 pt-2 ">
          <div class="">
            <div class="text-center font-bold text-2xl">
              {{lang.Choose_Options}}
            </div>
            <div class="mt-3 text-left" style="  max-height: calc(100vh - 200px);
        overflow-y: auto;">


              <!-- <input type="hidden" id="plandetailsobj" value="{{plandetailsobjvalue}}">
              <input type="hidden" id="optionumber" value="{{optionstitle.length}}"> -->

              <input type="hidden" id="plandetailsobj" #optionPlanDetailsObj value="{{plandetailsobjvalue}}">
              <input type="hidden" id="optionumber" #optionNumberInput value="{{optionstitle.length}}">

              @for(option of optionstitle; track option;let i = $index){
              <div>
                <h3><b>{{option.name}}</b><span style="color: red">*</span></h3>

                @for(optionvalue of option.planOptionsValues; track optionvalue;let j = $index){
                <div class="row">
                  <div class="col-md-12" style="border: 1px solid black;padding:5px 15px;border-bottom:1px !important">
                    <input type="radio" value="{{optionvalue.json}}"
                      id="planselectionvalue-{{optionvalue.id}}-{{option.id}}"
                      class="optionselectionmethod-{{option.id}}"
                      (change)="planoptionselection($event,optionvalue,option.id,optionvalue.id,i,'optionselectionmethod-')">&nbsp;{{optionvalue.name}}

                  </div>
                </div>
                }
                <br>
              </div>
              }
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">


          <p id="planoptionmessage"><b>{{optionmessage}}</b></p>
          <button type="button" class="w-36 h-14 mb-1 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold"
            (click)="closeoptionsselection()">
            {{lang.Close}}
          </button>
          <button type="button"
            class="w-36 h-14 mb-1 rounded-full border-2 border-green-700 bg-gray-200 p-0.5 font-bold"
            (click)="confirmoptionsselection()">
            {{lang.Confirm}}
            <!-- <strong style="color: white">{{lang.confirm}}</strong> -->
          </button>
          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(padAggrementModel){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.PAD_Agreement}}
            </div>
            <div class="text-center">
              <pdf-viewer [src]="generatePADaggrement" style=" height: 60vh;z-index:9999;overflow-y: scroll;"
                class="px-0 w-fill object-cover"></pdf-viewer>

            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700 gap-2">

          @if(signaturestatus){
          <button type="button"
            class="w-44 h-14 mb-1 rounded-full order-first border-2 border-green-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="signaturestartmodel()">
            {{lang.Sign_Agree}}
          </button>
          }
          @if(agreestatus){
          <button type="button"
            class="w-36 h-14 mb-1 order-2 rounded-full border-2 border-green-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="agreepadconditions()">
            {{lang.Agree}}
          </button>
          }
          @if(rejectPADModel){
          <button type="button"
            class="w-36 h-14 mb-1 order-3 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="rejectPADpafaggrement()">
            {{lang.Reject}}
          </button>
          }

          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(padAggrementFinalModel){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.PAD_Agreement}}
            </div>
            <div class="text-center">
              <pdf-viewer [src]="generatePADaggrement" style=" height: 60vh;z-index:9999;overflow-y: scroll;"
                class="px-0 w-fill object-cover"></pdf-viewer>

            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700 gap-2">


          @if(showagree){
          <button type="button"
            class="w-36 h-14 mb-1 order-2 rounded-full border-2 border-green-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="agreepadconditions()">
            {{lang.Agree}}
          </button>
          }
          @if(rejectPADModel){
          <button type="button"
            class="w-36 h-14 mb-1 order-3 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="rejectPADpafaggrement1()">
            {{lang.Reject}}
          </button>
          }
          @if(closePADModel){
          <button type="button"
            class="w-36 h-14 mb-1 order-4 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="closePADAdggrementModel()">
            {{lang.Close}}
          </button>
          }
          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(signModelForBankPay){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-1/4 sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.Signature}}
            </div>
            <div class="text-center">

              <div class="signature-container col-span-1 w-full" style="border:1px solid #ccc;border-radius: 4px;">

                <!-- <button class="btn btn-primary btn-inline" (click)="clearPadcc()" [disabled]="signaturecheckvalue1cc">Clear</button> -->

                <!-- <canvas
            #canvascc
            (touchstart)="startDrawingcc($event)"
            (touchmove)="movedcc($event)"
            (click)="signaturestartcc($event)" required
          ></canvas> -->

                <signature-pad [options]="signaturePadOptions" #signaturePad2 (touchmove)="onMouseMovePad($event)"
                  (mousemove)="onMouseMovePad($event)" (onEndEvent)="drawCompletePad()"
                  (onBeginEvent)="drawStartpad()"></signature-pad>
                @if(signaturecheckPAD){
                <div style="
          left: 10px;
          color: red;
          text-decoration: underline;cursor:pointer">
                  <p (click)="clearSignaturePAD()">x {{lang.Clear}}</p>
                </div>
                }

              </div>
              @if(showpaderrorMessage){
              <span class="invalid text-red-500">{{lang.Review_and_Sign_the_PAD_Agreement}}</span>
              }
              <!-- <div class="mt-2 border-2 border-green-200 rounded-lg w-1/2"> -->


              <!-- <canvas
                  #canvasPadElement
                  (mousedown)="onMouseDownpad($event)" (touchstart)="onMouseDownpad($event)" (touchmove)="onMouseMovepad($event)"
      (mousemove)="onMouseMovepad($event)" required  style="border: 1px solid #ccc;border-radius: 4px;"
                ></canvas>
                @if(signaturecheckvalue1){
                  <div style="
                  left: 10px;
                  color: red;
                  text-decoration: underline;cursor:pointer">
                      <p (click)="clearPadSignature()">x {{lang.clear}}</p>
                  </div>
                }
        @if(signaturemessagepad){
                  <span
                  class="invalid text-red-500"
                  >{{lang.please_sign_the_signature}}</span
                >
        } -->
              <!-- </div> -->


            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">


          <button type="button"
            class="w-36 h-14 mb-1 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="savePadsignature()">{{lang.Confirm}}

          </button>

          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
}

@if(imageDisplayShow){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-1/4 sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.Preview}}
            </div>
            <div class="text-center">

              <div class="signature-container col-span-1 w-full" style="border:1px solid #ccc;border-radius: 4px;">


                @if(normalview){
                <img [src]="imagedisplay" />
                }

                @if(pdfview){

                <pdf-viewer [src]="imagedisplay" style=" height: 60vh;z-index:9999;overflow-y: scroll;"
                  class="px-0 w-fill object-cover"></pdf-viewer>

                }

              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">


            <button type="button"
              class="w-36 h-14 mb-1 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
              (click)="closeImagePreview()">{{lang.Close}}

            </button>

            <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
            <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

}


@if(showMedcanForm){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" style="position: absolute; z-index: 0;">
  <div class="bg-white rounded-xl shadow-lg max-w-2xl w-full mx-4">
    <!-- Header -->
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white rounded-t-xl">
      <h2 class="text-[14px] font-semibold">Plan selection for members</h2>
    </div>

    <!-- Content -->
    <div class="p-6 max-h-[60vh] overflow-y-auto">
      <div class="mb-4 p-4 bg-blue-50 rounded-lg">
         <p class="text-md text-gray-700 mb-2">
          <!-- without tax price single plan need to show -->
          <strong>{{medcanPlanName}}</strong> <span style="margin-left: 130px;">${{ originalMedcanPrice | number:'1.2-2' }}</span> 
        </p>
        <p class="text-xs text-gray-500">Choose members to enroll in this plan</p>
      </div>

      <!-- Member (Primary) - Always selected and disabled -->
      <div class="mb-4 p-4 bg-gray-100 rounded-lg border-l-4 border-indigo-700">
        <label class="flex items-center cursor-not-allowed">
          <input type="checkbox" [checked]="memberSelected" disabled
            class="w-5 h-5 text-indigo-600 rounded focus:ring-indigo-500 opacity-60" />
          <span class="ml-3 text-gray-900 font-semibold">
            {{ validationInputData.firstName }} {{ validationInputData.lastName }}
            <span class="text-sm text-gray-600 font-normal">(Member - Primary)</span>
          </span>
        </label>

        <div class="ml-8 mt-2">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Doctor's Gender <span class="text-red-500">*</span>
          </label>
          <select
            [(ngModel)]="doctorSelfGender"
            name="doctorSelfGender"
            required
            #doctorSelfGenderRef="ngModel"
            (ngModelChange)="onSelfDoctorGenderChange($event)"
            class="w-full border border-gray-300 rounded-lg p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': doctorSelfGenderRef.invalid && doctorSelfGenderRef.touched}"
          >
            <option value="">Select</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="any">Any</option>
          </select>
          <p *ngIf="doctorSelfGenderRef.invalid && doctorSelfGenderRef.touched" class="text-red-500 text-xs mt-1">
            Doctor's Gender is required.
          </p>
        </div>


        <div class="ml-8 mt-2">
         <div *ngIf="!planScopeDetails?.length || planScopeDetails?.[0]?.options?.length==0">
          <button 
            type="button"
            (click)="openClinicModal()"
            class="flex items-center gap-2 px-4 py-2 border-2 border-dashed border-indigo-400 rounded-lg text-indigo-600 font-semibold hover:bg-indigo-50 transition"
          >
            <span class="text-xl">+</span> Add Clinic
          </button>
          <p *ngIf="clinicSubmitAttempted && (!planScopeDetails?.length || planScopeDetails?.[0]?.options?.length==0)" class="text-red-500 text-xs mt-1">
            Please add a clinic.
          </p>
        </div>

        <!-- Clinic already added -->
        <div *ngIf="planScopeDetails?.length > 0 && planScopeDetails[0]?.options?.length > 0" class="flex items-center justify-between border border-gray-300 rounded-lg p-3 bg-gray-50">
          <div>
            <p class="text-sm font-semibold text-gray-800">{{ planScopeDetails[0].options[0].clinic ?? planScopeDetails[0].clinicName }}</p>
          </div>
          <button 
            type="button"
            (click)="openClinicModal()"
            class="text-sm text-indigo-600 font-medium hover:underline"
          >
            Update
          </button>
        </div>
      
      </div>



        <!-- <div class="ml-8 mt-2">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Select Clinic <span class="text-red-500">*</span>
          </label>
          <div class="flex items-center gap-6">
            <label class="flex items-center cursor-pointer">
              <input type="radio" name="clinicSelfSelection" value="yes"
                [(ngModel)]="clinicSelfSelection"
                required
                #clinicSelfSelectionRef="ngModel"
                (change)="onClinicChange(true)" class="mr-2" />
              Yes
            </label>
            <label class="flex items-center cursor-pointer">
              <input type="radio" name="clinicSelfSelection" value="no"
                [(ngModel)]="clinicSelfSelection"
                (change)="onClinicChange(true)" class="mr-2" />
              No
            </label>
          </div>
          <p *ngIf="clinicSelfSelectionRef.invalid && clinicSelfSelectionRef.touched" class="text-red-500 text-xs mt-1">
            Please select a clinic option.
          </p>
        </div> -->

      </div>

      <!-- Spouse -->
      @if(validationInputData.having_spouse && validationInputData.spouse_details) {
      <div class="mb-4 p-4 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
        <label class="flex items-center cursor-pointer">
          <input type="checkbox" [(ngModel)]="spouseSelected"
            (ngModelChange)="onSpouseChange($event,validationInputData.spouse_details)"
            class="w-5 h-5 text-indigo-600 rounded focus:ring-indigo-500 cursor-pointer" />
          <span class="ml-3 text-gray-900">
            {{ validationInputData.spouse_details.firstName }} {{ validationInputData.spouse_details.lastName }}
            <span class="text-sm text-gray-600">(Spouse)</span>
          </span>
        </label>
        <div class="ml-8 mt-2 text-xs text-gray-500">
          DOB: {{ validationInputData.spouse_details.dob }} | Gender: {{ validationInputData.spouse_details.gender }}
        </div>

        <div class="ml-8 mt-2" *ngIf="spouseSelected">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Doctor's Gender <span class="text-red-500">*</span>
          </label>

          <select
            [(ngModel)]="doctorGender"
            name="doctorGender"
            class="w-full border border-gray-300 rounded-lg p-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="">Select</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="any">Any</option>
          </select>
        </div>

        <div class="ml-8 mt-2" *ngIf="spouseSelected">
          <label class="block text-sm font-medium text-gray-700 mb-2">Select clinic same as member</label>
          <div class="flex items-center gap-6">

            <label class="flex items-center cursor-pointer">
              <input type="radio" name="clinicSpouseSelection" value="yes"
              [(ngModel)]="clinicSpouseSelection" (change)="onClinicChange()" class="mr-2" />
              Yes
            </label>

            <label class="flex items-center cursor-pointer">
              <input type="radio" name="clinicSpouseSelection" value="no"
                [(ngModel)]="clinicSpouseSelection" (change)="onClinicChange()" class="mr-2" />
              No
            </label>

          </div>
        </div>
      </div>
      }

      <!-- Children -->
      @if(validationInputData.having_dependent_children && validationInputData.children_details?.length > 0) {
      <div class="space-y-3">
        @for(child of validationInputData.children_details; track $index) {
        <div class="mb-4 p-4 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
          <label class="flex items-center cursor-pointer">
            <input type="checkbox" [(ngModel)]="childrenSelected[$index]"
              (ngModelChange)="onChildChange($event,$index,child)"
              class="w-5 h-5 text-indigo-600 rounded focus:ring-indigo-500 cursor-pointer" />
            <span class="ml-3 text-gray-900">
              {{ child.firstName }} {{ child.lastName }}
              <span class="text-sm text-gray-600">(Child {{ $index + 1 }})</span>
            </span>
          </label>
          <div class="ml-8 mt-2 text-xs text-gray-500">
            DOB: {{ child.dob }} | Gender: {{ child.gender }}
          </div>

          <div class="ml-8 mt-2" *ngIf="childrenSelected[$index]">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Doctor's Gender <span class="text-red-500">*</span>
          </label>

        <select
          [(ngModel)]="doctorGender[$index]"
          [name]="'doctorGender' + $index"
          (ngModelChange)="onChildDoctorChange($event, $index, child)"
          class="w-full border border-gray-300 rounded-lg p-2 focus:ring-indigo-500 focus:border-indigo-500"
        >
          <option value="">Select</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="any">Any</option>
        </select>
        </div>

        <div class="ml-8 mt-2" *ngIf="childrenSelected[$index]">
          <label class="block text-sm font-medium text-gray-700 mb-2">Select clinic same as member</label>
          <div class="flex items-center gap-6">
            <!-- FIX: unique name per child using $index to avoid radio conflicts -->
            <label class="flex items-center cursor-pointer">
              <input type="radio" [name]="'clinicChild' + $index" value="yes"
                [(ngModel)]="clinicSelection[$index]"
                (change)="onClinicChildChange($index)" class="mr-2" />
              Yes
            </label>
            <label class="flex items-center cursor-pointer">
              <input type="radio" [name]="'clinicChild' + $index" value="no"
                [(ngModel)]="clinicSelection[$index]"
                (change)="onClinicChildChange($index)" class="mr-2" />
              No
            </label>

          </div>
        </div>
        </div>
        }
      </div>
      }

      <!-- No dependents message -->
      @if(!validationInputData.having_spouse && !validationInputData.having_dependent_children) {
      <div class="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <p class="text-sm text-yellow-800">No dependents available</p>
      </div>
      }

 <div style="display: inline-block; min-width: 100%;">
        <table style="width: 100%; font-size: 14px; border-collapse: collapse; border: 1px solid #000;">
          <thead>
            <tr>
              <th style="color: black; background-color: #d9d9ea; font-style: italic; padding: 8px 12px; font-weight: 500; text-align: left; border: 1px solid #000;">Members selected</th>
              <th style="color: black; background-color: #d9d9ea; font-style: italic; padding: 8px 12px; font-weight: 500; text-align: left; border: 1px solid #000;">Total premium price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="text-align: center; padding: 8px 12px; font-weight: 500; border: 1px solid #000;">{{ selectedCount }}</td>
              <td style="text-align: right; padding: 8px 12px; font-weight: 500; border: 1px solid #000;">${{ (medcanPlanAmount * selectedCount).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>


         <p class="text-sm text-gray-500 p-4" style="margin-top: -10px;">Note: The plan price ${{medcanPlanAmount}} (included tax) will be multiplied based on selected family members.
You will see a summary after confirming.</p>
    </div>

    <!-- Footer -->
    <div class="flex justify-end gap-2 border-t border-gray-200 px-6 py-4 bg-gray-50 rounded-b-xl">
      <button type="button"
        class="w-36 h-12 rounded-full border-2 border-gray-700 bg-gray-200 font-bold hover:bg-white transition-colors"
        (click)="onCloseMedcan()">
        {{ lang.Close }}
      </button>
      <button type="button"
        class="w-36 h-12 rounded-full border-2 border-indigo-700 bg-indigo-700 text-white font-bold hover:bg-indigo-800 transition-colors"
        (click)="onSubmitMedcan()">
        {{ lang.Submit }}
      </button>
    </div>
  </div>
</div>
}

@if(benficiary){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white  rounded-xl shadow-lg">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[14px] font-semibold">{{lang.Beneficiary_Information}}</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>

    @if(showBenificiaryForm){
    <form [formGroup]="benficiaryForm">

      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-2">
        <!-- <div class="sm:col-span-3">
          <label for="" class="">{{lang.Beneficiary}}<span class="text-danger">*</span></label>

          <select class="form-control" placeholder="Select" formControlName="customerType">

            <option value="" selected disabled>{{lang.Select}}</option>
            <option value="MEMBER" selected>{{lang.MEMBER}}</option>
            <option value="SPOUSE" selected>{{lang.SPOUSE}}</option>
          </select>


          @if (b['customerType'].errors && b['customerType'].touched) {
          <div class="invalid text-red-500">
            @if (b['customerType'].errors['required']) {
            <div>{{lang.Please_select_beneficiary}}</div>
            }
          </div>
          }

        </div> -->

        <div class="sm:col-span-3">
          <label for="" class="">{{lang.First_Name}}<span class="text-danger">*</span></label>
          <input class="form-control checking-field" type="text" placeholder={{lang.First_Name}}
            formControlName="firstName" (keypress)="alphabatesOnly($event)">

          @if (b['firstName'].errors && b['firstName'].touched) {
          <div class="invalid text-red-500">
            @if (b['firstName'].errors['required']) {
            <div>{{ lang.Please_enter_first_name }}</div>
            } @if (b['firstName'].errors['minlength']) {
            <div>{{ lang.First_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }

        </div>
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Last_Name}}<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder={{lang.Last_Name}}
            formControlName="lastName" (keypress)="alphabatesOnly($event)">


          @if (b['lastName'].errors && b['lastName'].touched) {
          <div class="invalid text-red-500">
            @if (b['lastName'].errors['required']) {
            <div>{{ lang.Please_enter_last_name }}</div>
            } @if (b['lastName'].errors['minlength']) {
            <div>{{ lang.Last_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }



        </div>
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Relation}}<span class="text-danger">*</span></label>


          <select class="form-control" placeholder="Select" formControlName="relationship"
            (change)="isChildCheck($event,true)">

            <option value="" selected disabled>{{lang.Select}}</option>
            <option *ngFor="let name of beneficariesDetails?.relationship" [value]="name.value">
              {{ name.label }}
            </option>

          </select>


          @if (b['relationship'].errors && b['relationship'].touched) {
          <div class="invalid text-red-500">
            @if (b['relationship'].errors['required']) {
            <div>{{lang.Please_select_relationship}}</div>
            }
          </div>
          }



        </div>

        @if(benficiaryForm.get('relationship')?.value == 'OTHER'){
        <div class="sm:col-span-3">
          <label for="" class="">Relationship<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder='Enter Relationship'
            formControlName="relationshipSpecific" (change)="checkSpouse()" (keypress)="alphabatesOnly($event)">

          @if (b['relationshipSpecific'].touched) {
          <div class="invalid text-red-500">
            @if (benficiaryForm.get('relationshipSpecific')?.value == '') {
            <div>Relationship should be minimum of 1 Character and without numbers</div>
            }
          </div>
          }
        </div>
        }
        <!-- @if(benficiaryForm.get('relationship')?.value === 'CHILD'){
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Is_this_person_under_age_18}}<span class="text-danger">*</span></label>
          <div class="flex items-center space-x-2">
            <input type="radio" id="true" formControlName="isMinor" value="true" class="form-radio text-blue-600"
              (change)="isMinorCheck($event)" />
            <label for="true" class="labeling">{{lang.Yes}}</label>
          </div>

          <div class="flex items-center space-x-2">
            <input type="radio" id="false" formControlName="isMinor" value="false" class="form-radio text-blue-600"
              (change)="isMinorCheck($event)" />
            <label for="false" class="labeling">{{lang.No}}</label>
          </div>


          @if (b['isMinor'].errors && b['isMinor'].touched) {
          <div class="invalid text-red-500">
            @if (b['isMinor'].errors['required']) {
            <div>{{lang.Please_select_minor_status}}</div>
            }
          </div>
          }



        </div>
        } -->

        <!-- @if(benficiaryForm.get('relationship')?.value === 'CHILD'){ -->
        <div class="col-span-3">
          <label for="date_of_birth">{{ lang.Date_of_Birth }}<span style="color: red">*</span></label>

          <input type="text" (paste)="(false)" class="form-control" formControlName="dob" [minDate]="minDate"
            [maxDate]="childmaxDate" #dp [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
            placeholder="MM-DD-YYYY" bsDatepicker (blur)="checkDateOfBirthMinor($event)"
            (bsValueChange)="onDateChange($event)" (input)="checkDateOfBirthMinor($event)"
            (change)="checkDateOfBirth($event)" (keypress)="numbersOnly($event)" />

          <!-- <input id="datepicker-autohide"  formControlName="date_of_birth" datepicker datepicker-autohide type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  placeholder="MM-DD-YYYY"> -->

          @if (b['dob'].errors && b['dob'].touched) {
          <div class="invalid text-red-500">
            @if (b['dob'].errors['required']) {
            <div>{{ lang.Please_Choose_Date_of_Birth }}</div>
            }
          </div>
          }
        </div>
        <!-- } -->
        <!-- <div class="sm:col-span-3">
          <label for="" class=""> {{lang.Contingent_First_Name}}<span class="text-danger">*</span></label>
          <input class="form-control checking-field" type="text" placeholder={{lang.First_Name}}
            formControlName="contingentFirstName" (keypress)="alphabatesOnly($event)">

          @if (b['contingentFirstName'].errors && b['contingentFirstName'].touched) {
          <div class="invalid text-red-500">
            @if (b['contingentFirstName'].errors['required']) {
            <div>{{ lang.Please_enter_first_name }}</div>
            } @if (b['contingentFirstName'].errors['minlength']) {
            <div>{{ lang.First_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }

        </div>
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Contingent_Last_Name}}<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder={{lang.Last_Name}}
            formControlName="contingentLastName" (keypress)="alphabatesOnly($event)">

          @if (b['contingentLastName'].errors && b['contingentLastName'].touched) {
          <div class="invalid text-red-500">
            @if (b['contingentLastName'].errors['required']) {
            <div>{{ lang.Please_enter_last_name }}</div>
            } @if (b['contingentLastName'].errors['minlength']) {
            <div>{{ lang.Last_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }



        </div> -->

        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Gender}}<span class="text-danger">*</span></label>
          <select class="form-control" id="gender" placeholder="Select" formControlName="gender">
            <option value="" disabled>{{ lang.Select }}</option>
            <option value="Male">{{ lang.Male }}</option>
            <option value="Female">{{ lang.Female }}</option>
            <option value="Non-Binary">{{ lang.Non_Binary }}</option>
            <option value="Undisclosed">{{ lang.Undisclosed }}</option>
          </select>

          @if (b['gender'].errors && b['gender'].touched) {
          <div class="invalid text-red-500">
            @if (b['gender'].errors['required']) {
            <div>{{ lang.Please_Select_Gender }}</div>
            }
          </div>
          }
        </div>

        @if((trusteeCheck===true && benficiaryForm.get('relationship')?.value === 'CHILD')){
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Trustee_First_Name}}<span class="text-danger">*</span></label>
          <input class="form-control checking-field" type="text" placeholder={{lang.First_Name}}
            formControlName="trusteeFirstName" (keypress)="alphabatesOnly($event)">

          @if (b['trusteeFirstName'].errors && b['trusteeFirstName'].touched) {
          <div class="invalid text-red-500">
            @if (b['trusteeFirstName'].errors['required']) {
            <div>{{ lang.Please_enter_first_name }}</div>
            } @if (b['trusteeFirstName'].errors['minlength']) {
            <div>{{ lang.First_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }

        </div>
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Trustee_Last_Name}}<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder={{lang.Last_Name}}
            formControlName="trusteeLastName" (keypress)="alphabatesOnly($event)">

          @if (b['trusteeLastName'].errors && b['trusteeLastName'].touched) {
          <div class="invalid text-red-500">
            @if (b['trusteeLastName'].errors['required']) {
            <div>{{ lang.Please_enter_last_name }}</div>
            } @if (b['trusteeLastName'].errors['minlength']) {
            <div>{{ lang.Last_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }



        </div>
        <div class="sm:col-span-3">
          <label for="" class="">Trustee Relation<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder=Relation formControlName="trusteeRelation"
            (keypress)="alphabatesOnly($event)">

          @if (b['trusteeRelation'].errors && b['trusteeRelation'].touched) {
          <div class="invalid text-red-500">
            @if (b['trusteeRelation'].errors['required']) {
            <div>Please enter relation</div>
            }
          </div>
          }



        </div>
        }
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Percentage}}<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder="Percentage" formControlName="percentage"
            (keypress)="numbersOnly($event)" (blur)="checkpercentagevalue($event)"
            (input)="checkpercentagevalue($event)">


          @if (b['percentage'].errors && b['percentage'].touched) {
          <div class="invalid text-red-500">
            @if (b['percentage'].errors['required']) {
            <div>{{lang.Please_enter_percentage}}</div>
            }
          </div>
          }



        </div>

        <div class="flex justify-end">
          <button type="button"
            class="w-28 h-12 mt-12 rounded-full border-2 border-indigo-700 bg-gray-200 p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white"
            [disabled]="benficiaryForm.invalid" (click)="savebenficiary(benficiaryForm.value)">
            Save
          </button>
        </div>







        <!-- <div class="sm:col-span-3">

          <button type="button"
            class="w-28 h-12 mt-12 rounded-full border-2 border-indigo-700 bg-gray-200 p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white float-right"
            [disabled]="benficiaryForm.invalid" (click)="savebenficiary(benficiaryForm.value)">
            {{lang.Save}}
          </button>
        </div> -->






      </div>
    </form>
    }

    @if(addbenificaryData.length>0){
    <div class="form-group col-md-12">
      <table class="table table-bordered text-black" id="customerPlansTable">

        <tbody>
          <tr>
          <tr>

            <th>{{lang.First_Name}}</th>
            <th>{{lang.Last_Name}}</th>
            <th>{{lang.Relation}}</th>
            <th>{{lang.Date_of_Birth}}</th>
            <th>{{lang.Gender}}</th>
            <!-- <th>{{lang.Trustee_First_Name}}</th>
            <th>{{lang.Trustee_Last_Name}}</th>
            <th>Trustee Relation</th> -->
            <th>Trustee Name - Relation</th>
            <th>{{lang.Percentage}}</th>
            <th>{{lang.Action}}</th>
          </tr>


          <tr *ngFor="
                  let broker of addbenificaryData;
                  let i = index
                " [ngClass]="{
                  orange: i % 2 == 0,
                  white: i % 2 != 0
                }">


            <td>
              {{broker.firstName}}
            </td>
            <td>
              {{broker.lastName}}
            </td>
            <td>
              {{
              broker.relationship?.toLowerCase() === 'other'
              ? capitalize(broker.relationshipSpecific ?? '')
              : capitalize(broker.relationship?.replace('_',' ') ?? '')
              }}
            </td>


            <td>
              @if(broker.dob==null){
              NA
              }@else{
              {{broker.dob | displayDate}}
              }

            </td>
            <td>
              {{broker.gender}}

            </td>

            <!-- <td>

              @if(broker.trusteeFirstName==""){
              NA
              }@else{
              {{broker.trusteeFirstName}}
              }

            </td>
            <td>
              @if(broker.trusteeLastName==""){
              NA
              }@else{
              {{broker.trusteeLastName}}
              }
            </td>
            <td>
              @if(broker.trusteeLastName==""){
              NA
              }@else{
              {{broker.trusteeRelation}}
              }
            </td> -->

            <td>
              @if(broker.trusteeFirstName==""){
              NA
              }@else{
              {{broker.trusteeFirstName+ ' '+broker.trusteeLastName + ' - '+broker.trusteeRelation}}
              }
            </td>

            <td style="text-align:center">
              {{broker.percentage}}%
            </td>

            <td class="thBottomNone text-center inline-flex items-center">
              <svg class="h-10 w-10 text-green-600" (click)="editbenficiary($event, i, broker)"
                *ngIf="enableEditIndex != i" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" />
                <path d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                <line x1="16" y1="5" x2="19" y2="8" />
              </svg>
              <svg class="h-9 w-9 text-red-600" (click)="deleteBenficiary(broker, i)" *ngIf="enableEditIndex != i"
                width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="3" y="4" width="18" height="4" rx="2" />
                <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" />
                <line x1="10" y1="12" x2="14" y2="12" />
              </svg>


            </td>

          </tr>
        </tbody>
      </table>

      <button type="button"
        class="w-36 h-12 mt-8 rounded-full border-2 border-indigo-700 bg-gray-200 p-0.5 font-bold transition duration-700 ease-in-out hover:bg-white"
        (click)="addnewbenficiary()">
        {{lang.Add_More}}
      </button>

    </div>

    <form [formGroup]="wawanessaForm">
      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-2">
        <div class="sm:col-span-4">
          <label>{{ lang?.Do_you_smoke }}</label>
          <div class="flex items-center space-x-2">
            <span class="flex items-center space-x-2">
              <input type="radio" id="true" formControlName="smoker" value="true" class="form-radio text-blue-600" />
              <label for="true" class="labeling">{{lang.Yes}}</label>
            </span>

            <span class="flex items-center space-x-2">
              <input type="radio" id="false" formControlName="smoker" value="false" class="form-radio text-blue-600" />
              <label for="false" class="labeling">{{lang.No}}</label>
            </span>
          </div>
          @if (w['smoker'].errors && w['smoker'].touched) {
          <div class="invalid text-red-500">
            @if (w['smoker'].errors['required']) {
            <div>Please choose smoking information</div>
            }
          </div>
          }
        </div>

        <div class="sm:col-span-4">
          <label for="" class="">{{ lang?.Earnings_frequency }}<span class="text-danger">*</span></label>
          <select class="form-control" id="gender" placeholder="Select" formControlName="earningsFrequency">
            <option value="" disabled>{{ lang.Select }}</option>
            <!-- @for (group of earningSummaryOptions; track group;let i = $index){
              <option value="">{{ lang.Select }}</option>
            } -->
            <option value="HOURLY">Hourly</option>
            <option value="WEEKLY">Weekly</option>
            <option value="FORTNIGHTLY">Bi-weekly</option>
            <option value="MONTHLY">Monthly</option>
            <option value="YEARLY">Annually</option>
          </select>
          @if (w['earningsFrequency'].errors && w['earningsFrequency'].touched) {
          <div class="invalid text-red-500">
            @if (w['earningsFrequency'].errors['required']) {
            <div>Please enter earnings frequency</div>
            }
          </div>
          }
        </div>

        <div class="sm:col-span-4">
          <label for="" class="">{{ lang?.Earnings_amount}}<span class="text-danger">*</span></label>
          <input type="number" class="form-control checking-field" placeholder="$" formControlName="earningsAmount"
            (keypress)="decimalNumberOnly($event)" min="1">
          @if (w['earningsAmount'].errors && w['earningsAmount'].touched) {
          <div class="invalid text-red-500">
            @if (w['earningsAmount'].errors['required']) {
            <div>{{ lang?.Please_enter_earnings_amount ?? 'Please enter earnings amount' }}</div>
            }
            @if (w['earningsAmount'].errors['min']) {
            <div>Earnings must be at least $1.00</div>
            }
          </div>
          }
        </div>
      </div>
    </form>
    <div class="flex justify-end gap-2 border border-t-indigo-700 px-2">
      <button type="button"
        class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
        (click)="onClose()">
        {{ lang.Close }}
      </button>
      <button type="submit"
        class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-700 p-0.5 font-bold hover:border-green-500"
        (click)="finalbenificiarySubmit()">
        {{lang.Submit}}
      </button>
    </div>
    }


  </div>
</div>
}


@if(showdandjform){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white  rounded-xl shadow-lg">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[14px] font-semibold">Earnings</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>


    <form [formGroup]="dandjForm">
      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-2">
        <div class="sm:col-span-4">
          <label>{{ lang?.Do_you_smoke }}</label>
          <div class="flex items-center space-x-2">
            <span class="flex items-center space-x-2">
              <input type="radio" id="true" formControlName="smoker" value="true" class="form-radio text-blue-600" />
              <label for="true" class="labeling">{{lang.Yes}}</label>
            </span>

            <span class="flex items-center space-x-2">
              <input type="radio" id="false" formControlName="smoker" value="false" class="form-radio text-blue-600" />
              <label for="false" class="labeling">{{lang.No}}</label>
            </span>
          </div>
        </div>

        <div class="sm:col-span-4">
          <label for="" class="">{{ lang?.Earnings_frequency }}<span class="text-danger">*</span></label>
          <select class="form-control" id="gender" placeholder="Select" formControlName="earningsFrequency">
            <option value="" disabled>{{ lang.Select }}</option>
            <!-- @for (group of earningSummaryOptions; track group;let i = $index){
              <option value="">{{ lang.Select }}</option>
            } -->
            <option value="HOURLY">Hourly</option>
            <option value="WEEKLY">Weekly</option>
            <option value="FORTNIGHTLY">Bi-weekly</option>
            <option value="MONTHLY">Monthly</option>
            <option value="YEARLY" selected>Annually</option>
          </select>
          @if (dandj['earningsFrequency'].errors && w['earningsFrequency'].touched) {
          <div class="invalid text-red-500">
            @if (dandj['earningsFrequency'].errors['required']) {
            <div>Please enter earnings frequency</div>
            }
          </div>
          }
        </div>

        <div class="sm:col-span-4">
          <label for="" class="">{{ lang?.Earnings_amount}}<span class="text-danger">*</span></label>
          <input type="number" class="form-control checking-field" placeholder="$" formControlName="earningsAmount"
            (keypress)="decimalNumberOnly($event)" min="1">
          @if (dandj['earningsAmount'].errors && w['earningsAmount'].touched) {
          <div class="invalid text-red-500">
            @if (dandj['earningsAmount'].errors['required']) {
            <div>{{ lang?.Please_enter_earnings_amount ?? 'Please enter earnings amount' }}</div>
            }
            @if (dandj['earningsAmount'].errors['min']) {
            <div>Earnings must be at least $1.00</div>
            }
          </div>
          }
        </div>
      </div>
    </form>
    <div class="flex justify-end gap-2 border border-t-indigo-700 px-2">
      <button type="button"
        class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
        (click)="onClosedandj()">
        {{ lang.Close }}
      </button>
      <button type="submit"
        class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-700 p-0.5 font-bold hover:border-green-500"
        (click)="dandjformSubmit()">
        {{lang.Submit}}
      </button>
    </div>



  </div>
</div>
}

@if(addeditbenficiary){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white  rounded-xl shadow-lg w-full md:w-1/2">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[14px] font-semibold">{{BenficairyModalAddAndUpdateButton}} {{lang.Beneficiary_Information}}</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>

    <form [formGroup]="benficiaryForm" (ngSubmit)="addeditbenficarySubmit()">

      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-2">

        <!-- <div class="sm:col-span-3">
          <label for="" class="">{{lang.Beneficiary}}<span class="text-danger">*</span></label>



          <select class="form-control" placeholder="Select" formControlName="customerType">

            <option value="" selected disabled>{{lang.Select}}</option>
            <option value="MEMBER" selected>{{lang.MEMBER}}</option>
            <option value="SPOUSE" selected>{{lang.SPOUSE}}</option>

          </select>


          @if (b['customerType'].errors && b['customerType'].touched) {
          <div class="invalid text-red-500">
            @if (b['customerType'].errors['required']) {
            <div>{{lang.Please_select_beneficiary}}</div>
            }
          </div>
          }

        </div> -->

        <div class="sm:col-span-3">
          <label for="" class="">{{lang.First_Name}}<span class="text-danger">*</span></label>
          <input class="form-control checking-field" type="text" placeholder={{lang.First_Name}}
            formControlName="firstName" (keypress)="alphabatesOnly($event)">

          @if (b['firstName'].errors && b['firstName'].touched) {
          <div class="invalid text-red-500">
            @if (b['firstName'].errors['required']) {
            <div>{{ lang.Please_enter_first_name }}</div>
            } @if (b['firstName'].errors['minlength']) {
            <div>{{ lang.First_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }

        </div>
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Last_Name}}<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder={{lang.Last_Name}}
            formControlName="lastName" (keypress)="alphabatesOnly($event)">


          @if (b['lastName'].errors && b['lastName'].touched) {
          <div class="invalid text-red-500">
            @if (b['lastName'].errors['required']) {
            <div>{{ lang.Please_enter_last_name }}</div>
            } @if (b['lastName'].errors['minlength']) {
            <div>{{ lang.Last_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }



        </div>
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Relation}}<span class="text-danger">*</span></label>



          <select class="form-control" placeholder="Select" formControlName="relationship"
            (change)="isChildCheck($event,true)">

            <option value="" selected disabled>{{lang.Select}}</option>
            <option *ngFor="let name of beneficariesDetails?.relationship" [value]="name.value">
              {{ name.label }}
            </option>

          </select>


          @if (b['relationship'].errors && b['relationship'].touched) {
          <div class="invalid text-red-500">
            @if (b['relationship'].errors['required']) {
            <div>{{lang.Please_select_relationship}}</div>
            }
          </div>
          }



        </div>

        @if(benficiaryForm.get('relationship')?.value == 'OTHER'){
        <div class="sm:col-span-3">
          <label for="" class="">Relationship<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder='Enter Relationship'
            formControlName="relationshipSpecific" (keypress)="alphabatesOnly($event)">

          @if (b['relationshipSpecific'].touched) {
          <div class="invalid text-red-500">
            @if (benficiaryForm.get('relationshipSpecific')?.value == '') {
            <div>Relationship should be minimum of 1 Character and without numbers</div>
            }
          </div>
          }
        </div>
        }
        <!-- @if(benficiaryForm.get('relationship')?.value === 'CHILD'){
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Is_this_person_under_age_18}}<span class="text-danger">*</span></label>
          <div class="flex items-center space-x-2">
            <input type="radio" id="true" formControlName="isMinor" value="true" class="form-radio text-blue-600"
              (change)="isMinorCheck($event)" />
            <label for="true" class="labeling">{{lang.Yes}}</label>
          </div>

          <div class="flex items-center space-x-2">
            <input type="radio" id="false" formControlName="isMinor" value="false" class="form-radio text-blue-600"
              (change)="isMinorCheck($event)" />
            <label for="false" class="labeling">{{lang.No}}</label>
          </div>


          @if (b['isMinor'].errors && b['isMinor'].touched) {
          <div class="invalid text-red-500">
            @if (b['isMinor'].errors['required']) {
            <div>{{lang.Please_select_minor_status}}</div>
            }
          </div>
          }



        </div>
        } -->

        <!-- @if(benficiaryForm.get('relationship')?.value === 'CHILD'){ -->
        <div class="col-span-3">
          <label for="date_of_birth">{{ lang.Date_of_Birth }}<span style="color: red">*</span></label>

          <input type="text" (paste)="(false)" class="form-control" formControlName="dob" [minDate]="minDate"
            [maxDate]="childmaxDate" #dp [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
            placeholder="MM-DD-YYYY" bsDatepicker (blur)="checkDateOfBirthMinor($event)"
            (bsValueChange)="onDateChange($event)" (input)="checkDateOfBirthMinor($event)"
            (change)="checkDateOfBirth($event)" (keypress)="numbersOnly($event)" />

          <!-- <input id="datepicker-autohide"  formControlName="date_of_birth" datepicker datepicker-autohide type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  placeholder="MM-DD-YYYY"> -->

          @if (b['dob'].errors && b['dob'].touched) {
          <div class="invalid text-red-500">
            @if (b['dob'].errors['required']) {
            <div>{{ lang.Please_Choose_Date_of_Birth }}</div>
            }
          </div>
          }
        </div>

        <div class="col-span-3">
          <label for="" class="">{{lang.Gender}}<span class="text-danger">*</span></label>
          <select class="form-control" id="gender" placeholder="Select" formControlName="gender">
            <option value="" disabled>{{ lang.Select }}</option>
            <option value="Male">{{ lang.Male }}</option>
            <option value="Female">{{ lang.Female }}</option>
            <option value="Non-Binary">{{ lang.Non_Binary }}</option>
            <option value="Undisclosed">{{ lang.Undisclosed }}</option>
          </select>

          @if (b['gender'].errors && b['gender'].touched) {
          <div class="invalid text-red-500">
            @if (b['gender'].errors['required']) {
            <div>{{ lang.Please_Select_Gender }}</div>
            }
          </div>
          }
        </div>
        <!-- } -->
        <!-- <div class="sm:col-span-3">
          <label for="" class=""> {{lang.Contingent_First_Name}}<span class="text-danger">*</span></label>
          <input class="form-control checking-field" type="text" placeholder={{lang.First_Name}}
            formControlName="contingentFirstName" (keypress)="alphabatesOnly($event)">

          @if (b['contingentFirstName'].errors && b['contingentFirstName'].touched) {
          <div class="invalid text-red-500">
            @if (b['contingentFirstName'].errors['required']) {
            <div>{{ lang.Please_enter_first_name }}</div>
            } @if (b['contingentFirstName'].errors['minlength']) {
            <div>{{ lang.First_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }

        </div>
        <div class="sm:col-span-3">
          <label for="" class=""> {{lang.Contingent_Last_Name}}<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder={{lang.Last_Name}}
            formControlName="contingentLastName" (keypress)="alphabatesOnly($event)">

          @if (b['contingentLastName'].errors && b['contingentLastName'].touched) {
          <div class="invalid text-red-500">
            @if (b['contingentLastName'].errors['required']) {
            <div>{{ lang.Please_enter_last_name }}</div>
            } @if (b['contingentLastName'].errors['minlength']) {
            <div>{{ lang.Last_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }



        </div> -->
        @if((trusteeCheck===true && benficiaryForm.get('relationship')?.value === 'CHILD')){


        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Trustee_First_Name}}<span class="text-danger">*</span></label>
          <input class="form-control checking-field" type="text" placeholder={{lang.First_Name}}
            formControlName="trusteeFirstName" (keypress)="alphabatesOnly($event)">

          @if (b['trusteeFirstName'].errors && b['trusteeFirstName'].touched) {
          <div class="invalid text-red-500">
            @if (b['trusteeFirstName'].errors['required']) {
            <div>{{ lang.Please_enter_first_name }}</div>
            } @if (b['trusteeFirstName'].errors['minlength']) {
            <div>{{ lang.First_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }

        </div>
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Trustee_Last_Name}}<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder={{lang.Last_Name}}
            formControlName="trusteeLastName" (keypress)="alphabatesOnly($event)">

          @if (b['trusteeLastName'].errors && b['trusteeLastName'].touched) {
          <div class="invalid text-red-500">
            @if (b['trusteeLastName'].errors['required']) {
            <div>{{ lang.Please_enter_last_name }}</div>
            } @if (b['trusteeLastName'].errors['minlength']) {
            <div>{{ lang.Last_Name_minimum_of_1_Character_and_without_numbers }}</div>
            }
          </div>
          }



        </div>
        <div class="sm:col-span-3">
          <label for="" class="">Trustee Relation<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder="Relation"
            formControlName="trusteeRelation" (keypress)="alphabatesOnly($event)">

          @if (b['trusteeRelation'].errors && b['trusteeRelation'].touched) {
          <div class="invalid text-red-500">
            @if (b['trusteeRelation'].errors['required']) {
            <div>Please enter relation</div>
            }
          </div>
          }



        </div>
        }
        <div class="sm:col-span-3">
          <label for="" class="">{{lang.Percentage}}<span class="text-danger">*</span></label>
          <input type="text" class="form-control checking-field" placeholder="Percentage" formControlName="percentage"
            (keypress)="numbersOnly($event)" (blur)="checkpercentagevalue($event)"
            (input)="checkpercentagevalue($event)">


          @if (b['percentage'].errors && b['percentage'].touched) {
          <div class="invalid text-red-500">
            @if (b['percentage'].errors['required']) {
            <div>{{lang.Please_enter_percentage}}</div>
            }
          </div>
          }



        </div>







      </div>



      <div class="flex justify-end gap-2 border border-t-indigo-700 px-2">
        <button type="button"
          class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
          (click)="onCloseaddeditbenificary()">
          {{ lang.Close }}
        </button>
        <button type="submit"
          class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-700 p-0.5 font-bold hover:border-green-500"
          [disabled]="benficiaryForm.invalid">
          Save
        </button>
      </div>
    </form>




  </div>
</div>
}
@if(benficiaryCount){
<div class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur confirm-dialog ">
  <div class="relative px-4 min-h-screen md:flex md:items-center md:justify-center">
    <div class=" opacity-25 w-full h-full absolute z-10 inset-0"></div>
    <div
      class="bg-white rounded-[14px] border border-gray-400 md:max-w-max md:mx-auto p-4 fixed inset-x-0 bottom-0 z-50 mb-4 mx-4 md:relative shadow-lg">
      <div class="md:flex items-center">
        <div
          class="rounded-full border border-gray-300 flex items-center justify-center w-20 h-16 flex-shrink-0 mx-auto">
          <i class="bx bx-error text-3xl">
            &#9888;
          </i>
        </div>
        <div class="mt-4 md:mt-0 md:ml-6 text-center md:text-left">
          <p class="font-bold text-[16px]">{{lang.Error}}!</p>
          <p class="text-[16px] text-gray-700 mt-1">{{benficiaryCountMessage}}.
          </p>
        </div>
      </div>
      <div class="text-center md:text-right mt-4 md:flex md:justify-end gap-2">
        <button id="confirm-delete-btn"
          class="block w-full md:inline-block md:w-auto px-4 py-3 md:py-2 border border-red-500  rounded-full font-semibold text-[14px] md:ml-2 md:order-1"
          (click)="benficiaryconfirm()">
          {{lang.Ok??'Ok'}}
        </button>&nbsp;
        <!-- <button id="confirm-cancel-btn" class="block w-full md:inline-block md:w-auto px-4 py-3 md:py-2 border border-gray-400 rounded-full font-semibold text-[14px] mt-4 md:mt-0 md:order-2" (click)="benficiaryconfirm()">
                      Cancel
                      </button> -->
      </div>
    </div>
  </div>
</div>
}

@if(showSpouseSignature){
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">

  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex sm:min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

      <div
        class="relative transform overflow-hidden rounded-xl bg-white text-center mx-auto shadow-xl transition-all sm:my-8 sm:w-1/4 sm:max-w-7xl max-w-2xl">
        <div class="bg-white">
          <div class="">
            <div
              class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
              {{lang.Spouse_Signature}}
            </div>
            <div class="text-center">

              <div class="signature-container col-span-1 w-full" style="border:1px solid #ccc;border-radius: 4px;">



                <signature-pad [options]="signaturePadOptions" (touchmove)="onMouseMove($event)"
                  (mousemove)="onMouseMove($event)" (onEndEvent)="drawComplete()"
                  (onBeginEvent)="drawStart()"></signature-pad>
                @if(signaturecheckvalue1cc){
                <div style="
            left: 10px;
            color: red;
            text-decoration: underline;cursor:pointer">
                  <p (click)="clearSignature()">x {{lang.Clear}}</p>
                </div>
                }

              </div>
              @if(showIAFGerrorMessage){
              <span class="invalid text-red-500">{{lang.Please_Sign_the_Signature}}</span>
              }



            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">


          <button type="button"
            class="w-36 h-14 mb-1 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
            (click)="saveIAFGsignature()">{{lang.Confirm}}

          </button>

          <!-- <button type="button" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
              <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>


}

@if(iafginfo){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white  rounded-xl shadow-lg w-full md:w-1/2">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[14px] font-semibold">IAFG Info</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>

    <form [formGroup]="iafggenderForm">
      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2 p-2">
        <div class="sm:col-span-12">
          <label for="" class="">This Form have IAFG Insurance plans, do you wish to continue?<span
              class="text-danger">*</span></label>
          <div class="flex items-center space-x-2">
            <input type="radio" id="true" formControlName="memberinfo" value="true" class="form-radio text-blue-600"
              (change)="memberinfogenderCheck($event)" />
            <label for="true" class="labeling">Yes</label>
          </div>

          <div class="flex items-center space-x-2">
            <input type="radio" id="false" formControlName="memberinfo" value="false" class="form-radio text-blue-600"
              (change)="memberinfogenderCheck($event)" />
            <label for="false" class="labeling">No</label>
          </div>


          @if (IA['memberinfo'].errors && IA['memberinfo'].touched) {
          <div class="invalid text-red-500">
            @if (IA['memberinfo'].errors['required']) {
            <div>Please select IAFG GenderAtBirth status</div>
            }
          </div>
          }



        </div>

        @if(iafggenderForm.get('memberinfo')?.value === 'true'){
        <div class="sm:col-span-3">
          <label for="" class="">GenderAtBirth<span class="text-danger">*</span></label>

          <select class="form-control" placeholder="Select" formControlName="gender">

            <option value="" selected disabled>Select</option>

            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>


          @if (IA['gender'].errors && IA['gender'].touched) {
          <div class="invalid text-red-500">
            @if (IA['gender'].errors['required']) {
            <div>Please select type</div>
            }
          </div>
          }

        </div>
        }
      </div>
    </form>




    <div class="flex justify-end gap-2 border border-t-indigo-700 px-2">
      <button type="button"
        class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
        (click)="hideIAFGgenderfrom()">
        {{ lang.close }}
      </button>
      <button type="submit"
        class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-700 p-0.5 font-bold hover:border-green-500"
        [disabled]="iafggenderForm.invalid" (click)="hideIAFGgenderfrom()">
        {{lang.submit}}
      </button>
    </div>

  </div>
</div>
}


@if(ConfirmModel){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white  rounded-xl shadow-lg  md:w-1/2 overflow-scroll">
    <div
      class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[14px] font-semibold">{{lang.Info}}</h2>
      <!-- <button (click)="onClose()" class="text-gray-500 hover:text-gray-800 flex items-end justify-end">&times;</button> -->
    </div>
    <p class="p-8"><strong>{{lang.Important_Limitation_applies_for_the_first_24_months_of_this_coverage}}:</strong></p>
    <ul class="p-8" style="list-style: disc !important">
      @if(termLifeplancheck){
      <p class="font-bold">{{lang.Life_Insurance}}:</p>
      <li>
        {{lang.If_the_cause_of_death_is_non_accidental_no_benefit_will_be_paid_but_premiums_will_be_refunded_with_5_interest_compounded_annually_This_limitation_is_removed_if_the_insured_Employee_or_Spouse_subsequently_apply_and_are_approved_for_additional_life_coverage_requiring_evidence_of_insurability}}
      </li>
      <li>{{lang.Death_from_suicide_within_24_months_of_the_effective_date_of_an_insured_person_s_coverage_is_excluded}}
      </li>
      }
      @if(criticalplancheck){
      <p class="font-bold">{{lang.Critical_Illness_Insurance}}:</p>
      <li>
        {{lang.Pre_existing_Condition_Exclusion_applies_for_the_first_24_months_of_this_coverage_Any_symptom_condition_disorder_illness_pre_disease_or_disease_or_any_mental_nervous_or_psychiatric_condition_or_disorder_for_which_any_one_of_medical_advice_treatment_service_prescribed_medication_diagnosis_or_consultation_including_consultation_to_investigate_and_or_diagnose_where_diagnosis_has_not_yet_been_made_was_received_by_the_insured_or_would_have_been_received_by_a_prudent_individual_within_the_24_months_immediately_preceding_the_effective_date}}
      </li>
      <li>
        {{lang.This_pre_existing_condition_exclusion_is_removed_if_the_insured_Employee_subsequently_applies_and_is_approved_for_additional_critical_illness_coverage_requiring_evidence_of_insurability}}
      </li>
      }
    </ul>
    <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 border border-t-indigo-700">


      <button type="button"
        class="w-36 h-14 mb-1 rounded-full border-2 border-gray-700 bg-gray-200 p-0.5 font-bold hover:bg-white"
        (click)="closeConfirmModel()">{{lang.Confirm}}

      </button>
    </div>
  </div>
</div>


}




@if(showEOIQuestions){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center z-50 pt-[7px]">
  <div class="bg-white rounded-xl shadow-lg w-[90vw] flex flex-col overflow-hidden border border-gray-200"   [ngClass]="!showUnderwriting ? 'h-fit mt-[70px]' : 'max-h-[94vh]'">

    <!-- Header -->
    <div class="flex items-center justify-between px-5 h-[40px] bg-[#00297A] text-white flex-shrink-0">
      <span class="font-semibold text-white" style="font-size: 20px;">
        Eligibility and Underwriting Questions
      </span>
      <!-- <button (click)="onClose()" class="text-white text-2xl leading-none">&times;</button> -->
    </div>

    <!-- Eligibility — sticky, white card on light gray bg -->
    <div class="bg-[#F4F6F9] px-6 pt-5 pb-5 border-b border-gray-200 flex-shrink-0">
      <div class="bg-white border border-gray-200 rounded-xl px-6 py-5">
        <p class="font-bold text-gray-900 text-base mb-3" style="font-size: 18px;">Eligibility Question</p>
        <div *ngFor="let q of eoiQuestions.EOI.questions">
          <p class="text-gray-800 mb-4 leading-relaxed" style="font-size: 14px;" [innerHTML]="q.question"></p>
          <div class="flex gap-6">
            <label *ngFor="let opt of q.anwserValues"
                   class="flex items-center gap-2 cursor-pointer text-gray-700"
                   style="font-size: 14px;"
                   (click)="$event.stopPropagation()">
              <input type="radio"
                     [name]="q.code"
                     [value]="opt.value"
                     (click)="$event.stopPropagation()"
                     (change)="$event.stopPropagation(); recordFirstAnswer(q.code, opt.value, q.type)" />
              {{ opt.label }}
            </label>
          </div>
          <p *ngIf="!enableEOISubmit" class="text-red-500 text-sm mt-3" style="font-size: 15px; text-align: right; font-weight: bold;">{{ showDisableEOIText }}</p>
          <p *ngIf="showInEligibleText" class="text-red-500 text-sm mt-3" style="font-size: 15px; text-align: right; font-weight: bold;">You are currently not eligible for this coverage based on your employment status requirements.</p>
        </div>
      </div>
    </div>

    <!-- Underwriting — scrollable -->
    <div class="flex-1 overflow-hidden px-6 py-5 bg-[#F4F6F9]"
         style="background: #F4F6F9; border-radius: 10px; margin: 14px;"
         tabindex="-1"
         (click)="$event.stopPropagation()" *ngIf="showUnderwriting">

      <p class="font-bold text-gray-900 text-base mb-4" style="font-size: 18px;">Underwriting Questions</p>
      <div class="h-[100%] pb-[10px] overflow-y-auto">
           <ng-container *ngFor="let group of groupedUWQuestions; trackBy: trackByHeading">
        <div class="bg-white border border-gray-200 rounded-xl mb-4">

          <!-- Group heading bar -->
          <div class="px-5 py-3 border-b border-gray-200">
            <p class="font-bold text-gray-900" style="font-size: 16px;">{{ group.heading }}</p>
          </div>

          <!-- Questions -->
          <div *ngFor="let q of group.questions; let last = last; trackBy: trackByCode"
               class="px-5 py-4"
               [class.border-b]="!last"
               [class.border-gray-100]="!last">

            <div class="text-gray-800 mb-3 leading-relaxed eoi-question-html"
                 style="font-size: 14px;"
                 [innerHTML]="q.numbering + '. ' + q.question"></div>

            <div class="flex gap-6 mt-3">
              <label *ngFor="let opt of q.anwserValues"
                     class="flex items-center gap-2 cursor-pointer text-gray-700"
                     style="font-size: 14px;">
                <input type="radio"
                       [name]="q.code"
                       [value]="opt.value"
                       (change)="recordAnswer(q.code, opt.value, q.type)" />
                {{ opt.label }}
              </label>
            </div>

          </div>
        </div>
      </ng-container>
      </div>
   

    </div>

    <!-- Footer -->
    <div class="flex justify-between items-center border-t border-gray-200 px-5 py-3 bg-white flex-shrink-0">
      <span></span>
      <!-- <span class="text-sm text-gray-500">{{ answeredCount }} of {{ totalCount }} answered</span> -->
      <div class="flex gap-2">
        <button type="button" (click)="onCloseEOI(currentType)"
          class="w-32 h-11 rounded-full border-2 border-indigo-200 bg-indigo-200 text-indigo-800 text-sm font-medium hover:bg-white transition-colors" style="font-size: 12px;">
          Close
        </button>
        <button *ngIf="enableEOISubmit" type="button" (click)="onEOISubmit()"
          class="w-32 h-11 rounded-full border-2 border-indigo-200 text-indigo-700 text-sm font-medium hover:border-green-500 hover:text-green-700 transition-colors" style="font-size: 12px;">
          Submit
        </button>
      </div>
    </div>

  </div>
</div>
}




